import React, { useState, useEffect, useCallback, createContext, useContext } from 'react';
import BillingSettings from './BillingSettings';
import { invalidatePermissionCache } from '../hooks/usePermissions';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ── SVG ICON COMPONENTS ───────────────────────────────────────────────────────
const IC = ({ d, d2, c }) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={d}/>{d2 && <path d={d2}/>}</svg>;
const Icon = {
  users:      <IC c="#3b82f6" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" d2="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>,
  roles:      <IC c="#8b5cf6" d="M7 11V7a5 5 0 0 1 10 0v4" d2="M3 11h18v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V11z"/>,
  bell:       <IC c="#f59e0b" d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" d2="M13.73 21a2 2 0 0 1-3.46 0"/>,
  calendar:   <IC c="#06b6d4" d="M3 4h18v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4z" d2="M16 2v4M8 2v4M3 10h18"/>,
  sun:        <IC c="#f97316" d="M12 7a5 5 0 1 0 0 10A5 5 0 0 0 12 7z" d2="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>,
  refresh:    <IC c="#10b981" d="M23 4v6h-6" d2="M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>,
  settings:   <IC c="#6366f1" d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" d2="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>,
  groups:     <IC c="#3b82f6" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" d2="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>,
  globe:      <IC c="#0ea5e9" d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2z" d2="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>,
  tag:        <IC c="#ec4899" d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" d2="M7 7h.01"/>,
  file:       <IC c="#6366f1" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" d2="M14 2v6h6M16 13H8M16 17H8M10 9H8"/>,
  rupee:      <IC c="#10b981" d="M6 3h12M6 8h12M12 8l-6 13" d2="M6 3c0 7 6 10 6 10s6-3 6-10"/>,
  category:   <IC c="#f59e0b" d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"/>,
  creditCard: <IC c="#3b82f6" d="M1 4h22v16a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4z" d2="M1 10h22"/>,
  upload:     <IC c="#8b5cf6" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" d2="M17 8l-5-5-5 5M12 3v12"/>,
  clipboard:  <IC c="#0f1f45" d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" d2="M9 3h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/>,
  repeat:     <IC c="#10b981" d="M17 1l4 4-4 4" d2="M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3"/>,
  calCheck:   <IC c="#06b6d4" d="M3 4h18v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4z" d2="M16 2v4M8 2v4M3 10h18M9 16l2 2 4-4"/>,
  whatsapp:   <IC c="#25d366" d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>,
  sms:        <IC c="#3b82f6" d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>,
  mail:       <IC c="#f97316" d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" d2="M22 6l-10 7L2 6"/>,
  megaphone:  <IC c="#f59e0b" d="M11 5L6 9H2v6h4l5 4V5z" d2="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/>,
  clock:      <IC c="#8b5cf6" d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2z" d2="M12 6v6l4 2"/>,
  building:   <IC c="#0f1f45" d="M2 7h20v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7z" d2="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>,
  palette:    <IC c="#ec4899" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>,
  pen:        <IC c="#6366f1" d="M12 20h9" d2="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>,
  chevron:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>,
  lock:       <IC c="#f97316" d="M7 11V7a5 5 0 0 1 10 0v4" d2="M3 11h18v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V11z"/>,
  telegram:   <IC c="#229ED9" d="M22 2L11 13" d2="M22 2l-7 20-4-9-9-4 20-7z"/>,
  target:     <IC c="#6366f1" d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z" d2="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/>,
  hash:       <IC c="#f97316" d="M4 9h16M4 15h16" d2="M10 3L8 21M16 3l-2 18"/>,
};

// ── NAV STRUCTURE ─────────────────────────────────────────────────────────────
const NAV = [
  {
    id: 'user', label: 'User Management',
    icon: Icon.users,
    items: [
      { id: 'users',            label: 'Users',                icon: Icon.users },
      { id: 'user-roles',       label: 'User Roles',           icon: Icon.roles },
      { id: 'user-replacement', label: 'User Replacement',     icon: Icon.refresh },
      { id: 'workspace-access', label: 'Workspace Access',     icon: Icon.lock },
    ]
  },
  {
    id: 'client', label: 'Client Settings',
    icon: Icon.groups,
    items: [
      { id: 'client-settings',  label: 'Client Settings',      icon: Icon.settings },
      { id: 'client-types',     label: 'Client Types',         icon: Icon.tag },
      { id: 'client-groups',    label: 'Client Groups',        icon: Icon.groups },
      { id: 'portals',          label: 'Portals List',         icon: Icon.globe },
      { id: 'tags',             label: 'Tags',                 icon: Icon.tag },
      { id: 'document-types',   label: 'Document Types',       icon: Icon.file },
      { id: 'client-portal',    label: 'Client Portal',        icon: Icon.globe },
    ]
  },
  {
    id: 'crm', label: 'CRM Settings',
    icon: Icon.target,
    items: [
      { id: 'crm-lead-numbering', label: 'Lead Numbering', icon: Icon.hash },
      { id: 'lead-stages', label: 'Lead Stages', icon: Icon.repeat },
      { id: 'lead-sources', label: 'Lead Sources', icon: Icon.megaphone },
      { id: 'website-integration', label: 'Website Integration', icon: Icon.globe },
    ]
  },
  {
    id: 'billing', label: 'Billing & Finance',
    icon: Icon.rupee,
    items: [
      { id: 'billing-settings', label: 'Billing Settings',     icon: Icon.clipboard },
      { id: 'expense-categories',label: 'Expense Categories',  icon: Icon.category },
      { id: 'payment-modes',    label: 'Payment Modes',        icon: Icon.creditCard },
      { id: 'bank-accounts',    label: 'Bank Accounts',        icon: Icon.building },
      { id: 'tally-export',     label: 'Export to Tally',      icon: Icon.upload },
    ]
  },
  {
    id: 'services', label: 'Services & Tasks',
    icon: Icon.clipboard,
    items: [
      { id: 'service-settings', label: 'Service Settings',     icon: Icon.settings },
      { id: 'service-categories', label: 'Service Categories', icon: Icon.tag },
      { id: 'renewal-types',    label: 'Renewal Types',        icon: Icon.repeat },
      { id: 'compliance-calendar',label: 'Compliance Calendar',icon: Icon.calCheck },
    ]
  },
  {
    id: 'notifications', label: 'Notifications',
    icon: Icon.bell,
    items: [
      { id: 'whatsapp',         label: 'WhatsApp',             icon: Icon.whatsapp },
      { id: 'telegram',         label: 'Telegram',             icon: Icon.telegram },
      { id: 'sms',              label: 'SMS',                  icon: Icon.sms },
      { id: 'email-settings',   label: 'Email',                icon: Icon.mail },
      { id: 'general-notifications', label: 'General',        icon: Icon.megaphone },
      { id: 'task-notifications',label: 'Task Alerts',         icon: Icon.clock },
    ]
  },
  {
    id: 'hr', label: 'HR & Payroll',
    icon: Icon.groups,
    items: [
      { id: 'attendance',        label: 'Work Schedule',     icon: Icon.calendar },
      { id: 'hr-settings',       label: 'Leave Types',       icon: Icon.groups },
      { id: 'holidays',          label: 'Holidays List',     icon: Icon.sun },
    ]
  },
  {
    id: 'firm', label: 'Firm & Branding',
    icon: Icon.building,
    items: [
      { id: 'billing-settings', label: 'Firm & Billing', icon: Icon.building },
    ]
  },
];

// ── TOAST & CONFIRM SYSTEM — replaces native alert()/window.confirm() popups ──
// Exported so sibling settings files (e.g. BillingSettings.js) that render
// inside this module's <ToastProvider> can share the same popup instead of
// falling back to native alert()/confirm().
const ToastContext = createContext(null);

export function ToastProvider({ children, darkMode }) {
  const [toasts, setToasts] = useState([]);
  const [confirmState, setConfirmState] = useState(null);

  const showToast = useCallback((message, type = 'error') => {
    const id = Date.now() + Math.random();
    setToasts(t => [...t, { id, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
  }, []);

  const showConfirm = useCallback((message) => {
    return new Promise((resolve) => setConfirmState({ message, resolve }));
  }, []);

  const handleConfirmChoice = (result) => {
    confirmState?.resolve(result);
    setConfirmState(null);
  };

  return (
    <ToastContext.Provider value={{ showToast, showConfirm }}>
      {children}

      <div style={{ position:'fixed', top:20, right:20, zIndex:9999, display:'flex', flexDirection:'column', gap:10, maxWidth:360 }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            display:'flex', alignItems:'flex-start', gap:10, padding:'12px 16px', borderRadius:12,
            background: darkMode ? '#1e293b' : '#fff',
            border:`1px solid ${t.type==='success' ? '#86efac' : '#fecaca'}`,
            boxShadow:'0 8px 24px rgba(0,0,0,0.15)',
          }}>
            <div style={{
              width:22, height:22, borderRadius:'50%', flexShrink:0, marginTop:1,
              background: t.type==='success' ? '#dcfce7' : '#fee2e2',
              display:'flex', alignItems:'center', justifyContent:'center',
            }}>
              {t.type==='success'
                ? <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                : <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>}
            </div>
            <p style={{ fontSize:13, fontWeight:600, color: darkMode ? '#e2e8f0' : '#0f1f45', margin:0, flex:1, lineHeight:1.4 }}>{t.message}</p>
            <button onClick={() => setToasts(ts => ts.filter(x => x.id !== t.id))}
              style={{ background:'none', border:'none', cursor:'pointer', color:darkMode?'#64748b':'#94a3b8', padding:0, flexShrink:0 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        ))}
      </div>

      {confirmState && (
        <div style={{ position:'fixed', inset:0, background:'rgba(15,31,69,0.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10000 }}
          onClick={() => handleConfirmChoice(false)}>
          <div onClick={e => e.stopPropagation()} style={{
            background: darkMode ? '#1e293b' : '#fff', borderRadius:16, padding:'28px 30px', maxWidth:400,
            boxShadow:'0 24px 60px rgba(0,0,0,0.3)',
          }}>
            <div style={{ width:44, height:44, borderRadius:12, background:'#fef3c7', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:16 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            </div>
            <p style={{ fontSize:14, fontWeight:600, color: darkMode ? '#e2e8f0' : '#0f1f45', margin:'0 0 22px', lineHeight:1.5, whiteSpace:'pre-line' }}>{confirmState.message}</p>
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button onClick={() => handleConfirmChoice(false)}
                style={{ padding:'9px 18px', borderRadius:9, border:`1px solid ${darkMode?'#334155':'#e2e8f0'}`, background:'transparent', color: darkMode?'#94a3b8':'#4a5568', fontSize:13, fontWeight:600, cursor:'pointer' }}>
                Cancel
              </button>
              <button onClick={() => handleConfirmChoice(true)}
                style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'#dc2626', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) return { showToast: (msg) => window.alert(msg), showConfirm: (msg) => Promise.resolve(window.confirm(msg)) };
  return ctx;
}

// ── PORTALS SECTION ───────────────────────────────────────────────────────────
function PortalsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const { showConfirm } = useToast();
  const [portals, setPortals] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', url: '' });
  const [saving, setSaving] = useState(false);
  const fetchPortals = () => fetch(`${BASE}/api/portals`, { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()).then(d => setPortals(Array.isArray(d) ? d : [])).catch(() => {});
  useEffect(() => { fetchPortals(); }, []);
  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    await fetch(`${BASE}/api/portals`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(form) }).catch(() => {});
    setSaving(false); setShowForm(false); setForm({ name: '', url: '' }); fetchPortals();
  };
  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this portal?')) return;
    await fetch(`${BASE}/api/portals/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } }).catch(() => {});
    fetchPortals();
  };
  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Portals List</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Manage portals used in Client → Password tab</p>
        </div>
        <button onClick={() => setShowForm(s => !s)} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Add Portal
        </button>
      </div>
      {showForm && (
        <form onSubmit={handleSave} style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:20, marginBottom:20 }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5 }}>Portal Name *</label>
              <input required type="text" placeholder="e.g. GST Portal" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={is} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5 }}>Portal URL</label>
              <input type="text" placeholder="https://gst.gov.in" value={form.url} onChange={e => setForm(f => ({ ...f, url: e.target.value }))} style={is} />
            </div>
          </div>
          <div style={{ display:'flex', gap:12 }}>
            <button type="button" onClick={() => setShowForm(false)} style={{ padding:'8px 16px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
            <button type="submit" disabled={saving} style={{ padding:'8px 20px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', marginLeft:'auto', opacity:saving?0.6:1 }}>{saving ? 'Saving...' : 'Add Portal'}</button>
          </div>
        </form>
      )}
      {portals.length === 0 ? (
        <div style={{ padding:'64px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:16 }}>
          <div style={{ width:48, height:48, background:T.bg3, borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px' }}>{Icon.globe}</div>
          <p style={{ fontSize:13, fontWeight:500, color:T.text2, margin:0 }}>No portals added yet</p>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Add portals like GST, Income Tax, MCA</p>
        </div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          {portals.map(p => (
            <div key={p.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:12, padding:'12px 16px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ width:40, height:40, borderRadius:10, background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:'#2563eb', flexShrink:0 }}>{p.name.charAt(0)}</div>
                <div>
                  <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{p.name}</p>
                  {p.url && <a href={p.url} target="_blank" rel="noreferrer" style={{ fontSize:11, color:'#3b82f6', textDecoration:'none', display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:192 }}>{p.url}</a>}
                </div>
              </div>
              <button onClick={() => handleDelete(p.id)} style={{ width:32, height:32, borderRadius:8, border:'none', background:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                onMouseLeave={e=>e.currentTarget.style.background='none'}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── EXPENSE CATEGORIES SECTION ────────────────────────────────────────────────
function ExpenseCategoriesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const [cats, setCats] = useState([]);
  const [newCat, setNewCat] = useState('');
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [renaming, setRenaming] = useState(false);
  const fetchCats = () => fetch(`${BASE}/api/expense-categories`, { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()).then(d => setCats(Array.isArray(d) ? d : [])).catch(() => {});
  useEffect(() => { fetchCats(); }, []);
  const handleAdd = async (e) => {
    e.preventDefault(); if (!newCat.trim()) return; setSaving(true);
    await fetch(`${BASE}/api/expense-categories`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ name: newCat.trim() }) }).catch(() => {});
    setSaving(false); setNewCat(''); fetchCats();
  };
  const startEdit = (c) => { setEditingId(c.id); setEditName(c.name || c); };
  const cancelEdit = () => { setEditingId(null); setEditName(''); };
  const handleRename = async (id) => {
    if (!editName.trim() || renaming) return;
    setRenaming(true);
    try {
      await fetch(`${BASE}/api/expense-categories/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ name: editName.trim() }) });
      setEditingId(null); setEditName(''); fetchCats();
    } finally { setRenaming(false); }
  };
  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Expense Categories</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Categories used in client expense tracking</p>
      </div>
      <form onSubmit={handleAdd} style={{ display:'flex', gap:12, marginBottom:24 }}>
        <input type="text" placeholder="New category e.g. GST Charges, Courier, Stationery" value={newCat} onChange={e => setNewCat(e.target.value)} style={{ ...is, flex:1 }} />
        <button type="submit" disabled={saving} style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', flexShrink:0, opacity:saving?0.6:1 }}>
          {saving ? 'Adding...' : '+ Add'}
        </button>
      </form>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10 }}>
        {cats.length === 0 ? (
          <div style={{ gridColumn:'span 3', textAlign:'center', color:T.text3, fontSize:13, padding:'40px 0', border:`2px dashed ${T.border2}`, borderRadius:12 }}>No categories yet</div>
        ) : cats.map(c => (
          <div key={c.id||c} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:10, padding:'10px 14px', transition:'box-shadow 0.15s' }}
            onMouseEnter={e=>e.currentTarget.style.boxShadow=darkMode?'0 4px 16px rgba(0,0,0,0.3)':'0 4px 12px rgba(15,31,69,0.08)'}
            onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
            {editingId === c.id ? (
              <div style={{ display:'flex', alignItems:'center', gap:6, flex:1 }}>
                <input autoFocus type="text" value={editName} onChange={e => setEditName(e.target.value)}
                  onKeyDown={e => { if (e.key==='Enter') { e.preventDefault(); handleRename(c.id); } if (e.key==='Escape') cancelEdit(); }}
                  style={{ ...is, flex:1, padding:'6px 10px', fontSize:13 }} />
                <button onClick={() => handleRename(c.id)} disabled={renaming || !editName.trim()}
                  style={{ width:26, height:26, borderRadius:6, border:'none', background:'#16a34a', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', flexShrink:0, opacity: renaming||!editName.trim()?0.5:1 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                </button>
                <button onClick={cancelEdit}
                  style={{ width:26, height:26, borderRadius:6, border:'none', background:T.bg3, color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', flexShrink:0 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            ) : (
              <>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ width:8, height:8, borderRadius:'50%', background:'#3b82f6', flexShrink:0 }}/>
                  <span style={{ fontSize:13, fontWeight:500, color:T.text }}>{c.name||c}</span>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                  <button onClick={() => startEdit(c)}
                    style={{ width:24, height:24, borderRadius:6, border:'none', background:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                    onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(59,130,246,0.12)':'#eff6ff'}
                    onMouseLeave={e=>e.currentTarget.style.background='none'}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                  <button onClick={() => fetch(`${BASE}/api/expense-categories/${c.id}`, { method:'DELETE', headers:{ 'Authorization':`Bearer ${token}` } }).then(() => fetchCats())}
                    style={{ width:24, height:24, borderRadius:6, border:'none', background:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                    onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                    onMouseLeave={e=>e.currentTarget.style.background='none'}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── SERVICE CATEGORIES SECTION ──────────────────────────────────────────────────
function ServiceCategoriesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const { showToast } = useContext(ToastContext);
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({ name: '', color: '#3b82f6' });
  const [saving, setSaving] = useState(false);
  const COLORS = ['#6366f1','#3b82f6','#10b981','#f59e0b','#ef4444','#8b5cf6','#ec4899','#0ea5e9','#14b8a6','#f97316'];
  const fetchCats = () => fetch(`${BASE}/api/service-categories`, { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()).then(d => setCats(Array.isArray(d) ? d : [])).catch(() => {});
  useEffect(() => { fetchCats(); }, []);
  const handleAdd = async (e) => {
    e.preventDefault(); if (!form.name.trim()) return; setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/service-categories`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(form) });
      if (res.ok) { setForm({ name: '', color: '#3b82f6' }); fetchCats(); }
      else { const d = await res.json().catch(() => ({})); showToast(d.message || 'Error adding category', 'error'); }
    } catch { showToast('Server error', 'error'); }
    finally { setSaving(false); }
  };
  const handleDelete = async (id) => {
    const res = await fetch(`${BASE}/api/service-categories/${id}`, { method:'DELETE', headers:{ 'Authorization':`Bearer ${token}` } });
    if (res.ok) fetchCats();
    else { const d = await res.json().catch(() => ({})); showToast(d.message || 'Error deleting category', 'error'); }
  };
  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Service Categories</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Categories offered when creating a service in the Services module</p>
      </div>
      <form onSubmit={handleAdd} style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:20, marginBottom:24 }}>
        <div style={{ display:'flex', gap:16, alignItems:'flex-end' }}>
          <div style={{ flex:1 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Category Name *</label>
            <input type="text" placeholder="e.g. GST & Indirect Tax" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={is} />
          </div>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:8, textTransform:'uppercase', letterSpacing:'0.05em' }}>Colour</label>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
              {COLORS.map(c => (
                <button key={c} type="button" onClick={() => setForm(f => ({ ...f, color: c }))}
                  style={{ width:24, height:24, borderRadius:'50%', background:c, cursor:'pointer', border: form.color===c?`3px solid ${T.text2}`:'2px solid transparent', transform: form.color===c?'scale(1.2)':'scale(1)', transition:'all 0.15s' }} />
              ))}
            </div>
          </div>
          <button type="submit" disabled={saving} style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', flexShrink:0, opacity:saving?0.6:1 }}>
            {saving ? 'Adding...' : '+ Add Category'}
          </button>
        </div>
      </form>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10 }}>
        {cats.length === 0 ? (
          <div style={{ gridColumn:'span 3', textAlign:'center', color:T.text3, fontSize:13, padding:'40px 0', border:`2px dashed ${T.border2}`, borderRadius:12 }}>No categories yet — the Services module will use its built-in defaults until you add some here.</div>
        ) : cats.map(c => (
          <div key={c.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:10, padding:'10px 14px', transition:'box-shadow 0.15s' }}
            onMouseEnter={e=>e.currentTarget.style.boxShadow=darkMode?'0 4px 16px rgba(0,0,0,0.3)':'0 4px 12px rgba(15,31,69,0.08)'}
            onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:8, height:8, borderRadius:'50%', background:c.color||'#3b82f6', flexShrink:0 }}/>
              <span style={{ fontSize:13, fontWeight:500, color:T.text }}>{c.name}</span>
            </div>
            <button onClick={() => handleDelete(c.id)}
              style={{ width:24, height:24, borderRadius:6, border:'none', background:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
              onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
              onMouseLeave={e=>e.currentTarget.style.background='none'}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── CLIENT TYPES SECTION ─────────────────────────────────────────────────────
// The client-constitution list (Individual, LLP, Private Limited …). Firm-
// editable: add your own (e.g. "Section 8 Company"), rename, or remove any
// that aren't in use. The same list drives the New/Edit Client dropdown.
function ClientTypesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState(null);
  const [name, setName] = useState('');

  const fetchTypes = () => {
    setLoading(true);
    fetch(`${BASE}/api/clients/types/all`, { headers })
      .then(r => r.json()).then(d => setTypes(Array.isArray(d) ? d : []))
      .catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { fetchTypes(); }, []);

  const reset = () => { setName(''); setEditId(null); };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      const url    = editId ? `${BASE}/api/clients/types/${editId}` : `${BASE}/api/clients/types`;
      const method = editId ? 'PUT' : 'POST';
      const res = await fetch(url, { method, headers: jh, body: JSON.stringify({ name: name.trim() }) });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { showToast(d.message || 'Could not save'); return; }
      reset(); fetchTypes();
    } catch { showToast('Could not save'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (t) => {
    if (!await showConfirm(`Remove the "${t.name}" type?`)) return;
    const res = await fetch(`${BASE}/api/clients/types/${t.id}`, { method: 'DELETE', headers });
    if (!res.ok) { const d = await res.json().catch(() => ({})); showToast(d.message || 'Could not delete'); return; }
    fetchTypes();
  };

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Client Types</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>The legal constitution shown when creating a client. Add your own (e.g. Section 8 Company), rename, or remove ones you don't use.</p>
      </div>

      <form onSubmit={handleSave} style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:20, marginBottom:24 }}>
        <div style={{ display:'flex', gap:12, alignItems:'flex-end' }}>
          <div style={{ flex:1 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>{editId ? 'Rename Type' : 'Type Name *'}</label>
            <input type="text" placeholder="e.g. Section 8 Company" value={name} onChange={e => setName(e.target.value)} style={is} />
          </div>
          <button type="submit" disabled={saving} style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', flexShrink:0, opacity:saving?0.6:1 }}>
            {saving ? 'Saving...' : editId ? 'Save' : '+ Add Type'}
          </button>
          {editId && (
            <button type="button" onClick={reset} style={{ padding:'9px 14px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer', flexShrink:0 }}>Cancel</button>
          )}
        </div>
      </form>

      {loading ? (
        <div style={{ padding:'32px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading…</div>
      ) : types.length === 0 ? (
        <div style={{ padding:'32px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:12, color:T.text3, fontSize:13 }}>No types yet — add your first one above.</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
          {types.map(t => (
            <div key={t.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 14px', borderRadius:10, background:T.bg2, border:`1px solid ${T.cardBorder}` }}>
              <span style={{ fontSize:13, fontWeight:600, color:T.text, flex:1 }}>{t.name}</span>
              {t.client_count > 0 && (
                <span style={{ fontSize:11, fontWeight:600, color:T.text3 }}>{t.client_count} client{t.client_count === 1 ? '' : 's'}</span>
              )}
              <button onClick={() => { setEditId(t.id); setName(t.name); }} title="Rename"
                style={{ width:26, height:26, borderRadius:7, border:`1px solid ${T.border2}`, background:T.bg3, color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', padding:0 }}
                onMouseEnter={e=>{ e.currentTarget.style.color='#3b82f6'; e.currentTarget.style.borderColor='#3b82f6'; }}
                onMouseLeave={e=>{ e.currentTarget.style.color=T.text3; e.currentTarget.style.borderColor=T.border2; }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              </button>
              <button onClick={() => handleDelete(t)} title="Remove"
                disabled={t.client_count > 0}
                style={{ width:26, height:26, borderRadius:7, border:`1px solid ${T.border2}`, background:T.bg3, color: t.client_count > 0 ? T.border2 : T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor: t.client_count > 0 ? 'not-allowed' : 'pointer', padding:0 }}
                onMouseEnter={e=>{ if (!t.client_count) { e.currentTarget.style.color='#ef4444'; e.currentTarget.style.borderColor='#ef4444'; } }}
                onMouseLeave={e=>{ if (!t.client_count) { e.currentTarget.style.color=T.text3; e.currentTarget.style.borderColor=T.border2; } }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── TAGS SECTION ──────────────────────────────────────────────────────────────
function TagsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const [tags, setTags] = useState([]);
  const [form, setForm] = useState({ name: '', color: '#6366f1' });
  const [saving, setSaving] = useState(false);
  const COLORS = ['#6366f1','#3b82f6','#10b981','#f59e0b','#ef4444','#8b5cf6','#ec4899','#0ea5e9','#14b8a6','#f97316'];
  const fetchTags = () => fetch(`${BASE}/api/clients/tags/all`, { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()).then(d => setTags(Array.isArray(d) ? d : [])).catch(() => {});
  useEffect(() => { fetchTags(); }, []);
  const handleAdd = async (e) => {
    e.preventDefault(); if (!form.name.trim()) return; setSaving(true);
    await fetch(`${BASE}/api/clients/tags`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(form) }).catch(() => {});
    setSaving(false); setForm({ name: '', color: '#6366f1' }); fetchTags();
  };
  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Tags</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Use tags to categorize clients and tasks</p>
      </div>
      <form onSubmit={handleAdd} style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:20, marginBottom:24 }}>
        <div style={{ display:'flex', gap:16, alignItems:'flex-end' }}>
          <div style={{ flex:1 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Tag Name *</label>
            <input type="text" placeholder="e.g. VIP, Urgent, New Client" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={is} />
          </div>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:8, textTransform:'uppercase', letterSpacing:'0.05em' }}>Colour</label>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
              {COLORS.map(c => (
                <button key={c} type="button" onClick={() => setForm(f => ({ ...f, color: c }))}
                  style={{ width:24, height:24, borderRadius:'50%', background:c, cursor:'pointer', border: form.color===c?`3px solid ${T.text2}`:'2px solid transparent', transform: form.color===c?'scale(1.2)':'scale(1)', transition:'all 0.15s' }} />
              ))}
            </div>
          </div>
          <button type="submit" disabled={saving} style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', flexShrink:0, opacity:saving?0.6:1 }}>
            {saving ? 'Saving...' : '+ Add Tag'}
          </button>
        </div>
      </form>
      <div style={{ display:'flex', flexWrap:'wrap', gap:10 }}>
        {tags.length === 0 ? (
          <div style={{ width:'100%', padding:'32px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:12, color:T.text3, fontSize:13 }}>No tags yet</div>
        ) : tags.map(t => (
          <div key={t.id} style={{ display:'flex', alignItems:'center', gap:8, paddingLeft:14, paddingRight:10, paddingTop:8, paddingBottom:8, borderRadius:20, background:t.color||'#6366f1', color:'#fff', fontSize:13, fontWeight:500 }}>
            {t.name}
            <button onClick={() => fetch(`${BASE}/api/clients/tags/${t.id}`, { method:'DELETE', headers:{ 'Authorization':`Bearer ${token}` } }).then(() => fetchTags())}
              style={{ width:18, height:18, borderRadius:'50%', background:'rgba(0,0,0,0.2)', border:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', padding:0 }}
              onMouseEnter={e=>e.currentTarget.style.background='rgba(0,0,0,0.4)'}
              onMouseLeave={e=>e.currentTarget.style.background='rgba(0,0,0,0.2)'}>
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── USERS SECTION (embedded from Users module) ────────────────────────────────
function UsersSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const { showToast, showConfirm } = useToast();
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form, setForm] = useState({ full_name: '', email: '', phone: '', role: 'staff', password: '' });
  const [saving, setSaving] = useState(false);

  const ROLE_META = {
    admin:   { bg: '#fef2f2', color: '#dc2626', border: '#fecaca', dot: '#ef4444', label: 'Admin' },
    manager: { bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe', dot: '#3b82f6', label: 'Manager' },
    staff:   { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0', dot: '#22c55e', label: 'Staff' },
  };
  const AVATAR_GRADIENTS = [
    'linear-gradient(135deg,#0f1f45,#1a3a6b)',
    'linear-gradient(135deg,#3b82f6,#1d4ed8)',
    'linear-gradient(135deg,#8b5cf6,#6d28d9)',
    'linear-gradient(135deg,#10b981,#047857)',
    'linear-gradient(135deg,#f59e0b,#d97706)',
    'linear-gradient(135deg,#ef4444,#b91c1c)',
    'linear-gradient(135deg,#ec4899,#be185d)',
  ];

  const ic = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'10px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };

  const fetchUsers = () => fetch(`${BASE}/api/users`, { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()).then(d => setUsers(Array.isArray(d) ? d : [])).catch(() => {});
  useEffect(() => { fetchUsers(); }, []);

  const openAdd = () => { setEditUser(null); setForm({ full_name: '', email: '', phone: '', role: 'staff', password: '' }); setShowForm(true); };
  const openEdit = (u) => { setEditUser(u); setForm({ full_name: u.full_name, email: u.email, phone: u.phone || '', role: u.role, password: '' }); setShowForm(true); };

  const handleAvatarUpload = async (userId, file) => {
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) { showToast('Image must be under 2MB'); return; }
    const fd = new FormData();
    fd.append('avatar', file);
    try {
      const res = await fetch(`${BASE}/api/users/${userId}/avatar`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: fd,
      });
      if (res.ok) {
        const updated = await res.json();
        setUsers(prev => prev.map(u => u.id === userId ? { ...u, avatar_url: updated.avatar_url } : u));
        // Keep the topbar avatar (reads from localStorage) in sync when the uploader is editing their own photo
        try {
          const me = JSON.parse(localStorage.getItem('user') || 'null');
          if (me && me.id === userId) {
            localStorage.setItem('user', JSON.stringify({ ...me, avatar_url: updated.avatar_url }));
          }
        } catch (e) {}
      } else {
        showToast('Avatar upload failed');
      }
    } catch(e) {
      showToast('Avatar upload error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const url = editUser ? `${BASE}/api/users/${editUser.id}` : `${BASE}/api/users`;
      const method = editUser ? 'PUT' : 'POST';
      const body = { ...form };
      if (editUser && !body.password) delete body.password;
      await fetch(url, { method, headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(body) });
      setShowForm(false); fetchUsers();
    } catch(e) { showToast('Error saving user'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this user?')) return;
    await fetch(`${BASE}/api/users/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
    fetchUsers();
  };

  const roleCounts = { admin: 0, manager: 0, staff: 0 };
  users.forEach(u => { if (roleCounts[u.role] !== undefined) roleCounts[u.role]++; });

  return (
    <div>
      {/* ── Header ── */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div>
          <h3 style={{ fontSize:16, fontWeight:700, color:T.text, margin:0 }}>Team Members</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:3 }}>{users.length} user{users.length !== 1 ? 's' : ''} · {roleCounts.admin} admin · {roleCounts.manager} manager · {roleCounts.staff} staff</p>
        </div>
        <button onClick={openAdd} style={{
          display:'flex', alignItems:'center', gap:7, padding:'9px 18px',
          background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff',
          border:'none', borderRadius:10, fontSize:13, fontWeight:600, cursor:'pointer',
          boxShadow:'0 4px 12px rgba(15,31,69,0.25)',
        }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add User
        </button>
      </div>

      {/* ── Stats row ── */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:24 }}>
        {Object.entries(ROLE_META).map(([role, meta]) => (
          <div key={role} style={{
            background: T.bg2,
            border: `1px solid ${T.cardBorder}`,
            borderRadius:12, padding:'14px 18px', display:'flex', alignItems:'center', gap:12,
            boxShadow: `0 4px 12px ${meta.glow}`,
          }}>
            <div style={{ width:36, height:36, borderRadius:10, background: meta.iconBg, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={meta.color} strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div>
              <p style={{ fontSize:20, fontWeight:800, color:meta.color, margin:0, lineHeight:1 }}>{roleCounts[role]}</p>
              <p style={{ fontSize:11, color:T.text3, margin:'3px 0 0', textTransform:'capitalize', fontWeight:500 }}>{meta.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ── Slide-down Form ── */}
      {showForm && (
        <div style={{
          background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:14,
          padding:24, marginBottom:24,
          boxShadow: darkMode?'0 4px 20px rgba(0,0,0,0.3)':'0 4px 20px rgba(15,31,69,0.07)',
        }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:32, height:32, borderRadius:8, background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </div>
              <p style={{ fontSize:14, fontWeight:700, color:T.text, margin:0 }}>{editUser ? 'Edit User' : 'Add New User'}</p>
            </div>
            <button type="button" onClick={() => setShowForm(false)} style={{ background:'none', border:'none', cursor:'pointer', color:'#94a3b8', padding:4 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:'#64748b', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Full Name *</label>
                <input required type="text" placeholder="e.g. Rahul Sharma" value={form.full_name} onChange={e => setForm(f => ({ ...f, full_name: e.target.value }))} style={ic} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Email Address *</label>
                <input required type="email" placeholder="rahul@firm.com" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={ic} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Mobile Number</label>
                <input type="tel" placeholder="9876543210" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value.replace(/[^0-9]/g, '').slice(0,10) }))} style={ic} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Role</label>
                <select value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))} style={ic}>
                  <option value="admin">Admin</option>
                  <option value="manager">Manager</option>
                  <option value="staff">Staff</option>
                </select>
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>{editUser ? 'New Password (blank = no change)' : 'Password *'}</label>
                <input required={!editUser} type="password" placeholder="••••••••" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} style={ic} />
              </div>
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:10 }}>
              <button type="button" onClick={() => setShowForm(false)} style={{ padding:'9px 18px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, fontWeight:500, cursor:'pointer' }}>Cancel</button>
              <button type="submit" disabled={saving} style={{ padding:'9px 22px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', display:'flex', alignItems:'center', gap:7, opacity: saving ? 0.7 : 1 }}>
                {saving && <span style={{ width:13, height:13, border:'2px solid rgba(255,255,255,0.4)', borderTopColor:'#fff', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }}/>}
                {saving ? 'Saving...' : editUser ? 'Save Changes' : 'Create User'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* ── User Cards ── */}
      {users.length === 0 ? (
        <div style={{ padding:'60px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:16 }}>
          <div style={{ width:52, height:52, borderRadius:14, background:T.bg3, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px' }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
          </div>
          <p style={{ color:T.text2, fontWeight:600, fontSize:14 }}>No team members yet</p>
          <p style={{ color:T.text3, fontSize:12, marginTop:4 }}>Click Add User to get started</p>
        </div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:14 }}>
          {users.map((u, i) => {
            const meta = ROLE_META[u.role] || ROLE_META.staff;
            return (
              <div key={u.id} style={{
                background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14,
                padding:20, transition:'all 0.2s',
                boxShadow: darkMode?'0 1px 4px rgba(0,0,0,0.2)':'0 1px 4px rgba(15,31,69,0.05)',
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow=darkMode?'0 6px 20px rgba(0,0,0,0.4)':'0 6px 20px rgba(15,31,69,0.10)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow=darkMode?'0 1px 4px rgba(0,0,0,0.2)':'0 1px 4px rgba(15,31,69,0.05)'}>
                {/* Top row */}
                <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:14 }}>
                  <label title="Upload profile picture" style={{ cursor:'pointer', flexShrink:0 }}>
                    <input type="file" accept="image/*" style={{ display:'none' }}
                      onChange={e => {
                        const file = e.target.files[0];
                        if (!file) return;
                        handleAvatarUpload(u.id, file);
                      }}
                    />
                    <div style={{
                      width:44, height:44, borderRadius:'50%', flexShrink:0, position:'relative',
                      background: (u.avatar_url || u._localAvatar) ? 'transparent' : AVATAR_GRADIENTS[i % AVATAR_GRADIENTS.length],
                      display:'flex', alignItems:'center', justifyContent:'center',
                      overflow:'hidden', boxShadow:'0 2px 8px rgba(15,31,69,0.15)',
                    }}>
                      {(u.avatar_url || u._localAvatar)
                        ? <img src={u.avatar_url ? `${BASE}${u.avatar_url}` : u._localAvatar} alt={u.full_name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                        : <span style={{ color:'#fff', fontSize:17, fontWeight:800 }}>{u.full_name?.charAt(0)?.toUpperCase()}</span>
                      }
                      {/* Hover overlay */}
                      <div className="avatar-upload-overlay" style={{
                        position:'absolute', inset:0, background:'rgba(15,31,69,0.55)',
                        display:'flex', alignItems:'center', justifyContent:'center',
                        opacity:0, transition:'opacity 0.2s', borderRadius:'50%',
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                      </div>
                    </div>
                    <style>{`.avatar-upload-overlay { opacity: 0; } label:hover .avatar-upload-overlay { opacity: 1 !important; }`}</style>
                  </label>
                  <span style={{
                    fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20,
                    background: meta.bg, color: meta.color, border:`1px solid ${meta.border}`,
                    display:'flex', alignItems:'center', gap:5,
                  }}>
                    <span style={{ width:5, height:5, borderRadius:'50%', background:meta.dot, display:'inline-block' }}/>
                    {u.role}
                  </span>
                </div>
                {/* Info */}
                <p style={{ fontSize:14, fontWeight:700, color:T.text, margin:0, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{u.full_name}</p>
                <p style={{ fontSize:12, color:T.text3, margin:'4px 0 0', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{u.email}</p>
                {/* Divider */}
                <div style={{ height:1, background:T.border, margin:'14px 0' }}/>
                {/* Actions */}
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={() => openEdit(u)} style={{
                    flex:1, padding:'7px 0', borderRadius:8, border:`1px solid ${T.border2}`,
                    background:T.bg2, color:T.text2, fontSize:12, fontWeight:600, cursor:'pointer',
                    display:'flex', alignItems:'center', justifyContent:'center', gap:5,
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background=T.bg3; e.currentTarget.style.borderColor=T.border; }}
                  onMouseLeave={e => { e.currentTarget.style.background=T.bg2; e.currentTarget.style.borderColor=T.border2; }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    Edit
                  </button>
                  <button onClick={() => handleDelete(u.id)} style={{
                    padding:'7px 12px', borderRadius:8, border:`1px solid ${darkMode?'rgba(239,68,68,0.25)':'#fee2e2'}`,
                    background: darkMode?'rgba(239,68,68,0.08)':'#fff', color:'#ef4444', fontSize:12, fontWeight:600, cursor:'pointer',
                    display:'flex', alignItems:'center', justifyContent:'center', gap:5,
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.15)':'#fef2f2'; }}
                  onMouseLeave={e => { e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.08)':'#fff'; }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── CLIENT GROUPS SECTION (embedded from ClientGroups module) ─────────────────
function ClientGroupsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const { showToast, showConfirm } = useToast();
  const [groups, setGroups] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editGroup, setEditGroup] = useState(null);
  const [form, setForm] = useState({ name: '', description: '' });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState('');

  const fetchGroups = async () => {
    try {
      const r = await fetch(`${BASE}/api/clients/groups`, { headers: { 'Authorization': `Bearer ${token}` } });
      const d = await r.json();
      setGroups(Array.isArray(d) ? d : []);
    } catch { setGroups([]); }
  };
  useEffect(() => { fetchGroups(); }, []);

  const openAdd = () => { setEditGroup(null); setForm({ name: '', description: '' }); setFormError(''); setShowForm(true); };
  const openEdit = (g) => { setEditGroup(g); setForm({ name: g.name, description: g.description || '' }); setFormError(''); setShowForm(true); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { setFormError('Group name is required'); return; }
    setSaving(true); setFormError('');
    try {
      const url = editGroup ? `${BASE}/api/clients/groups/${editGroup.id}` : `${BASE}/api/clients/groups`;
      const res = await fetch(url, { method: editGroup ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(form) });
      if (!res.ok) { const d = await res.json(); setFormError(d.message || 'Save failed'); setSaving(false); return; }
      setSaving(false); setShowForm(false); fetchGroups();
    } catch { setFormError('Network error — please try again'); setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this group? Clients in this group will be ungrouped.')) return;
    try {
      const res = await fetch(`${BASE}/api/clients/groups/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      if (!res.ok) { showToast('Could not delete this group.'); return; }
      fetchGroups();
    } catch { showToast('Network error — could not delete.'); }
  };

  const GROUP_COLORS = ['#0f1f45','#3b82f6','#8b5cf6','#10b981','#f59e0b','#ef4444','#ec4899','#0ea5e9'];

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Client Groups</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>{groups.length} groups created</p>
        </div>
        <button onClick={openAdd} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Group
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:20, marginBottom:20 }}>
          <p style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:16 }}>{editGroup ? 'Edit Group' : 'New Group'}</p>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Group Name *</label>
              <input required type="text" placeholder="e.g. Axis Bank Group, Family Group" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={is} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Description</label>
              <input type="text" placeholder="Optional description" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} style={is} />
            </div>
          </div>
          {formError && (
            <div style={{ fontSize:12, color:'#ef4444', background:darkMode?'rgba(239,68,68,0.1)':'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:'8px 12px', marginBottom:12 }}>
              {formError}
            </div>
          )}
          <div style={{ display:'flex', gap:12 }}>
            <button type="button" onClick={() => setShowForm(false)} style={{ padding:'8px 16px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
            <button type="submit" disabled={saving} style={{ padding:'8px 20px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', marginLeft:'auto', opacity:saving?0.6:1 }}>
              {saving ? 'Saving...' : editGroup ? 'Save Changes' : 'Create Group'}
            </button>
          </div>
        </form>
      )}

      {groups.length === 0 && !showForm ? (
        <div style={{ padding:'64px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:16 }}>
          <div style={{ width:48, height:48, background:T.bg3, borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px' }}>{Icon.groups}</div>
          <p style={{ fontSize:13, fontWeight:500, color:T.text2, margin:0 }}>No client groups yet</p>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Group clients by firm, family or relationship</p>
        </div>
      ) : (
        <div style={{ border:`1px solid ${T.border}`, borderRadius:12, overflow:'hidden' }}>
          {/* List header */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 100px 160px', padding:'8px 16px', background:T.bg3, borderBottom:`1px solid ${T.border}` }}>
            <span style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em' }}>Group Name</span>
            <span style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em' }}>Clients</span>
            <span style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em' }}>Actions</span>
          </div>
          {groups.map((g, i) => (
            <div key={g.id}
              style={{ display:'grid', gridTemplateColumns:'1fr 100px 160px', alignItems:'center', padding:'12px 16px', borderBottom: i < groups.length-1 ? `1px solid ${T.border}` : 'none', background:T.bg2, transition:'background 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background = T.bg3}
              onMouseLeave={e => e.currentTarget.style.background = T.bg2}>
              {/* Name + description */}
              <div>
                <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{g.name}</p>
                {g.description && <p style={{ fontSize:11, color:T.text3, margin:'2px 0 0' }}>{g.description}</p>}
              </div>
              {/* Client count */}
              <span style={{ fontSize:13, color:T.text2 }}>
                <strong style={{ color: g.client_count > 0 ? '#3b82f6' : T.text3 }}>{g.client_count || 0}</strong>
                <span style={{ color:T.text3, marginLeft:4 }}>clients</span>
              </span>
              {/* Actions */}
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={() => openEdit(g)}
                  style={{ padding:'5px 14px', borderRadius:7, border:`1px solid ${T.border2}`, background:'transparent', color:T.text2, fontSize:12, fontWeight:500, cursor:'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.background = T.bg3}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  Edit
                </button>
                <button onClick={() => handleDelete(g.id)}
                  style={{ padding:'5px 14px', borderRadius:7, border:`1px solid ${darkMode?'rgba(239,68,68,0.25)':'#fecaca'}`, background:darkMode?'rgba(239,68,68,0.08)':'#fef2f2', color:'#ef4444', fontSize:12, fontWeight:500, cursor:'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.background = darkMode?'rgba(239,68,68,0.15)':'#fee2e2'}
                  onMouseLeave={e => e.currentTarget.style.background = darkMode?'rgba(239,68,68,0.08)':'#fef2f2'}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── COMING SOON ───────────────────────────────────────────────────────────────
function ComingSoon({ label, darkMode = false, T: theme }) {
  const T = theme || { bg3:'#f8faff', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8' };
  return (
    <div style={{ padding:'80px 0', textAlign:'center' }}>
      <div style={{ width:64, height:64, background:T.bg3, border:`2px dashed ${T.border2}`, borderRadius:16, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      </div>
      <h3 style={{ fontSize:15, fontWeight:600, color:T.text, margin:0 }}>{label}</h3>
      <p style={{ fontSize:13, color:T.text3, marginTop:6 }}>This section is coming soon</p>
      <span style={{ display:'inline-block', marginTop:12, padding:'4px 14px', borderRadius:20, fontSize:12, fontWeight:500, color:'#3b82f6', background:darkMode?'rgba(59,130,246,0.12)':'#eff6ff', border:`1px solid ${darkMode?'rgba(59,130,246,0.25)':'#bfdbfe'}` }}>In Development</span>
    </div>
  );
}

// ── CONTENT ROUTER ────────────────────────────────────────────────────────────
// ── NOTIFICATION CHANNEL SECTION ─────────────────────────────────────────────
// ─── General Notifications Section ───────────────────────────────────────────
const NOTIF_EVENTS = [
  { key:'client_created',   label:'Client Created',     desc:'When a new client is added' },
  { key:'invoice_created',  label:'Invoice Created',    desc:'When an invoice is raised' },
  { key:'payment_received', label:'Payment Received',   desc:'When a receipt is recorded' },
  { key:'task_assigned',    label:'Task Assigned',      desc:'When a task is assigned to staff' },
  { key:'task_completed',   label:'Task Completed',     desc:'When a task is marked complete' },
  { key:'renewal_due',      label:'Renewal Reminder',   desc:'Before a renewal expires' },
  { key:'lead_created',     label:'New Lead',           desc:'When a new lead is added' },
];

const VARIABLES = {
  client_created:   ['{CLIENT_NAME}','{FILE_NUMBER}','{ADDED_BY}','{DATE}','{YOUR_COMPANY_NAME}'],
  invoice_created:  ['{CLIENT_NAME}','{INVOICE_NUMBER}','{AMOUNT}','{DUE_DATE}','{YOUR_COMPANY_NAME}'],
  payment_received: ['{CLIENT_NAME}','{AMOUNT}','{RECEIPT_NUMBER}','{PAYMENT_MODE}','{DATE}','{YOUR_COMPANY_NAME}'],
  task_assigned:    ['{CLIENT_NAME}','{TASK_NAME}','{ASSIGNED_BY}','{DUE_DATE}','{YOUR_COMPANY_NAME}'],
  task_completed:   ['{CLIENT_NAME}','{TASK_NAME}','{COMPLETED_BY}','{DATE}','{YOUR_COMPANY_NAME}'],
  renewal_due:      ['{CLIENT_NAME}','{RENEWAL_NAME}','{DUE_DATE}','{DAYS_REMAINING}','{YOUR_COMPANY_NAME}'],
  lead_created:     ['{LEAD_NAME}','{MOBILE}','{SERVICE}','{ADDED_BY}','{DATE}','{YOUR_COMPANY_NAME}'],
};

function SimpleEmailEditor({ value, onChange, vars, darkMode, T }) {
  const editorRef = React.useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  // Sync value to contentEditable when value changes externally
  React.useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, []);

  const exec = (cmd, val = null) => {
    editorRef.current.focus();
    document.execCommand(cmd, false, val);
    onChange(editorRef.current.innerHTML);
  };

  const insertVarAtCursor = (varName) => {
    editorRef.current.focus();
    const sel = window.getSelection();
    if (sel.rangeCount) {
      const range = sel.getRangeAt(0);
      range.deleteContents();
      const span = document.createElement('span');
      span.style.cssText = `background:${darkMode?'rgba(59,130,246,0.2)':'#dbeafe'};color:#2563eb;font-weight:600;border-radius:4px;padding:1px 5px;font-size:12px;`;
      span.contentEditable = 'false';
      span.textContent = varName;
      range.insertNode(span);
      range.setStartAfter(span);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      // Add space after
      document.execCommand('insertText', false, ' ');
    }
    onChange(editorRef.current.innerHTML);
  };

  const toolBtn = (cmd, icon, title) => (
    <button type="button" onMouseDown={e => { e.preventDefault(); exec(cmd); }} title={title}
      style={{ width:28, height:28, borderRadius:6, border:'none', background:'none', cursor:'pointer', color:T.text2, display:'flex', alignItems:'center', justifyContent:'center', fontSize:13 }}
      onMouseEnter={e=>e.currentTarget.style.background=T.bg3}
      onMouseLeave={e=>e.currentTarget.style.background='none'}>
      {icon}
    </button>
  );

  return (
    <div style={{ border:`1.5px solid ${isFocused?'#3b82f6':T.inputBorder}`, borderRadius:10, overflow:'hidden', background:T.inputBg, transition:'border-color 0.15s' }}>
      {/* Toolbar */}
      <div style={{ display:'flex', alignItems:'center', gap:2, padding:'6px 10px', borderBottom:`1px solid ${T.border}`, background:T.bg3, flexWrap:'wrap' }}>
        {toolBtn('bold',      <strong>B</strong>, 'Bold')}
        {toolBtn('italic',    <em>I</em>,         'Italic')}
        {toolBtn('underline', <u>U</u>,           'Underline')}
        <div style={{ width:1, height:20, background:T.border, margin:'0 4px' }}/>
        {toolBtn('insertUnorderedList', <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="9" y1="6" x2="20" y2="6"/><line x1="9" y1="12" x2="20" y2="12"/><line x1="9" y1="18" x2="20" y2="18"/><circle cx="4" cy="6" r="1" fill="currentColor"/><circle cx="4" cy="12" r="1" fill="currentColor"/><circle cx="4" cy="18" r="1" fill="currentColor"/></svg>, 'Bullet List')}
        {toolBtn('insertOrderedList', <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="10" y1="6" x2="21" y2="6"/><line x1="10" y1="12" x2="21" y2="12"/><line x1="10" y1="18" x2="21" y2="18"/><path d="M4 6h1v4"/><path d="M4 10H6"/><path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"/></svg>, 'Numbered List')}
        <div style={{ width:1, height:20, background:T.border, margin:'0 4px' }}/>
        {toolBtn('removeFormat', <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 3H7l-5 9 5 9h15a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"/><line x1="27" y1="8" x2="12" y2="14"/></svg>, 'Clear Format')}
        <div style={{ flex:1 }}/>
        <span style={{ fontSize:11, color:T.text3 }}>Variables:</span>
        {vars.map(v => (
          <button key={v} type="button" onMouseDown={e => { e.preventDefault(); insertVarAtCursor(v); }}
            style={{ fontSize:10, padding:'2px 7px', borderRadius:5, border:`1px solid ${darkMode?'rgba(59,130,246,0.3)':'#bfdbfe'}`, background:darkMode?'rgba(59,130,246,0.1)':'#eff6ff', color:'#3b82f6', cursor:'pointer', fontWeight:600, whiteSpace:'nowrap' }}>
            {v}
          </button>
        ))}
      </div>

      {/* Editor */}
      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        onFocus={() => setIsFocused(true)}
        onBlur={() => { setIsFocused(false); onChange(editorRef.current.innerHTML); }}
        onInput={() => onChange(editorRef.current.innerHTML)}
        style={{
          minHeight:160, padding:'14px 16px', outline:'none',
          fontSize:13, lineHeight:1.8, color:T.text,
          background:T.inputBg,
        }}
        data-placeholder="Write your email here. Use variable buttons above to insert dynamic values like client name, invoice number etc."
      />

      {/* Placeholder via CSS */}
      <style>{`
        [data-placeholder]:empty:before {
          content: attr(data-placeholder);
          color: #94a3b8;
          pointer-events: none;
        }
      `}</style>

      {/* Preview toggle */}
      <div style={{ padding:'8px 14px', borderTop:`1px solid ${T.border}`, background:T.bg3, display:'flex', justifyContent:'flex-end' }}>
        <span style={{ fontSize:11, color:T.text3 }}>
          Tip: Variables like <strong style={{ color:'#3b82f6' }}>{'{CLIENT_NAME}'}</strong> will be replaced with actual values when sent
        </span>
      </div>
    </div>
  );
}

function GeneralNotificationsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const h = { Authorization: `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...h };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };

  const [activeEvent, setActiveEvent] = useState(null);
  const [templates, setTemplates] = useState({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const fetchAll = async () => {
    try {
      const res = await fetch(`${BASE}/api/notification-settings/events/all`, { headers: h });
      const data = await res.json();
      const map = {};
      if (Array.isArray(data)) data.forEach(t => { map[t.event_key] = t; });
      setTemplates(map);
    } catch (_) {}
  };

  useEffect(() => { fetchAll(); }, [token]);

  const getTemplate = (key) => templates[key] || {
    event_key: key,
    email_enabled: false, email_subject: '', email_body: '',
    sms_enabled: false, sms_template: '',
    whatsapp_enabled: false, whatsapp_template: '',
    email_recipients: 'admin', email_custom_to: '',
  };

  const updateTemplate = (key, field, value) => {
    setTemplates(prev => ({
      ...prev,
      [key]: { ...getTemplate(key), [field]: value }
    }));
  };

  const handleSave = async (key) => {
    setSaving(true);
    try {
      // Use templates[key] directly — not getTemplate() which falls back to empty defaults
      const payload = templates[key];
      if (!payload) { setSaving(false); return; }
      const res = await fetch(`${BASE}/api/notification-settings/events/${key}`, {
        method: 'PUT', headers: jh,
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('Save failed');
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) {
      console.error('[handleSave]', e.message);
    }
    setSaving(false);
  };

  const insertVar = (key, channel, varName) => {
    const field = channel === 'email_body' ? 'email_body' : channel === 'sms' ? 'sms_template' : 'whatsapp_template';
    const tpl = getTemplate(key);
    const current = tpl[field] || '';
    updateTemplate(key, field, current + varName);
  };

  const statusBadge = (key) => {
    const t = getTemplate(key);
    const active = t.email_enabled || t.sms_enabled || t.whatsapp_enabled;
    return (
      <span style={{ fontSize:11, fontWeight:600, padding:'2px 8px', borderRadius:20,
        color: active ? '#16a34a' : T.text3,
        background: active ? (darkMode?'rgba(22,163,74,0.12)':'#f0fdf4') : T.bg3 }}>
        {active ? 'Active' : 'Inactive'}
      </span>
    );
  };

  if (activeEvent) {
    const evt = NOTIF_EVENTS.find(e => e.key === activeEvent);
    const tpl = getTemplate(activeEvent);
    const vars = VARIABLES[activeEvent] || [];

    return (
      <div>
        {/* Breadcrumb */}
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:20 }}>
          <button onClick={() => setActiveEvent(null)}
            style={{ display:'flex', alignItems:'center', gap:6, border:'none', background:'none', cursor:'pointer', color:'#3b82f6', fontSize:13, fontWeight:500, padding:0 }}
            onMouseEnter={e=>e.currentTarget.style.textDecoration='underline'}
            onMouseLeave={e=>e.currentTarget.style.textDecoration='none'}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M5 12l7 7M5 12l7-7"/></svg>
            General Notifications
          </button>
          <span style={{ color:T.text3 }}>›</span>
          <span style={{ fontSize:13, fontWeight:600, color:T.text }}>{evt?.label}</span>
        </div>

        {/* Variables reference */}
        <div style={{ background:darkMode?'rgba(59,130,246,0.08)':'#eff6ff', border:`1px solid ${darkMode?'rgba(59,130,246,0.2)':'#bfdbfe'}`, borderRadius:10, padding:'10px 16px', marginBottom:20, display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
          <span style={{ fontSize:11, fontWeight:600, color:'#3b82f6' }}>Variables:</span>
          {vars.map(v => (
            <span key={v} style={{ fontSize:11, fontWeight:600, padding:'2px 8px', borderRadius:6, background:darkMode?'rgba(59,130,246,0.15)':'#dbeafe', color:'#2563eb', cursor:'default' }}>{v}</span>
          ))}
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          {/* EMAIL */}
          <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, overflow:'hidden', boxShadow:darkMode?'0 4px 16px rgba(0,0,0,0.2)':'0 2px 8px rgba(15,31,69,0.06)' }}>
            <div style={{ padding:'14px 20px', background:darkMode?'rgba(249,115,22,0.08)':'#fff7ed', borderBottom:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={{ width:30, height:30, borderRadius:8, background:darkMode?'rgba(249,115,22,0.15)':'#ffedd5', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                </div>
                <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>Email</p>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <span style={{ fontSize:12, color:T.text2 }}>Enable</span>
                <div onClick={() => updateTemplate(activeEvent, 'email_enabled', !tpl.email_enabled)}
                  style={{ width:36, height:20, borderRadius:10, background:tpl.email_enabled?'#f97316':(darkMode?'#334155':'#d1d5db'), position:'relative', cursor:'pointer', transition:'background 0.2s' }}>
                  <div style={{ position:'absolute', top:2, left:tpl.email_enabled?18:2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
                </div>
              </div>
            </div>
            {tpl.email_enabled && (
              <div style={{ padding:20, display:'flex', flexDirection:'column', gap:14 }}>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase' }}>Email Subject</label>
                  <input type="text" value={tpl.email_subject||''} onChange={e=>updateTemplate(activeEvent,'email_subject',e.target.value)} placeholder="e.g. Invoice {INVOICE_NUMBER} from {YOUR_COMPANY_NAME}" style={is} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase' }}>Email Template</label>
                  <SimpleEmailEditor
                    value={tpl.email_body||''}
                    onChange={val => updateTemplate(activeEvent, 'email_body', val)}
                    vars={vars}
                    darkMode={darkMode}
                    T={T}
                  />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase' }}>Send To</label>
                  <select value={tpl.email_recipients||'admin'} onChange={e=>updateTemplate(activeEvent,'email_recipients',e.target.value)} style={is}>
                    <option value="admin">Admin (notify email from settings)</option>
                    <option value="client">Client Email</option>
                    <option value="custom">Custom Email</option>
                  </select>
                </div>
                {tpl.email_recipients === 'custom' && (
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase' }}>Custom Email(s) — comma separated</label>
                    <input type="text" value={tpl.email_custom_to||''} onChange={e=>updateTemplate(activeEvent,'email_custom_to',e.target.value)} placeholder="e.g. admin@firm.com, partner@firm.com" style={is} />
                  </div>
                )}
              </div>
            )}
          </div>

          {/* SMS */}
          <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, overflow:'hidden', boxShadow:darkMode?'0 4px 16px rgba(0,0,0,0.2)':'0 2px 8px rgba(15,31,69,0.06)' }}>
            <div style={{ padding:'14px 20px', background:darkMode?'rgba(59,130,246,0.08)':'#eff6ff', borderBottom:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={{ width:30, height:30, borderRadius:8, background:darkMode?'rgba(59,130,246,0.15)':'#dbeafe', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                </div>
                <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>SMS</p>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <span style={{ fontSize:12, color:T.text2 }}>Enable</span>
                <div onClick={() => updateTemplate(activeEvent, 'sms_enabled', !tpl.sms_enabled)}
                  style={{ width:36, height:20, borderRadius:10, background:tpl.sms_enabled?'#3b82f6':(darkMode?'#334155':'#d1d5db'), position:'relative', cursor:'pointer', transition:'background 0.2s' }}>
                  <div style={{ position:'absolute', top:2, left:tpl.sms_enabled?18:2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
                </div>
              </div>
            </div>
            {tpl.sms_enabled && (
              <div style={{ padding:20 }}>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase' }}>SMS Template</label>
                <textarea value={tpl.sms_template||''} onChange={e=>updateTemplate(activeEvent,'sms_template',e.target.value)}
                  rows={3} placeholder="e.g. Hi {CLIENT_NAME}, Invoice {INVOICE_NUMBER} of {AMOUNT} has been created. -{YOUR_COMPANY_NAME}"
                  style={{ ...is, resize:'vertical' }} />
                <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:8 }}>
                  <span style={{ fontSize:11, color:T.text3, fontWeight:600 }}>Insert:</span>
                  {vars.map(v => (
                    <button key={v} onClick={() => insertVar(activeEvent, 'sms', v)}
                      style={{ fontSize:11, padding:'2px 8px', borderRadius:6, border:`1px solid ${T.border2}`, background:T.bg3, color:T.text2, cursor:'pointer' }}
                      onMouseEnter={e=>e.currentTarget.style.background='#dbeafe'}
                      onMouseLeave={e=>e.currentTarget.style.background=T.bg3}>
                      {v}
                    </button>
                  ))}
                </div>
                <p style={{ fontSize:11, color:T.text3, marginTop:8 }}>Max 160 characters per SMS. Current: {(tpl.sms_template||'').length}</p>
              </div>
            )}
          </div>

          {/* WHATSAPP */}
          <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, overflow:'hidden', boxShadow:darkMode?'0 4px 16px rgba(0,0,0,0.2)':'0 2px 8px rgba(15,31,69,0.06)' }}>
            <div style={{ padding:'14px 20px', background:darkMode?'rgba(37,211,102,0.08)':'#f0fdf4', borderBottom:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={{ width:30, height:30, borderRadius:8, background:darkMode?'rgba(37,211,102,0.15)':'#dcfce7', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#25d366" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                </div>
                <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>WhatsApp</p>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <span style={{ fontSize:12, color:T.text2 }}>Enable</span>
                <div onClick={() => updateTemplate(activeEvent, 'whatsapp_enabled', !tpl.whatsapp_enabled)}
                  style={{ width:36, height:20, borderRadius:10, background:tpl.whatsapp_enabled?'#25d366':(darkMode?'#334155':'#d1d5db'), position:'relative', cursor:'pointer', transition:'background 0.2s' }}>
                  <div style={{ position:'absolute', top:2, left:tpl.whatsapp_enabled?18:2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
                </div>
              </div>
            </div>
            {tpl.whatsapp_enabled && (
              <div style={{ padding:20 }}>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase' }}>WhatsApp Template</label>
                <textarea value={tpl.whatsapp_template||''} onChange={e=>updateTemplate(activeEvent,'whatsapp_template',e.target.value)}
                  rows={4} placeholder="e.g. Hi {CLIENT_NAME}, your invoice {INVOICE_NUMBER} for {AMOUNT} has been generated. -{YOUR_COMPANY_NAME}"
                  style={{ ...is, resize:'vertical' }} />
                <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:8 }}>
                  <span style={{ fontSize:11, color:T.text3, fontWeight:600 }}>Insert:</span>
                  {vars.map(v => (
                    <button key={v} onClick={() => insertVar(activeEvent, 'whatsapp', v)}
                      style={{ fontSize:11, padding:'2px 8px', borderRadius:6, border:`1px solid ${T.border2}`, background:T.bg3, color:T.text2, cursor:'pointer' }}
                      onMouseEnter={e=>e.currentTarget.style.background='#dcfce7'}
                      onMouseLeave={e=>e.currentTarget.style.background=T.bg3}>
                      {v}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Save */}
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <button onClick={() => handleSave(activeEvent)} disabled={saving}
              style={{ padding:'10px 28px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1, display:'flex', alignItems:'center', gap:8 }}>
              {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
              {saving ? 'Saving...' : 'Save Template'}
            </button>
            {saved && (
              <span style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, color:'#16a34a', fontWeight:600 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                Saved
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ── Event List View ──────────────────────────────────────────────────────────
  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>General Notifications</h3>
        <p style={{ fontSize:12, color:T.text3, margin:'4px 0 0' }}>Configure templates for each event across Email, SMS and WhatsApp</p>
      </div>

      <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, overflow:'hidden', boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
            <tr>
              {['Event','Description','SMS','WhatsApp','Email',''].map(h => (
                <th key={h} style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {NOTIF_EVENTS.map((evt, i) => {
              const tpl = getTemplate(evt.key);
              const badge = (enabled) => (
                <span style={{ fontSize:11, fontWeight:600, padding:'2px 8px', borderRadius:20,
                  color: enabled?'#16a34a':T.text3,
                  background: enabled?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):T.bg3 }}>
                  {enabled ? 'Active' : 'Inactive'}
                </span>
              );
              return (
                <tr key={evt.key} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), transition:'background 0.15s', cursor:'pointer' }}
                  onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                  onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}
                  onClick={() => setActiveEvent(evt.key)}>
                  <td style={{ padding:'14px 20px', fontSize:13, fontWeight:600, color:'#3b82f6' }}>{evt.label}</td>
                  <td style={{ padding:'14px 20px', fontSize:12, color:T.text3 }}>{evt.desc}</td>
                  <td style={{ padding:'14px 20px' }}>{badge(tpl.sms_enabled)}</td>
                  <td style={{ padding:'14px 20px' }}>{badge(tpl.whatsapp_enabled)}</td>
                  <td style={{ padding:'14px 20px' }}>{badge(tpl.email_enabled)}</td>
                  <td style={{ padding:'14px 20px' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function NotificationChannelSection({ token, channel, title, color, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const { showToast } = useToast();
  const [settings, setSettings] = useState({
    enabled: false,
    on_new_client: false,
    on_invoice_created: false,
    on_payment_received: false,
    on_task_assigned: false,
    on_task_due: false,
    on_renewal_due: false,
    on_lead_created: false,
    api_key: '',
    sender_id: '',
    template_id: '',
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetch(`${BASE}/api/notification-settings/${channel}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setSettings(s => ({ ...s, ...d })); })
      .catch(() => {});
  }, [channel, token]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await fetch(`${BASE}/api/notification-settings/${channel}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(settings),
      });
      setSaved(true); setTimeout(() => setSaved(false), 3000);
    } catch(e) { showToast('Error saving'); }
    finally { setSaving(false); }
  };

  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'10px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };

  const Toggle = ({ field, label, desc }) => (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 0', borderBottom:`1px solid ${T.border}` }}>
      <div>
        <p style={{ fontSize:13, fontWeight:500, color:T.text, margin:0 }}>{label}</p>
        {desc && <p style={{ fontSize:11, color:T.text3, marginTop:3 }}>{desc}</p>}
      </div>
      <div onClick={() => setSettings(s => ({ ...s, [field]: !settings[field] }))}
        style={{ width:40, height:22, borderRadius:11, background:settings[field]?'#3b82f6':(darkMode?'#334155':'#d1d5db'), position:'relative', cursor:'pointer', flexShrink:0, marginLeft:16, transition:'background 0.2s' }}>
        <div style={{ position:'absolute', top:2, left:settings[field]?20:2, width:18, height:18, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
      </div>
    </div>
  );

  return (
    <div>
      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div style={{ width:40, height:40, borderRadius:12, background:`${color}22`, display:'flex', alignItems:'center', justifyContent:'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
          </div>
          <div>
            <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>{title}</h3>
            <p style={{ fontSize:12, color:T.text3, marginTop:3 }}>Manage {title} notification preferences</p>
          </div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          {saved && (
            <span style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, color:'#16a34a', fontWeight:600 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>Saved
            </span>
          )}
          <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 20px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
            {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
        {/* Master toggle */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <div>
              <p style={{ fontSize:14, fontWeight:700, color:T.text, margin:0 }}>Enable {title} Notifications</p>
              <p style={{ fontSize:12, color:T.text3, marginTop:3 }}>Turn on to activate all {title.toLowerCase()} alerts</p>
            </div>
            <div onClick={() => setSettings(s => ({ ...s, enabled: !settings.enabled }))}
              style={{ width:46, height:26, borderRadius:13, background:settings.enabled?'#3b82f6':(darkMode?'#334155':'#d1d5db'), position:'relative', cursor:'pointer', flexShrink:0, transition:'background 0.2s' }}>
              <div style={{ position:'absolute', top:3, left:settings.enabled?22:3, width:20, height:20, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
            </div>
          </div>
        </div>

        {/* Event triggers */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <h4 style={{ fontSize:13, fontWeight:700, color:T.text, margin:'0 0 4px' }}>Notification Triggers</h4>
          <p style={{ fontSize:12, color:T.text3, marginBottom:16 }}>Choose which events send a {title.toLowerCase()} notification</p>
          <Toggle field="on_new_client"       label="New Client Added"      desc="Notify when a new client is created" />
          <Toggle field="on_invoice_created"  label="Invoice Created"       desc="Notify when a new invoice is raised" />
          <Toggle field="on_payment_received" label="Payment Received"      desc="Notify when a receipt is recorded" />
          <Toggle field="on_task_assigned"    label="Task Assigned"         desc="Notify when a task is assigned to a user" />
          <Toggle field="on_task_due"         label="Task Due Reminder"     desc="Notify before a task deadline" />
          <Toggle field="on_renewal_due"      label="Renewal Due Reminder"  desc="Notify before a renewal expires" />
          <Toggle field="on_lead_created"     label="New Lead"              desc="Notify when a new lead is added" />
        </div>

        {/* API Config — only show for channel-specific integrations */}
        {(channel === 'whatsapp' || channel === 'sms' || channel === 'email') && (
          <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 1px 4px rgba(15,31,69,0.05)' }}>
            <h4 style={{ fontSize:13, fontWeight:700, color:T.text, margin:'0 0 18px' }}>
              {channel === 'email' ? '📧 SMTP Configuration' : '🔌 API Configuration'}
            </h4>
            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>

              {channel === 'email' && (
                <>
                  {/* SMTP Server Type */}
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:8, textTransform:'uppercase', letterSpacing:'0.05em' }}>Send Email From</label>
                    <div style={{ display:'flex', gap:12 }}>
                      {[
                        { value:'gmail',   label:'Gmail' },
                        { value:'outlook', label:'Office 365 / Outlook' },
                        { value:'custom',  label:'Custom SMTP' },
                      ].map(opt => (
                        <label key={opt.value} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:`1.5px solid ${(settings.smtp_provider||'gmail')===opt.value?'#3b82f6':T.border2}`, background:(settings.smtp_provider||'gmail')===opt.value?(darkMode?'rgba(59,130,246,0.1)':'#eff6ff'):T.bg2, cursor:'pointer', fontSize:13, fontWeight:500, color:(settings.smtp_provider||'gmail')===opt.value?'#3b82f6':T.text2 }}>
                          <input type="radio" name="smtp_provider" value={opt.value}
                            checked={(settings.smtp_provider||'gmail') === opt.value}
                            onChange={e => setSettings(s => ({ ...s, smtp_provider: e.target.value }))}
                            style={{ accentColor:'#3b82f6' }} />
                          {opt.label}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Custom SMTP fields */}
                  {(settings.smtp_provider === 'custom' || !settings.smtp_provider) && settings.smtp_provider === 'custom' && (
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                      <div style={{ gridColumn:'span 2' }}>
                        <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>SMTP Host</label>
                        <input type="text" placeholder="e.g. smtp.hostinger.com" value={settings.smtp_host || ''}
                          onChange={e => setSettings(s => ({ ...s, smtp_host: e.target.value }))} style={is} />
                      </div>
                      <div>
                        <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Encryption</label>
                        <select value={settings.smtp_encryption || 'SSL'}
                          onChange={e => setSettings(s => ({ ...s, smtp_encryption: e.target.value, smtp_port: e.target.value==='SSL'?'465':e.target.value==='TLS'?'587':'25' }))} style={is}>
                          <option value="SSL">SSL</option>
                          <option value="TLS">TLS / STARTTLS</option>
                          <option value="none">None</option>
                        </select>
                      </div>
                      <div>
                        <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>SMTP Port</label>
                        <input type="number" placeholder="e.g. 465" value={settings.smtp_port || ''}
                          onChange={e => setSettings(s => ({ ...s, smtp_port: e.target.value }))} style={is} />
                      </div>
                      <div>
                        <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>SMTP Username</label>
                        <input type="email" placeholder="e.g. info@legalchanakya.in" value={settings.smtp_username || ''}
                          onChange={e => setSettings(s => ({ ...s, smtp_username: e.target.value }))} style={is} />
                      </div>
                      <div>
                        <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>SMTP Password</label>
                        <input type="password" placeholder="SMTP password" value={settings.smtp_password || ''}
                          onChange={e => setSettings(s => ({ ...s, smtp_password: e.target.value }))} style={is} />
                      </div>
                    </div>
                  )}

                  {/* Gmail App Password */}
                  {(settings.smtp_provider === 'gmail' || !settings.smtp_provider || settings.smtp_provider === 'outlook') && (
                    <div>
                      <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>
                        {settings.smtp_provider === 'outlook' ? 'Outlook / App Password' : 'Gmail App Password'}
                      </label>
                      <input type="password"
                        placeholder={settings.smtp_provider === 'outlook' ? 'Office 365 app password' : '16-digit App Password'}
                        value={settings.smtp_password || ''}
                        onChange={e => setSettings(s => ({ ...s, smtp_password: e.target.value }))} style={is} />
                      <p style={{ fontSize:11, color:T.text3, marginTop:5 }}>
                        {settings.smtp_provider === 'outlook'
                          ? 'Office 365: Azure AD → App registrations → Generate password'
                          : 'Gmail: Google Account → Security → 2-Step Verification → App Passwords'}
                      </p>
                    </div>
                  )}

                  {/* From Email + From Name */}
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                    <div>
                      <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>From Email</label>
                      <input type="email" placeholder="e.g. info@legalchanakya.in" value={settings.sender_id || ''}
                        onChange={e => setSettings(s => ({ ...s, sender_id: e.target.value }))} style={is} />
                    </div>
                    <div>
                      <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>From Name</label>
                      <input type="text" placeholder="e.g. Legal Chanakya" value={settings.from_name || ''}
                        onChange={e => setSettings(s => ({ ...s, from_name: e.target.value }))} style={is} />
                    </div>
                  </div>

                  {/* Notify Email */}
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Admin Notification Email</label>
                    <input type="email" placeholder="admin@yourfirm.com (receives system alerts)" value={settings.notify_email || ''}
                      onChange={e => setSettings(s => ({ ...s, notify_email: e.target.value }))} style={is} />
                  </div>

                  {/* Info box */}
                  <div style={{ background:darkMode?'rgba(59,130,246,0.08)':'#eff6ff', border:`1px solid ${darkMode?'rgba(59,130,246,0.2)':'#bfdbfe'}`, borderRadius:10, padding:'12px 16px' }}>
                    <p style={{ fontSize:12, fontWeight:600, color:'#3b82f6', margin:'0 0 6px' }}>Quick Reference</p>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:4 }}>
                      {[
                        ['Hostinger', 'smtp.hostinger.com', 'SSL', '465'],
                        ['Gmail', 'smtp.gmail.com', 'TLS', '587'],
                        ['Outlook/365', 'smtp.office365.com', 'TLS', '587'],
                        ['Zoho', 'smtp.zoho.in', 'SSL', '465'],
                      ].map(([name, host, enc, port]) => (
                        <div key={name} style={{ fontSize:11, color:T.text2 }}>
                          <strong style={{ color:T.text }}>{name}:</strong> {host} · {enc} · {port}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Test button */}
                  <TestEmailButton token={token} onSave={handleSave} />
                </>
              )}

              {channel !== 'email' && (
                <>
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>API Key</label>
                    <input type="text" placeholder="Enter API key" value={settings.api_key || ''}
                      onChange={e => setSettings(s => ({ ...s, api_key: e.target.value }))} style={is} />
                  </div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                    <div>
                      <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Sender ID</label>
                      <input type="text" placeholder="e.g. CHANKYX" value={settings.sender_id || ''}
                        onChange={e => setSettings(s => ({ ...s, sender_id: e.target.value }))} style={is} />
                    </div>
                    <div>
                      <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Template ID</label>
                      <input type="text" placeholder="DLT Template ID" value={settings.template_id || ''}
                        onChange={e => setSettings(s => ({ ...s, template_id: e.target.value }))} style={is} />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
function TestEmailButton({ token, onSave }) {
  const [testing, setTesting] = useState(false);
  const [result,  setResult]  = useState(null);

  const handleTest = async () => {
    setTesting(true); setResult(null);
    // Save first, then test
    await onSave();
    try {
      const res = await fetch(`${BASE}/api/notification-settings/email/test`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const data = await res.json();
      setResult(data);
    } catch(e) {
      setResult({ success: false, reason: 'Could not reach server' });
    } finally {
      setTesting(false);
      setTimeout(() => setResult(null), 6000);
    }
  };

  return (
    <div>
      <button onClick={handleTest} disabled={testing} style={{
        display:'flex', alignItems:'center', gap:8, padding:'10px 20px',
        borderRadius:10, border:'1.5px solid #0f1f45',
        background: testing ? '#f8faff' : '#fff',
        color:'#0f1f45', fontSize:13, fontWeight:600, cursor: testing ? 'wait' : 'pointer',
      }}>
        {testing
          ? <span style={{ width:13, height:13, border:'2px solid #0f1f45', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>
          : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 2L11 13"/><path d="M22 2L15 22 11 13 2 9l20-7z"/></svg>
        }
        {testing ? 'Sending test email...' : 'Send Test Email'}
      </button>
      {result && (
        <div style={{
          marginTop:10, padding:'10px 14px', borderRadius:10, fontSize:12, fontWeight:500,
          background: result.success ? '#f0fdf4' : '#fef2f2',
          border: `1px solid ${result.success ? '#bbf7d0' : '#fecaca'}`,
          color: result.success ? '#15803d' : '#dc2626',
          display:'flex', alignItems:'center', gap:8,
        }}>
          {result.success
            ? <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Test email sent successfully! Check your inbox.</>
            : <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> Failed: {result.reason}</>
          }
        </div>
      )}
    </div>
  );
}

// ── WORKSPACE ACCESS SECTION — per-user toggle for paid workspace modules ─────
function WorkspaceAccessSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh      = { 'Content-Type': 'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [data, setData]     = useState({ users: [], modules: [], access: {} });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState({});

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/users/module-access-matrix`, { headers });
      const d = await r.json();
      setData({ users: d.users || [], modules: d.modules || [], access: d.access || {} });
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleToggle = async (userId, moduleKey, current) => {
    const key = `${userId}-${moduleKey}`;
    setSaving(s => ({ ...s, [key]: true }));
    try {
      await fetch(`${BASE}/api/users/${userId}/module-access/${moduleKey}`, {
        method: 'PUT', headers: jh, body: JSON.stringify({ has_access: !current })
      });
      setData(prev => ({
        ...prev,
        access: { ...prev.access, [userId]: { ...prev.access[userId], [moduleKey]: !current } }
      }));
    } catch(e) { showToast('Error saving'); }
    finally { setSaving(s => ({ ...s, [key]: false })); }
  };

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h3 style={{ fontSize:16, fontWeight:700, color:T.text, margin:0 }}>Workspace Module Access</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:3 }}>Control which team members can open each paid workspace (MCA, GST, Income Tax). Admins always have full access.</p>
      </div>

      <div style={{ background:darkMode?'rgba(249,115,22,0.1)':'#fff7ed', border:`1px solid ${darkMode?'rgba(249,115,22,0.25)':'#fed7aa'}`, borderRadius:12, padding:'14px 18px', marginBottom:20, display:'flex', alignItems:'flex-start', gap:12 }}>
        <div style={{ width:32, height:32, borderRadius:8, background:darkMode?'rgba(249,115,22,0.2)':'#ffedd5', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        </div>
        <div>
          <p style={{ fontSize:13, fontWeight:700, color:'#f97316', margin:0 }}>A user needs BOTH to open a workspace</p>
          <p style={{ fontSize:12, color:darkMode?'#fdba74':'#c2410c', marginTop:3 }}>Your firm must have an active subscription for that module, AND that specific user must be toggled on below.</p>
        </div>
      </div>

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:'#94a3b8', fontSize:13 }}>Loading users...</div>
      ) : data.modules.length === 0 ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:'#94a3b8', fontSize:13 }}>No workspace modules available yet.</div>
      ) : (
        <div style={{ background:T.bg2, borderRadius:16, border:`1px solid ${T.cardBorder}`, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 1px 6px rgba(15,31,69,0.05)', overflow:'hidden' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                <th style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em' }}>User</th>
                {data.modules.map(m => (
                  <th key={m.module_key} style={{ padding:'10px 8px', textAlign:'center', fontSize:11, fontWeight:700, color:'#fff', letterSpacing:'0.03em' }}>{m.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.users.map((u, i) => {
                const isAdmin = u.role === 'admin';
                return (
                  <tr key={u.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff') }}>
                    <td style={{ padding:'12px 20px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ width:30, height:30, borderRadius:'50%', background:'#0f1f45', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700, flexShrink:0 }}>
                          {(u.full_name||'?').charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{u.full_name}</p>
                          <p style={{ fontSize:11, color:T.text3, margin:0, textTransform:'capitalize' }}>{u.role}</p>
                        </div>
                      </div>
                    </td>
                    {data.modules.map(m => {
                      const enabled = isAdmin || data.access[u.id]?.[m.module_key] === true;
                      const key = `${u.id}-${m.module_key}`;
                      return (
                        <td key={m.module_key} style={{ padding:'8px', textAlign:'center' }}>
                          <button
                            onClick={() => !isAdmin && handleToggle(u.id, m.module_key, data.access[u.id]?.[m.module_key] === true)}
                            disabled={isAdmin || saving[key]}
                            title={isAdmin ? 'Admins always have access' : (enabled ? 'Revoke access' : 'Grant access')}
                            style={{
                              width:44, height:24, borderRadius:20, border:'none', position:'relative',
                              background: enabled ? '#16a34a' : (darkMode ? '#334155' : '#e2e8f0'),
                              cursor: isAdmin ? 'default' : 'pointer',
                              opacity: isAdmin ? 0.6 : 1,
                              transition:'background 0.15s',
                            }}>
                            <span style={{
                              position:'absolute', top:2, left: enabled ? 22 : 2,
                              width:20, height:20, borderRadius:'50%', background:'#fff',
                              transition:'left 0.15s', boxShadow:'0 1px 3px rgba(0,0,0,0.3)',
                            }}/>
                          </button>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── TELEGRAM DESTINATION CARD — one named chat (Partners, Sales Team, …) ───
function TelegramDestinationCard({ dest, token, darkMode, T, onChange }) {
  const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const { showConfirm } = useToast();
  const [label, setLabel] = useState(dest.label);
  const [editingLabel, setEditingLabel] = useState(false);
  const [toggles, setToggles] = useState({
    enabled: dest.enabled,
    on_lead_created: dest.on_lead_created, on_invoice_created: dest.on_invoice_created,
    on_payment_received: dest.on_payment_received, on_task_assigned: dest.on_task_assigned,
    on_task_due: dest.on_task_due, on_renewal_due: dest.on_renewal_due, on_new_client: dest.on_new_client,
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testMsg, setTestMsg] = useState(null);
  const [connecting, setConnecting] = useState(false);

  useEffect(() => {
    setLabel(dest.label);
    setToggles({
      enabled: dest.enabled,
      on_lead_created: dest.on_lead_created, on_invoice_created: dest.on_invoice_created,
      on_payment_received: dest.on_payment_received, on_task_assigned: dest.on_task_assigned,
      on_task_due: dest.on_task_due, on_renewal_due: dest.on_renewal_due, on_new_client: dest.on_new_client,
    });
  }, [dest]);

  const handleSave = async (overrideLabel) => {
    setSaving(true);
    try {
      await fetch(`${BASE}/api/telegram/destinations/${dest.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ label: overrideLabel || label, ...toggles }),
      });
      setSaved(true); setTimeout(() => setSaved(false), 3000);
      onChange();
    } catch (e) {} finally { setSaving(false); }
  };

  const handleConnect = async () => {
    setConnecting(true);
    try {
      await fetch(`${BASE}/api/telegram/destinations/${dest.id}/connect`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      onChange();
    } catch (e) {} finally { setConnecting(false); }
  };

  const handleDisconnect = async () => {
    await fetch(`${BASE}/api/telegram/destinations/${dest.id}/disconnect`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
    onChange();
  };

  const handleDelete = async () => {
    if (!await showConfirm(`Remove "${dest.label}"? This can't be undone.`)) return;
    await fetch(`${BASE}/api/telegram/destinations/${dest.id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    onChange();
  };

  const handleTest = async () => {
    setTesting(true); setTestMsg(null);
    try {
      const res = await fetch(`${BASE}/api/telegram/destinations/${dest.id}/test`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setTestMsg({ type: data.success ? 'success' : 'error', text: data.success ? 'Test message sent!' : (data.reason || 'Failed to send') });
    } catch (e) { setTestMsg({ type: 'error', text: 'Network error' }); }
    finally { setTesting(false); }
  };

  const Toggle = ({ field, label: fieldLabel }) => (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 0', borderBottom:`1px solid ${T.border}` }}>
      <span style={{ fontSize:12.5, color:T.text2 }}>{fieldLabel}</span>
      <div onClick={() => setToggles(s => ({ ...s, [field]: !s[field] }))}
        style={{ width:34, height:19, borderRadius:10, background:toggles[field]?'#229ED9':(darkMode?'#334155':'#d1d5db'), position:'relative', cursor:'pointer', flexShrink:0, transition:'background 0.2s' }}>
        <div style={{ position:'absolute', top:2, left:toggles[field]?16:2, width:15, height:15, borderRadius:'50%', background:'#fff', transition:'left 0.2s' }}/>
      </div>
    </div>
  );

  return (
    <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, padding:18, marginBottom:14, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, flex:1, minWidth:0 }}>
          <div style={{ width:9, height:9, borderRadius:'50%', background: dest.connected ? '#16a34a' : T.border2, flexShrink:0 }}/>
          {editingLabel ? (
            <input autoFocus value={label} onChange={e => setLabel(e.target.value)}
              onBlur={() => { setEditingLabel(false); handleSave(label); }}
              onKeyDown={e => { if (e.key === 'Enter') { setEditingLabel(false); handleSave(label); } }}
              style={{ fontSize:14, fontWeight:700, color:T.text, border:`1px solid ${T.inputBorder}`, borderRadius:6, padding:'4px 8px', outline:'none', background:T.inputBg }}/>
          ) : (
            <span onClick={() => setEditingLabel(true)} style={{ fontSize:14, fontWeight:700, color:T.text, cursor:'pointer' }} title="Click to rename">{dest.label}</span>
          )}
        </div>
        <button onClick={handleDelete} style={{ background:'none', border:'none', color:T.text3, cursor:'pointer', padding:4, flexShrink:0 }} title="Remove destination">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
        </button>
      </div>

      {dest.connected ? (
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
          <span style={{ fontSize:12, color:T.text3 }}>Connected</span>
          <div style={{ display:'flex', gap:8 }}>
            <button onClick={handleTest} disabled={testing} style={{ padding:'5px 12px', borderRadius:7, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:11.5, fontWeight:600, cursor:'pointer' }}>
              {testing ? 'Sending…' : 'Test'}
            </button>
            <button onClick={handleDisconnect} style={{ padding:'5px 12px', borderRadius:7, border:'1px solid #fecaca', background:'transparent', color:'#dc2626', fontSize:11.5, fontWeight:600, cursor:'pointer' }}>
              Disconnect
            </button>
          </div>
        </div>
      ) : dest.pairing_code ? (
        <div style={{ textAlign:'center', marginBottom:14, background:T.bg3, borderRadius:10, padding:14 }}>
          <p style={{ fontSize:11.5, color:T.text3, marginBottom:8 }}>Add the bot to this chat/group and message it:</p>
          {dest.deep_link ? (
            <a href={dest.deep_link} target="_blank" rel="noreferrer"
              style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'7px 14px', borderRadius:8, background:'#229ED9', color:'#fff', fontSize:12, fontWeight:700, textDecoration:'none' }}>
              {dest.pairing_code} — Open in Telegram →
            </a>
          ) : (
            <span style={{ fontSize:14, fontWeight:800, letterSpacing:3, color:'#229ED9', fontFamily:'monospace' }}>{dest.pairing_code}</span>
          )}
          <p style={{ fontSize:10.5, color:T.text3, marginTop:8 }}>Waiting for confirmation… this updates automatically.</p>
        </div>
      ) : (
        <div style={{ textAlign:'center', marginBottom:14 }}>
          <button onClick={handleConnect} disabled={connecting}
            style={{ padding:'7px 16px', borderRadius:8, border:'none', background:'#229ED9', color:'#fff', fontSize:12, fontWeight:700, cursor:'pointer' }}>
            {connecting ? 'Generating…' : 'Generate Connect Link'}
          </button>
        </div>
      )}
      {testMsg && <p style={{ fontSize:11, textAlign:'center', marginBottom:10, color: testMsg.type==='success'?'#16a34a':'#dc2626', fontWeight:600 }}>{testMsg.text}</p>}

      <div style={{ borderTop:`1px solid ${T.border}`, paddingTop:10 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:6 }}>
          <p style={{ fontSize:10.5, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.06em', margin:0 }}>Alerts sent here</p>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            {saved && <span style={{ fontSize:11, color:'#16a34a', fontWeight:600 }}>Saved</span>}
            <button onClick={() => handleSave()} disabled={saving} style={{ padding:'4px 10px', borderRadius:6, border:'none', background:'#0f1f45', color:'#fff', fontSize:11, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
              {saving ? '…' : 'Save'}
            </button>
          </div>
        </div>
        <Toggle field="on_lead_created"     label="New Lead" />
        <Toggle field="on_invoice_created"  label="Invoice Created" />
        <Toggle field="on_payment_received" label="Payment Received" />
        <Toggle field="on_task_assigned"    label="Task Assigned" />
        <Toggle field="on_task_due"         label="Task Due Reminder" />
        <Toggle field="on_renewal_due"      label="Renewal Due Reminder" />
      </div>
    </div>
  );
}

// ── TELEGRAM CONNECT SECTION — manages the list of destinations ────────────
function TelegramConnectSection({ token, darkMode, T }) {
  const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const [destinations, setDestinations] = useState([]);
  const [botConfigured, setBotConfigured] = useState(true);
  const [newLabel, setNewLabel] = useState('');
  const [creating, setCreating] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [testingDue, setTestingDue] = useState(false);
  const [dueTestMsg, setDueTestMsg] = useState(null);

  const fetchDestinations = useCallback(() => {
    fetch(`${BASE}/api/telegram/destinations`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) { setDestinations(d.destinations || []); setBotConfigured(d.bot_configured); } })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [BASE, token]);

  useEffect(() => { fetchDestinations(); }, [fetchDestinations]);

  // Poll while anything is mid-pairing
  useEffect(() => {
    const hasPending = destinations.some(d => d.pairing_code && !d.connected);
    if (!hasPending) return;
    const interval = setInterval(fetchDestinations, 3000);
    return () => clearInterval(interval);
  }, [destinations, fetchDestinations]);

  const handleAdd = async () => {
    if (!newLabel.trim()) return;
    setCreating(true);
    try {
      await fetch(`${BASE}/api/telegram/destinations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ label: newLabel.trim() }),
      });
      setNewLabel('');
      fetchDestinations();
    } catch (e) {} finally { setCreating(false); }
  };

  const handleTestDueReminders = async () => {
    setTestingDue(true); setDueTestMsg(null);
    try {
      const res = await fetch(`${BASE}/api/telegram/test-due-reminders`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setDueTestMsg(data.message || 'Done.');
    } catch (e) { setDueTestMsg('Network error'); }
    finally { setTestingDue(false); }
  };

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20 }}>
        <div style={{ width:40, height:40, borderRadius:12, background:'#229ED922', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#229ED9" strokeWidth="2"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>
        </div>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Telegram</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:3 }}>Add a destination per team — Partners, Sales Team, etc. Each one has its own alerts.</p>
        </div>
      </div>

      {!botConfigured && (
        <div style={{ background:darkMode?'rgba(239,68,68,0.08)':'#fef2f2', border:`1px solid ${darkMode?'rgba(239,68,68,0.2)':'#fecaca'}`, borderRadius:10, padding:'12px 16px', marginBottom:16 }}>
          <p style={{ fontSize:12, color:'#dc2626', margin:0, fontWeight:600 }}>
            The Telegram bot isn't configured on the server yet — TELEGRAM_BOT_TOKEN is missing.
          </p>
        </div>
      )}

      <div style={{ display:'flex', gap:10, marginBottom:20 }}>
        <input value={newLabel} onChange={e => setNewLabel(e.target.value)} placeholder="e.g. Partners, Sales Team, Compliance"
          onKeyDown={e => { if (e.key === 'Enter') handleAdd(); }}
          style={{ flex:1, border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'10px 14px', fontSize:13, outline:'none', background:T.inputBg, color:T.text }}/>
        <button onClick={handleAdd} disabled={creating || !newLabel.trim() || !botConfigured}
          style={{ padding:'10px 20px', borderRadius:10, border:'none', background: (newLabel.trim() && botConfigured) ? '#229ED9' : T.border2, color:'#fff', fontSize:13, fontWeight:700, cursor: (newLabel.trim() && botConfigured) ? 'pointer' : 'not-allowed', whiteSpace:'nowrap' }}>
          {creating ? 'Adding…' : '+ Add Destination'}
        </button>
      </div>

      {loaded && destinations.length === 0 && (
        <div style={{ textAlign:'center', padding:'32px 16px', background:T.bg3, borderRadius:14, border:`1px dashed ${T.border2}` }}>
          <p style={{ fontSize:13, color:T.text3, margin:0 }}>No Telegram destinations yet. Add one above — e.g. "Partners" or "Sales Team".</p>
        </div>
      )}

      {destinations.map(dest => (
        <TelegramDestinationCard key={dest.id} dest={dest} token={token} darkMode={darkMode} T={T} onChange={fetchDestinations} />
      ))}

      {destinations.length > 0 && (
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, padding:18, marginTop:6 }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
            <div>
              <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>Daily Reminders</p>
              <p style={{ fontSize:11.5, color:T.text3, marginTop:3 }}>Task Due, Renewal Due, and client payment reminders — runs automatically every day around 9 AM. Test it now instead of waiting.</p>
            </div>
            <button onClick={handleTestDueReminders} disabled={testingDue}
              style={{ padding:'8px 16px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:12.5, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' }}>
              {testingDue ? 'Running…' : 'Run Now (Test)'}
            </button>
          </div>
          {dueTestMsg && <p style={{ fontSize:12, color:T.text2, marginTop:10 }}>{dueTestMsg}</p>}
        </div>
      )}
    </div>
  );
}

// ── CRM: LEAD NUMBERING SECTION ────────────────────────────────────────────────
// SaaS-friendly replacement for manually TRUNCATE-ing the leads table to
// reset numbering — each firm picks its own prefix, starting number, and
// whether numbering resets every financial year.
function CrmNumberingSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const { showToast, showConfirm } = useToast();
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type':'application/json', ...headers };
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [settings, setSettings] = useState({ lead_prefix:'L', lead_start_number:1, lead_reset_yearly:false, lead_next_number:1 });

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/crm-settings`, { headers });
      const d = await r.json();
      setSettings(s => ({ ...s, ...d }));
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/crm-settings`, { method:'PUT', headers:jh, body:JSON.stringify(settings) });
      const d = await res.json();
      if (!res.ok) { showToast(d.message || 'Could not save settings'); return; }
      setSettings(s => ({ ...s, ...d }));
      showToast('Lead numbering settings saved.', 'success');
    } catch (e) { showToast('Server error while saving settings'); }
    finally { setSaving(false); }
  };

  const handleReset = async () => {
    const ok = await showConfirm(`Reset lead numbering now?\n\nThe next new lead will be numbered starting from ${settings.lead_prefix}${String(settings.lead_start_number).padStart(6,'0')}. Existing leads keep their current IDs.`);
    if (!ok) return;
    setResetting(true);
    try {
      const res = await fetch(`${BASE}/api/crm-settings/reset-numbering`, { method:'POST', headers });
      const d = await res.json();
      if (!res.ok) { showToast(d.message || 'Could not reset numbering'); return; }
      setSettings(s => ({ ...s, ...d.settings }));
      showToast(d.message || 'Numbering reset.', 'success');
    } catch (e) { showToast('Server error while resetting numbering'); }
    finally { setResetting(false); }
  };

  const previewId = settings.lead_reset_yearly
    ? `${settings.lead_prefix || 'L'}/FY/${String(settings.lead_start_number || 1).padStart(4,'0')}`
    : `${settings.lead_prefix || 'L'}${String(settings.lead_start_number || 1).padStart(6,'0')}`;

  if (loading) return <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>;

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Lead Numbering</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Control how new Lead IDs are generated for your firm — no database access needed to start a fresh numbering sequence.</p>
      </div>

      <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, padding:22, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)', maxWidth:560 }}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Prefix</label>
            <input type="text" maxLength={10} value={settings.lead_prefix || ''} onChange={e => setSettings(s => ({ ...s, lead_prefix: e.target.value.toUpperCase() }))} placeholder="L" style={is} />
          </div>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Start Number</label>
            <input type="number" min={1} value={settings.lead_start_number || 1} onChange={e => setSettings(s => ({ ...s, lead_start_number: e.target.value }))} style={is} />
          </div>
        </div>

        <label style={{ display:'flex', alignItems:'center', gap:10, marginBottom:18, cursor:'pointer' }}>
          <input type="checkbox" checked={!!settings.lead_reset_yearly} onChange={e => setSettings(s => ({ ...s, lead_reset_yearly: e.target.checked }))} style={{ width:16, height:16 }} />
          <span style={{ fontSize:13, color:T.text2 }}>Reset numbering every financial year (Apr–Mar)</span>
        </label>

        <div style={{ background:T.bg3, border:`1px solid ${T.border}`, borderRadius:10, padding:'10px 14px', marginBottom:20, display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:11, color:T.text3, fontWeight:600, textTransform:'uppercase' }}>Preview</span>
          <code style={{ fontSize:13, fontWeight:700, color:'#3b82f6' }}>{previewId}</code>
          <span style={{ fontSize:11, color:T.text3 }}>next new lead's ID (currently at #{settings.lead_next_number || settings.lead_start_number || 1})</span>
        </div>

        <div style={{ display:'flex', gap:10 }}>
          <button onClick={handleSave} disabled={saving}
            style={{ padding:'9px 20px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
          <button onClick={handleReset} disabled={resetting}
            style={{ padding:'9px 20px', borderRadius:9, border:'1px solid #fecaca', background:darkMode?'rgba(239,68,68,0.1)':'#fef2f2', color:'#dc2626', fontSize:13, fontWeight:600, cursor:'pointer', opacity:resetting?0.6:1 }}>
            {resetting ? 'Resetting...' : 'Reset Numbering Now'}
          </button>
        </div>
        <p style={{ fontSize:11, color:T.text3, marginTop:14 }}>"Reset Numbering Now" replaces the old workflow of manually truncating the leads table in Supabase — it only resets the counter, existing leads and their IDs are untouched.</p>
      </div>
    </div>
  );
}

// One universal integration per firm — any external site (this firm's own
// website, a chatbot, a checkout flow) authenticates with THIS firm's own
// api_key against the shared, SaaS-wide POST /api/public/intake endpoint.
// Nothing about a specific firm's domain lives in the backend — it's all
// driven from this settings row.
function WebsiteIntegrationSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const { showToast, showConfirm } = useToast();
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type':'application/json', ...headers };
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [regenerating, setRegenerating] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [integ, setInteg] = useState({ api_key:'', allowed_origins:'', source_enquiry_form:true, source_chatbot:true, source_checkout:true });

  const [services, setServices] = useState([]);
  const [slugMap, setSlugMap] = useState([]);
  const [newSlug, setNewSlug] = useState('');
  const [newServiceId, setNewServiceId] = useState('');
  const [addingSlug, setAddingSlug] = useState(false);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const [iRes, sRes, mRes] = await Promise.all([
        fetch(`${BASE}/api/website-integration`, { headers }),
        fetch(`${BASE}/api/services`, { headers }),
        fetch(`${BASE}/api/website-integration/slug-map`, { headers }),
      ]);
      const [iData, sData, mData] = await Promise.all([iRes.json(), sRes.json(), mRes.json()]);
      setInteg(v => ({ ...v, ...iData }));
      setServices(Array.isArray(sData) ? sData : []);
      setSlugMap(Array.isArray(mData) ? mData : []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/website-integration`, { method:'PUT', headers:jh, body:JSON.stringify(integ) });
      const d = await res.json();
      if (!res.ok) { showToast(d.message || 'Could not save settings'); return; }
      setInteg(v => ({ ...v, ...d }));
      showToast('Website integration settings saved.', 'success');
    } catch (e) { showToast('Server error while saving settings'); }
    finally { setSaving(false); }
  };

  const handleRegenerate = async () => {
    const ok = await showConfirm('Regenerate the API key?\n\nAny website, chatbot, or checkout script still using the current key will stop working immediately until updated with the new one.');
    if (!ok) return;
    setRegenerating(true);
    try {
      const res = await fetch(`${BASE}/api/website-integration/regenerate-key`, { method:'POST', headers });
      const d = await res.json();
      if (!res.ok) { showToast(d.message || 'Could not regenerate key'); return; }
      setInteg(v => ({ ...v, ...d }));
      setRevealed(true);
      showToast('New API key generated.', 'success');
    } catch (e) { showToast('Server error while regenerating key'); }
    finally { setRegenerating(false); }
  };

  const copyKey = () => {
    navigator.clipboard?.writeText(integ.api_key || '');
    showToast('API key copied.', 'success');
  };

  const handleAddSlug = async () => {
    if (!newSlug.trim() || !newServiceId) { showToast('Pick a service and enter a slug.'); return; }
    setAddingSlug(true);
    try {
      const res = await fetch(`${BASE}/api/website-integration/slug-map`, { method:'POST', headers:jh, body:JSON.stringify({ slug:newSlug.trim(), service_id:newServiceId }) });
      const d = await res.json();
      if (!res.ok) { showToast(d.message || 'Could not add mapping'); return; }
      setNewSlug(''); setNewServiceId('');
      fetchAll();
    } catch (e) { showToast('Server error while adding mapping'); }
    finally { setAddingSlug(false); }
  };

  const handleDeleteSlug = async (id) => {
    const ok = await showConfirm('Remove this service slug mapping?');
    if (!ok) return;
    try {
      await fetch(`${BASE}/api/website-integration/slug-map/${id}`, { method:'DELETE', headers });
      setSlugMap(m => m.filter(row => row.id !== id));
    } catch (e) { showToast('Server error while removing mapping'); }
  };

  if (loading) return <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>;

  const snippet = `fetch('${BASE}/api/public/intake', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    api_key: '${integ.api_key || 'YOUR_API_KEY'}',
    source: 'enquiry_form',   // or 'chatbot' / 'checkout'
    name, phone, email,
    service: 'gst-registration', // your own slug — see mapping below
    message
  })
});`;

  const cardStyle = { background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, padding:22, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' };
  const toggleRow = (label, desc, field) => (
    <label style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'10px 0', cursor:'pointer', borderTop:`1px solid ${T.border}` }}>
      <input type="checkbox" checked={integ[field] !== false} onChange={e => setInteg(v => ({ ...v, [field]: e.target.checked }))} style={{ width:16, height:16, marginTop:2 }} />
      <div>
        <div style={{ fontSize:13, color:T.text2, fontWeight:600 }}>{label}</div>
        <div style={{ fontSize:11.5, color:T.text3, marginTop:2 }}>{desc}</div>
      </div>
    </label>
  );

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Website Integration</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Connect your own website, AI chatbot, or checkout flow to this CRM — leads created there land here automatically. Every firm gets its own key; nothing here is specific to any one firm's site.</p>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:20, maxWidth:680 }}>

        {/* API key */}
        <div style={cardStyle}>
          <div style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:10 }}>API Key</div>
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            <code style={{ flex:1, background:T.bg3, border:`1px solid ${T.border}`, borderRadius:8, padding:'9px 12px', fontSize:12.5, color:T.text, overflowX:'auto', whiteSpace:'nowrap' }}>
              {revealed ? (integ.api_key || '—') : (integ.api_key ? integ.api_key.slice(0,8) + '•'.repeat(24) : '—')}
            </code>
            <button onClick={() => setRevealed(r => !r)} style={{ padding:'9px 12px', borderRadius:8, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:12, fontWeight:600, cursor:'pointer' }}>{revealed ? 'Hide' : 'Reveal'}</button>
            <button onClick={copyKey} style={{ padding:'9px 12px', borderRadius:8, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:12, fontWeight:600, cursor:'pointer' }}>Copy</button>
            <button onClick={handleRegenerate} disabled={regenerating} style={{ padding:'9px 14px', borderRadius:8, border:'1px solid #fecaca', background:darkMode?'rgba(239,68,68,0.1)':'#fef2f2', color:'#dc2626', fontSize:12, fontWeight:600, cursor:'pointer', opacity:regenerating?0.6:1, whiteSpace:'nowrap' }}>
              {regenerating ? 'Regenerating...' : 'Regenerate'}
            </button>
          </div>

          <div style={{ marginTop:16 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Allowed Origins <span style={{ fontWeight:400, textTransform:'none' }}>(optional)</span></label>
            <input type="text" value={integ.allowed_origins || ''} onChange={e => setInteg(v => ({ ...v, allowed_origins: e.target.value }))} placeholder="https://yourfirm.com, https://www.yourfirm.com" style={is} />
            <p style={{ fontSize:11, color:T.text3, marginTop:6 }}>Comma-separated. Leave blank to allow any origin — needed for a server-to-server call (e.g. from your own backend) which won't send a browser Origin header at all. Restrict this only for calls made directly from browser JavaScript (like a chat widget).</p>
          </div>

          <button onClick={handleSave} disabled={saving}
            style={{ marginTop:16, padding:'9px 20px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>

        {/* Source toggles */}
        <div style={cardStyle}>
          <div style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:4 }}>Lead Sources</div>
          {toggleRow('Website Enquiry Form', 'A plain contact/enquiry form on your site.', 'source_enquiry_form')}
          {toggleRow('AI Chatbot', 'Leads captured by your website’s AI chat widget.', 'source_chatbot')}
          {toggleRow('Checkout / Payment', 'A customer completing a paid checkout on your site.', 'source_checkout')}
        </div>

        {/* Integration snippet */}
        <div style={cardStyle}>
          <div style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:10 }}>Example Request</div>
          <pre style={{ background:darkMode?'#0b1220':'#0f1f2e', color:'#a5f3fc', borderRadius:10, padding:14, fontSize:11.5, lineHeight:1.6, overflowX:'auto', margin:0 }}>{snippet}</pre>
          <p style={{ fontSize:11, color:T.text3, marginTop:10 }}>Call this from wherever a lead is captured on your site — a form submit handler, your chatbot's backend, or your checkout's payment-confirmation step. Same endpoint, same key, every time.</p>
        </div>

        {/* Service slug mapping */}
        <div style={cardStyle}>
          <div style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:10 }}>Service Slug Mapping</div>
          <p style={{ fontSize:11.5, color:T.text3, marginBottom:14 }}>Map the service identifiers your website uses (e.g. "private-ltd") to your actual Services Master entries, so a lead from your site is tagged with the right service automatically.</p>

          <div style={{ display:'flex', gap:8, marginBottom:14 }}>
            <input type="text" value={newSlug} onChange={e => setNewSlug(e.target.value)} placeholder="e.g. gst-registration" style={{ ...is, flex:1 }} />
            <select value={newServiceId} onChange={e => setNewServiceId(e.target.value)} style={{ ...is, flex:1 }}>
              <option value="">Select service...</option>
              {services.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
            <button onClick={handleAddSlug} disabled={addingSlug} style={{ padding:'9px 16px', borderRadius:9, border:'none', background:'#0f1f45', color:'#fff', fontSize:12.5, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap', opacity:addingSlug?0.6:1 }}>
              {addingSlug ? 'Adding...' : '+ Add'}
            </button>
          </div>

          {slugMap.length === 0 ? (
            <p style={{ fontSize:12, color:T.text3, textAlign:'center', padding:'14px 0' }}>No mappings yet — an unmapped service slug is still saved on the lead, but left untagged for manual follow-up.</p>
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              {slugMap.map(row => (
                <div key={row.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 12px', background:T.bg3, border:`1px solid ${T.border}`, borderRadius:8 }}>
                  <div style={{ fontSize:12.5 }}>
                    <code style={{ color:'#3b82f6', fontWeight:600 }}>{row.slug}</code>
                    <span style={{ color:T.text3, margin:'0 6px' }}>→</span>
                    <span style={{ color:T.text, fontWeight:500 }}>{row.service_name}</span>
                  </div>
                  <button onClick={() => handleDeleteSlug(row.id)} style={{ fontSize:11, color:'#ef4444', background:'none', border:'none', cursor:'pointer', fontWeight:600 }}>Remove</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// A small fixed swatch palette — enough variety for a firm's stage list
// without building a full color picker.
const STAGE_COLOR_PALETTE = ['#6366f1', '#d97706', '#7c3aed', '#ea580c', '#0ea5e9', '#16a34a', '#dc2626', '#ec4899', '#64748b', '#0f1f45'];

// Lead Stages — firm-editable picklist, same pattern as Client Types, plus a
// color swatch per stage and a protected pair ("Won"/"Lost") that can't be
// renamed or deleted since Won triggers auto Client+Task creation and both
// drive the referral pipeline's close-out logic.
function LeadStagesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [stages, setStages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState(null);
  const [name, setName] = useState('');
  const [color, setColor] = useState(STAGE_COLOR_PALETTE[0]);

  const fetchStages = () => {
    setLoading(true);
    fetch(`${BASE}/api/leads/stages/all`, { headers })
      .then(r => r.json()).then(d => setStages(Array.isArray(d) ? d : []))
      .catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { fetchStages(); }, []);

  const reset = () => { setName(''); setEditId(null); setColor(STAGE_COLOR_PALETTE[0]); };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      const url    = editId ? `${BASE}/api/leads/stages/${editId}` : `${BASE}/api/leads/stages`;
      const method = editId ? 'PUT' : 'POST';
      const res = await fetch(url, { method, headers: jh, body: JSON.stringify({ name: name.trim(), color }) });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { showToast(d.message || 'Could not save'); return; }
      reset(); fetchStages();
    } catch { showToast('Could not save'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (s) => {
    if (!await showConfirm(`Remove the "${s.name}" stage?`)) return;
    const res = await fetch(`${BASE}/api/leads/stages/${s.id}`, { method: 'DELETE', headers });
    if (!res.ok) { const d = await res.json().catch(() => ({})); showToast(d.message || 'Could not delete'); return; }
    fetchStages();
  };

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Lead Stages</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>The pipeline stages used across CRM — List View, Pipeline View, and the Lead form. Add your own (e.g. "Not Responded", "Not Interested"), rename, recolor, or remove ones you don't use. <strong>"Won" and "Lost" are protected</strong> — Won triggers automatic Client + Task creation and both drive the referral pipeline, so they can't be renamed or deleted.</p>
      </div>

      <form onSubmit={handleSave} style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:20, marginBottom:24 }}>
        <div style={{ display:'flex', gap:12, alignItems:'flex-end' }}>
          <div style={{ flex:1 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>{editId ? 'Rename Stage' : 'Stage Name *'}</label>
            <input type="text" placeholder="e.g. Not Interested" value={name} onChange={e => setName(e.target.value)} style={is} />
          </div>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Color</label>
            <div style={{ display:'flex', gap:6, padding:'8px 0' }}>
              {STAGE_COLOR_PALETTE.map(c => (
                <button key={c} type="button" onClick={() => setColor(c)}
                  style={{ width:22, height:22, borderRadius:'50%', background:c, border: color===c ? `2px solid ${T.text}` : '2px solid transparent', boxShadow: color===c ? '0 0 0 2px '+T.bg3 : 'none', cursor:'pointer', padding:0 }} />
              ))}
            </div>
          </div>
          <button type="submit" disabled={saving} style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', flexShrink:0, opacity:saving?0.6:1 }}>
            {saving ? 'Saving...' : editId ? 'Save' : '+ Add Stage'}
          </button>
          {editId && (
            <button type="button" onClick={reset} style={{ padding:'9px 14px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer', flexShrink:0 }}>Cancel</button>
          )}
        </div>
      </form>

      {loading ? (
        <div style={{ padding:'32px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading…</div>
      ) : stages.length === 0 ? (
        <div style={{ padding:'32px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:12, color:T.text3, fontSize:13 }}>No stages yet — add your first one above.</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
          {stages.map(s => (
            <div key={s.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 14px', borderRadius:10, background:T.bg2, border:`1px solid ${T.cardBorder}` }}>
              <span style={{ width:12, height:12, borderRadius:'50%', background:s.color || '#64748b', flexShrink:0 }} />
              <span style={{ fontSize:13, fontWeight:600, color:T.text, flex:1 }}>{s.name}</span>
              {s.is_system && (
                <span style={{ fontSize:10, fontWeight:700, color:'#64748b', background:darkMode?'rgba(100,116,139,0.15)':'#f1f5f9', padding:'3px 8px', borderRadius:20, textTransform:'uppercase', letterSpacing:'0.04em', display:'flex', alignItems:'center', gap:4 }}>
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                  Protected
                </span>
              )}
              {s.lead_count > 0 && (
                <span style={{ fontSize:11, fontWeight:600, color:T.text3 }}>{s.lead_count} lead{s.lead_count === 1 ? '' : 's'}</span>
              )}
              <button onClick={() => { setEditId(s.id); setName(s.name); setColor(s.color || STAGE_COLOR_PALETTE[0]); }} title={s.is_system ? 'Protected — cannot rename' : 'Rename'}
                disabled={s.is_system}
                style={{ width:26, height:26, borderRadius:7, border:`1px solid ${T.border2}`, background:T.bg3, color: s.is_system ? T.border2 : T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor: s.is_system ? 'not-allowed' : 'pointer', padding:0 }}
                onMouseEnter={e=>{ if (!s.is_system) { e.currentTarget.style.color='#3b82f6'; e.currentTarget.style.borderColor='#3b82f6'; } }}
                onMouseLeave={e=>{ if (!s.is_system) { e.currentTarget.style.color=T.text3; e.currentTarget.style.borderColor=T.border2; } }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              </button>
              <button onClick={() => handleDelete(s)} title={s.is_system ? 'Protected — cannot delete' : 'Remove'}
                disabled={s.is_system || s.lead_count > 0}
                style={{ width:26, height:26, borderRadius:7, border:`1px solid ${T.border2}`, background:T.bg3, color: (s.is_system || s.lead_count > 0) ? T.border2 : T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor: (s.is_system || s.lead_count > 0) ? 'not-allowed' : 'pointer', padding:0 }}
                onMouseEnter={e=>{ if (!s.is_system && !s.lead_count) { e.currentTarget.style.color='#ef4444'; e.currentTarget.style.borderColor='#ef4444'; } }}
                onMouseLeave={e=>{ if (!s.is_system && !s.lead_count) { e.currentTarget.style.color=T.text3; e.currentTarget.style.borderColor=T.border2; } }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Lead Sources — firm-editable picklist, identical pattern to Client Types
// (no protected rows — no automation keys off a specific source value).
function LeadSourcesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState(null);
  const [name, setName] = useState('');

  const fetchSources = () => {
    setLoading(true);
    fetch(`${BASE}/api/leads/sources/all`, { headers })
      .then(r => r.json()).then(d => setSources(Array.isArray(d) ? d : []))
      .catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { fetchSources(); }, []);

  const reset = () => { setName(''); setEditId(null); };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      const url    = editId ? `${BASE}/api/leads/sources/${editId}` : `${BASE}/api/leads/sources`;
      const method = editId ? 'PUT' : 'POST';
      const res = await fetch(url, { method, headers: jh, body: JSON.stringify({ name: name.trim() }) });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { showToast(d.message || 'Could not save'); return; }
      reset(); fetchSources();
    } catch { showToast('Could not save'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (s) => {
    if (!await showConfirm(`Remove the "${s.name}" source?`)) return;
    const res = await fetch(`${BASE}/api/leads/sources/${s.id}`, { method: 'DELETE', headers });
    if (!res.ok) { const d = await res.json().catch(() => ({})); showToast(d.message || 'Could not delete'); return; }
    fetchSources();
  };

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Lead Sources</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Where a lead came from — shown in the Lead form and the List View filter. Add your own, rename, or remove ones you don't use.</p>
      </div>

      <form onSubmit={handleSave} style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:20, marginBottom:24 }}>
        <div style={{ display:'flex', gap:12, alignItems:'flex-end' }}>
          <div style={{ flex:1 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>{editId ? 'Rename Source' : 'Source Name *'}</label>
            <input type="text" placeholder="e.g. Trade Show" value={name} onChange={e => setName(e.target.value)} style={is} />
          </div>
          <button type="submit" disabled={saving} style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', flexShrink:0, opacity:saving?0.6:1 }}>
            {saving ? 'Saving...' : editId ? 'Save' : '+ Add Source'}
          </button>
          {editId && (
            <button type="button" onClick={reset} style={{ padding:'9px 14px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer', flexShrink:0 }}>Cancel</button>
          )}
        </div>
      </form>

      {loading ? (
        <div style={{ padding:'32px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading…</div>
      ) : sources.length === 0 ? (
        <div style={{ padding:'32px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:12, color:T.text3, fontSize:13 }}>No sources yet — add your first one above.</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
          {sources.map(s => (
            <div key={s.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 14px', borderRadius:10, background:T.bg2, border:`1px solid ${T.cardBorder}` }}>
              <span style={{ fontSize:13, fontWeight:600, color:T.text, flex:1 }}>{s.name}</span>
              {s.lead_count > 0 && (
                <span style={{ fontSize:11, fontWeight:600, color:T.text3 }}>{s.lead_count} lead{s.lead_count === 1 ? '' : 's'}</span>
              )}
              <button onClick={() => { setEditId(s.id); setName(s.name); }} title="Rename"
                style={{ width:26, height:26, borderRadius:7, border:`1px solid ${T.border2}`, background:T.bg3, color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', padding:0 }}
                onMouseEnter={e=>{ e.currentTarget.style.color='#3b82f6'; e.currentTarget.style.borderColor='#3b82f6'; }}
                onMouseLeave={e=>{ e.currentTarget.style.color=T.text3; e.currentTarget.style.borderColor=T.border2; }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              </button>
              <button onClick={() => handleDelete(s)} title="Remove"
                disabled={s.lead_count > 0}
                style={{ width:26, height:26, borderRadius:7, border:`1px solid ${T.border2}`, background:T.bg3, color: s.lead_count > 0 ? T.border2 : T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor: s.lead_count > 0 ? 'not-allowed' : 'pointer', padding:0 }}
                onMouseEnter={e=>{ if (!s.lead_count) { e.currentTarget.style.color='#ef4444'; e.currentTarget.style.borderColor='#ef4444'; } }}
                onMouseLeave={e=>{ if (!s.lead_count) { e.currentTarget.style.color=T.text3; e.currentTarget.style.borderColor=T.border2; } }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function SectionContent({ id, token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const p = { token, darkMode, T };
  if (id === 'users')               return <UsersSection {...p} />;
  if (id === 'client-types')        return <ClientTypesSection {...p} />;
  if (id === 'client-groups')       return <ClientGroupsSection {...p} />;
  if (id === 'portals')             return <PortalsSection {...p} />;
  if (id === 'expense-categories')  return <ExpenseCategoriesSection {...p} />;
  if (id === 'service-categories')  return <ServiceCategoriesSection {...p} />;
  if (id === 'tags')                return <TagsSection {...p} />;
  if (id === 'hr-settings')         return <HRSettingsSection {...p} />;
  if (id === 'payment-modes')       return <PaymentModesSection {...p} />;
  if (id === 'bank-accounts')       return <BankAccountsSection {...p} />;
  if (id === 'renewal-types')       return <RenewalTypesSection {...p} />;
  if (id === 'billing-settings')    return <BillingSettings token={token} darkMode={darkMode} T={T} />;
  if (id === 'user-roles')          return <UserRolesSection {...p} />;
  if (id === 'workspace-access')    return <WorkspaceAccessSection {...p} />;
  if (id === 'attendance')          return <AttendanceSettingsSection {...p} />;
  if (id === 'user-replacement')    return <UserReplacementSection {...p} />;
  if (id === 'document-types')      return <DocumentTypesSection {...p} />;
  if (id === 'holidays')            return <HolidaysSection {...p} />;
  if (id === 'firm-profile')        return <FirmProfileSection {...p} />;
  if (id === 'client-settings')     return <ClientSettingsSection {...p} />;
  if (id === 'client-portal')       return <ClientPortalSection {...p} />;
  if (id === 'compliance-calendar') return <ComplianceCalendarSection {...p} />;
  if (id === 'digital-signature')   return <DigitalSignatureSection {...p} />;
  if (id === 'branding')            return <BrandingSection {...p} />;
  if (id === 'whatsapp')            return <NotificationChannelSection {...p} channel="whatsapp" title="WhatsApp" color="#25d366" />;
  if (id === 'telegram')            return <TelegramConnectSection {...p} />;
  if (id === 'sms')                 return <NotificationChannelSection {...p} channel="sms" title="SMS" color="#3b82f6" />;
  if (id === 'email-settings')      return <NotificationChannelSection {...p} channel="email" title="Email" color="#f97316" />;
  if (id === 'general-notifications') return <GeneralNotificationsSection {...p} />;
  if (id === 'task-notifications')  return <NotificationChannelSection {...p} channel="tasks" title="Task Alerts" color="#8b5cf6" />;
  if (id === 'user-notifications')  return <NotificationChannelSection {...p} channel="users" title="User Notifications" color="#0f1f45" />;
  if (id === 'tally-export')        return <NotificationComingSoon {...p} title="Tally Export" desc="Export invoices and receipts to Tally-compatible format." icon="📊" />;
  if (id === 'crm-lead-numbering')  return <CrmNumberingSection {...p} />;
  if (id === 'lead-stages')         return <LeadStagesSection {...p} />;
  if (id === 'lead-sources')        return <LeadSourcesSection {...p} />;
  if (id === 'website-integration') return <WebsiteIntegrationSection {...p} />;
  const allItems = NAV.flatMap(s => s.items);
  const item = allItems.find(i => i.id === id);
  return <ComingSoon {...p} label={item?.label || id} />;
}

// ── MAIN SETTINGS PAGE ────────────────────────────────────────────────────────
function Settings({ initialSection, darkMode = false, T: theme }) {
  const T = theme || { bg:'#f4f7ff', bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBg:'#fff', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const [activeId, setActiveId] = useState(initialSection || null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.page === 'settings' && e.detail?.section) {
        setActiveId(e.detail.section);
      }
    };
    window.addEventListener('navigateTo', handler);
    return () => window.removeEventListener('navigateTo', handler);
  }, []);

  useEffect(() => {
    if (initialSection) setActiveId(initialSection);
  }, [initialSection]);

  // ── Jump nav (grid view) — sticky pill bar that scrolls the page to a
  // section group instead of making the user hunt for it by hand ──
  const [activeGroup, setActiveGroup] = useState(NAV[0]?.id);
  const groupRefs = React.useRef({});

  useEffect(() => {
    if (activeId) return; // only observe while the grid view is mounted
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => { if (entry.isIntersecting) setActiveGroup(entry.target.dataset.navId); });
      },
      { rootMargin: '-100px 0px -70% 0px', threshold: 0 }
    );
    Object.values(groupRefs.current).forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
  }, [activeId]);

  const scrollToGroup = (id) => {
    setActiveGroup(id);
    groupRefs.current[id]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // ── DETAIL VIEW ──
  if (activeId) {
    const allItems = NAV.flatMap(s => s.items);
    const item = allItems.find(i => i.id === activeId);
    const section = NAV.find(s => s.items.some(i => i.id === activeId));
    return (
      <ToastProvider darkMode={darkMode}>
      <div style={{ padding:32, minHeight:'100vh', background: darkMode?'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.07) 0%,transparent 60%),#0a0f1e':'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.05) 0%,transparent 50%),#f4f7ff' }}>
        {/* Breadcrumb */}
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:28 }}>
          <button onClick={() => setActiveId(null)} style={{ color:'#3b82f6', background:'none', border:'none', fontSize:13, fontWeight:500, cursor:'pointer', padding:0 }}>Settings</button>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
          <span style={{ fontSize:13, color:T.text3 }}>{section?.label}</span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
          <span style={{ fontSize:13, fontWeight:600, color:T.text }}>{item?.label}</span>
        </div>
        <div style={{ background:T.bg2, borderRadius:20, border:`1px solid ${T.cardBorder}`, padding:28, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <SectionContent id={activeId} token={token} darkMode={darkMode} T={T} />
        </div>
      </div>
      </ToastProvider>
    );
  }

  // ── GRID VIEW ──
  return (
    <ToastProvider darkMode={darkMode}>
    <div style={{ padding:32, minHeight:'100vh', background: darkMode?'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.07) 0%,transparent 60%),#0a0f1e':'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.05) 0%,transparent 50%),#f4f7ff' }}>
      <div style={{ marginBottom:20 }}>
        <p style={{ fontSize:13, color:T.text3, margin:0 }}>Configure ChanakyaX to match your firm's workflow</p>
      </div>

      {/* ── Sticky jump nav — click a section, page scrolls to it ── */}
      <div style={{
        position:'sticky', top:0, zIndex:5, margin:'0 -32px 28px', padding:'12px 32px',
        background: darkMode ? 'rgba(10,15,30,0.94)' : 'rgba(244,247,255,0.94)',
        backdropFilter:'blur(6px)', WebkitBackdropFilter:'blur(6px)',
        borderBottom:`1px solid ${T.border}`,
        display:'flex', alignItems:'center', gap:8, overflowX:'auto',
      }} className="settings-jumpnav">
        {NAV.map(section => {
          const active = activeGroup === section.id;
          return (
            <button key={section.id} onClick={() => scrollToGroup(section.id)} title={section.label} style={{
              flex:'0 0 auto', display:'flex', alignItems:'center', gap:7, whiteSpace:'nowrap',
              padding:'7px 14px', borderRadius:999, fontSize:12.5, fontWeight:600, cursor:'pointer',
              transition:'background 0.15s, color 0.15s, border-color 0.15s',
              border:`1px solid ${active ? 'transparent' : T.border}`,
              background: active ? 'linear-gradient(135deg,#0f1f45,#1a3a6b)' : T.bg2,
              color: active ? '#fff' : T.text2,
            }}
            onMouseEnter={e => { if (!active) { e.currentTarget.style.borderColor = '#3b82f6'; e.currentTarget.style.color = '#3b82f6'; } }}
            onMouseLeave={e => { if (!active) { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.text2; } }}>
              <span style={{ display:'flex', lineHeight:0, opacity: active ? 1 : 0.8 }}>{section.icon}</span>
              {section.label}
            </button>
          );
        })}
      </div>
      <style>{`.settings-jumpnav::-webkit-scrollbar { display:none; } .settings-jumpnav { scrollbar-width:none; }`}</style>

      <div style={{ display:'flex', flexDirection:'column', gap:36 }}>
        {NAV.map(section => (
          <div key={section.id} id={`settings-nav-${section.id}`} data-nav-id={section.id}
               ref={el => { groupRefs.current[section.id] = el; }}
               style={{ scrollMarginTop:76 }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
              <div style={{ width:32, height:32, borderRadius:9, background:darkMode?'rgba(255,255,255,0.06)':T.bg2, border:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                {section.icon}
              </div>
              <h2 style={{ fontSize:12, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.08em', margin:0 }}>{section.label}</h2>
              <div style={{ flex:1, height:1, background:T.border }}/>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14 }}>
              {section.items.map(item => (
                <button key={item.id} onClick={() => setActiveId(item.id)}
                  style={{ textAlign:'left', background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:20, cursor:'pointer', transition:'all 0.15s', boxShadow:darkMode?'0 2px 12px rgba(0,0,0,0.2)':'0 2px 8px rgba(15,31,69,0.04)' }}
                  onMouseEnter={e=>{ e.currentTarget.style.borderColor='#3b82f6'; e.currentTarget.style.boxShadow=darkMode?'0 4px 20px rgba(59,130,246,0.15)':'0 4px 16px rgba(59,130,246,0.1)'; }}
                  onMouseLeave={e=>{ e.currentTarget.style.borderColor=T.cardBorder; e.currentTarget.style.boxShadow=darkMode?'0 2px 12px rgba(0,0,0,0.2)':'0 2px 8px rgba(15,31,69,0.04)'; }}>
                  <div style={{ width:42, height:42, borderRadius:12, background:darkMode?'rgba(255,255,255,0.06)':T.bg3, border:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:14 }}>
                    {item.icon}
                  </div>
                  <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:'0 0 6px' }}>{item.label}</p>
                  <p style={{ fontSize:11, color:T.text3, lineHeight:1.5, margin:0, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>
                    {/* Descriptions */}
                    {item.id === 'users'              && 'Add, edit and manage team members and their passwords'}
                    {item.id === 'user-roles'         && 'Create roles and control dashboard access permissions'}
                    {item.id === 'user-notifications' && 'Configure push notifications and alert preferences'}
                    {item.id === 'attendance'         && 'Office hours, working days of the week & attendance rules'}
                    {item.id === 'holidays'           && 'Create or manage holidays list for the firm'}
                    {item.id === 'user-replacement'   && 'Replace a user across tasks, clients and services'}
                    {item.id === 'client-settings'    && 'Manage client settings and add custom fields'}
                    {item.id === 'client-types'       && 'Add or rename client types e.g. Section 8 Company, AOP'}
                    {item.id === 'client-groups'      && 'Create and manage client groups and relationships'}
                    {item.id === 'portals'            && 'Manage portals e.g. GST, Income Tax, MCA'}
                    {item.id === 'tags'               && 'Manage tags for clients and tasks e.g. Urgent, VIP'}
                    {item.id === 'document-types'     && 'Add document types e.g. PAN Card, GST Certificate'}
                    {item.id === 'client-portal'      && 'Client-facing login portal link and section visibility'}
                    {item.id === 'billing-settings'   && 'Firm profile, invoice/receipt/quotation formatting and numbering'}
                    {item.id === 'expense-categories' && 'Manage expense categories e.g. Stationery, Legal'}
                    {item.id === 'payment-modes'      && 'Add payment modes for receipts e.g. Bank, UPI, Cash'}
                    {item.id === 'tally-export'       && 'Export invoices and receipts to Tally accounting'}
                    {item.id === 'service-settings'   && 'Configure default service settings and automations'}
                    {item.id === 'service-categories' && 'Manage categories used when creating services e.g. GST, Audit'}
                    {item.id === 'renewal-types'      && 'Manage renewal types e.g. DSC, Trade License, FSSAI'}
                    {item.id === 'compliance-calendar'&& 'Manage compliance calendar and important due dates'}
                    {item.id === 'whatsapp'           && 'Configure WhatsApp Business API and templates'}
                    {item.id === 'telegram'           && 'Connect a Telegram bot for instant firm alerts — no Meta approval needed'}
                    {item.id === 'sms'                && 'SMS settings and credit balance management'}
                    {item.id === 'email-settings'     && 'Email settings for automated messages'}
                    {item.id === 'general-notifications'&&'Schedule general messages and timing preferences'}
                    {item.id === 'task-notifications' && 'Apply conditions and reminders for task alerts'}
                    {item.id === 'hr-settings'        && 'Leave types, annual application windows and notice rules'}
                  </p>
                  <div style={{ display:'flex', justifyContent:'flex-end', marginTop:12 }}>
                    <div style={{ width:24, height:24, borderRadius:'50%', background:darkMode?'rgba(255,255,255,0.06)':T.bg3, display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
    </ToastProvider>
  );
}

function PaymentModesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type':'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [modes,    setModes]    = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving,   setSaving]   = useState(false);
  const [form, setForm] = useState({ name:'', value:'' });
  const [viewMode, setViewMode] = useState('list');

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/payment-modes`, { headers });
      const d = await r.json();
      setModes(Array.isArray(d) ? d : []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);
  const openAdd  = () => { setEditItem(null); setForm({ name:'', value:'' }); setShowForm(true); };
  const openEdit = (m) => { setEditItem(m); setForm({ name:m.name, value:m.value, is_active:m.is_active }); setShowForm(true); };

  const handleSave = async () => {
    if (!form.name) return showToast('Name is required');
    setSaving(true);
    try {
      const url    = editItem ? `${BASE}/api/payment-modes/${editItem.id}` : `${BASE}/api/payment-modes`;
      const method = editItem ? 'PUT' : 'POST';
      const res    = await fetch(url, { method, headers:jh, body:JSON.stringify(form) });
      if (!res.ok) { const d=await res.json(); return showToast(d.message||'Error'); }
      setShowForm(false); fetchAll();
    } catch(e) { showToast('Error'); }
    finally { setSaving(false); }
  };

  const handleToggle = async (m) => {
    await fetch(`${BASE}/api/payment-modes/${m.id}`, {
      method:'PUT', headers:jh,
      body: JSON.stringify({ ...m, is_active: !m.is_active })
    });
    fetchAll();
  };

  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this payment mode?')) return;
    await fetch(`${BASE}/api/payment-modes/${id}`, { method:'DELETE', headers });
    fetchAll();
  };

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Payment Modes</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Modes available when recording receipts</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {/* View Toggle */}
          <div style={{ display:'flex', background:T.bg3, border:`1px solid ${T.border}`, borderRadius:9, padding:3 }}>
            <button onClick={() => setViewMode('list')} title="List View"
              style={{ width:32, height:28, borderRadius:7, border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s',
                background: viewMode==='list'?'linear-gradient(135deg,#0f1f45,#1a3a6b)':'transparent',
                color: viewMode==='list'?'#fff':T.text3 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
            </button>
            <button onClick={() => setViewMode('grid')} title="Grid View"
              style={{ width:32, height:28, borderRadius:7, border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s',
                background: viewMode==='grid'?'linear-gradient(135deg,#0f1f45,#1a3a6b)':'transparent',
                color: viewMode==='grid'?'#fff':T.text3 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
            </button>
          </div>
          <button onClick={openAdd} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Mode
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>
      ) : viewMode === 'list' ? (
        /* ── LIST VIEW ── */
        <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, overflow:'hidden', boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                {['Mode','Key','Status','Actions'].map(h => (
                  <th key={h} style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {modes.length === 0 ? (
                <tr><td colSpan="4" style={{ padding:'48px 20px', textAlign:'center', color:T.text3, fontSize:13 }}>No payment modes yet. Click Add Mode to create one.</td></tr>
              ) : modes.map((m,i) => (
                <tr key={m.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), opacity:m.is_active?1:0.6, transition:'background 0.15s' }}
                  onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                  onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                  <td style={{ padding:'12px 20px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ width:36, height:36, borderRadius:10, background:['#0f1f45','#3b82f6','#10b981','#f59e0b','#8b5cf6','#ef4444','#ec4899','#06b6d4'][i%8], display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:14, fontWeight:700, flexShrink:0 }}>
                        {m.name.charAt(0)}
                      </div>
                      <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{m.name}</p>
                    </div>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <code style={{ fontSize:12, color:T.text3, background:T.bg3, padding:'2px 8px', borderRadius:6, border:`1px solid ${T.border}` }}>{m.value}</code>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <button onClick={() => handleToggle(m)} style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, cursor:'pointer', border:'1px solid',
                      color:m.is_active?'#16a34a':T.text3,
                      background:m.is_active?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc'),
                      borderColor:m.is_active?(darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'):(darkMode?T.border:T.border2) }}>
                      {m.is_active ? 'Active' : 'Inactive'}
                    </button>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                      <button onClick={() => openEdit(m)}
                        style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>{e.currentTarget.style.background=T.bg3;e.currentTarget.style.color=T.text2;}}
                        onMouseLeave={e=>{e.currentTarget.style.background='none';e.currentTarget.style.color=T.text3;}}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      </button>
                      <button onClick={() => handleDelete(m.id)}
                        style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:'#ef4444', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                        onMouseLeave={e=>e.currentTarget.style.background='none'}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        /* ── GRID VIEW ── */
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12 }}>
          {modes.map((m,i) => (
            <div key={m.id} style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, padding:16, opacity:m.is_active?1:0.5, transition:'box-shadow 0.15s' }}
              onMouseEnter={e=>e.currentTarget.style.boxShadow=darkMode?'0 4px 16px rgba(0,0,0,0.3)':'0 4px 12px rgba(15,31,69,0.08)'}
              onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
                <div style={{ width:36, height:36, borderRadius:10, background:['#0f1f45','#3b82f6','#10b981','#f59e0b','#8b5cf6','#ef4444','#ec4899','#06b6d4'][i%8], display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:14, fontWeight:700 }}>
                  {m.name.charAt(0)}
                </div>
                <button onClick={() => handleToggle(m)} style={{ fontSize:11, fontWeight:600, padding:'2px 9px', borderRadius:20, cursor:'pointer', border:'1px solid', color:m.is_active?'#16a34a':T.text3, background:m.is_active?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc'), borderColor:m.is_active?(darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'):(darkMode?T.border:T.border2) }}>
                  {m.is_active ? 'Active' : 'Inactive'}
                </button>
              </div>
              <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:'0 0 3px' }}>{m.name}</p>
              <code style={{ fontSize:11, color:T.text3, fontFamily:'monospace' }}>{m.value}</code>
              <div style={{ display:'flex', gap:8, marginTop:12 }}>
                <button onClick={() => openEdit(m)} style={{ flex:1, padding:'6px 0', borderRadius:8, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:12, fontWeight:500, cursor:'pointer' }}
                  onMouseEnter={e=>e.currentTarget.style.background=T.bg3}
                  onMouseLeave={e=>e.currentTarget.style.background=T.bg2}>Edit</button>
                <button onClick={() => handleDelete(m.id)} style={{ padding:'6px 12px', borderRadius:8, border:`1px solid ${darkMode?'rgba(239,68,68,0.25)':'#fecaca'}`, background:darkMode?'rgba(239,68,68,0.08)':'#fef2f2', color:'#ef4444', fontSize:12, cursor:'pointer' }}
                  onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.15)':'#fee2e2'}
                  onMouseLeave={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.08)':'#fef2f2'}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:50, padding:16 }}>
          <div style={{ background:T.bg2, borderRadius:20, width:'100%', maxWidth:420, boxShadow:darkMode?'0 24px 60px rgba(0,0,0,0.6)':'0 24px 60px rgba(15,31,69,0.2)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 28px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:'20px 20px 0 0' }}>
              <h3 style={{ fontSize:15, fontWeight:700, color:'#fff', margin:0 }}>{editItem?'Edit':'Add'} Payment Mode</h3>
              <button onClick={()=>setShowForm(false)} style={{ width:30, height:30, borderRadius:8, border:'none', background:'rgba(255,255,255,0.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding:'20px 28px', background:T.bg3, display:'flex', flexDirection:'column', gap:16 }}>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Display Name *</label>
                <input type="text" placeholder="e.g. Bank Transfer, UPI" value={form.name}
                  onChange={e => { const name=e.target.value; setForm(f=>({...f,name,value:editItem?f.value:name.toLowerCase().replace(/\s+/g,'_')})); }} style={is} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Value (system key)</label>
                <input type="text" placeholder="e.g. bank_transfer" value={form.value}
                  onChange={e=>setForm(f=>({...f,value:e.target.value.toLowerCase().replace(/\s+/g,'_')}))} style={is} />
                <p style={{ fontSize:11, color:T.text3, marginTop:4 }}>Auto-generated from name. Used internally.</p>
              </div>
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:12, padding:'14px 28px', borderTop:`1px solid ${T.border}`, background:T.bg2, borderRadius:'0 0 20px 20px' }}>
              <button onClick={()=>setShowForm(false)} style={{ padding:'9px 20px', borderRadius:10, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
              <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 22px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
                {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── BANK ACCOUNTS — the firm's own list of real bank accounts. Kept
// deliberately separate from Payment Modes: a Payment Mode (NEFT/UPI/Cheque/
// Card/...) is just a descriptive note on HOW money moved, optional on every
// Receipt/Expense; a Bank Account is WHERE it actually moved (or "Cash" if
// nowhere), mandatory on those same forms. Finance and Accounting's Bank
// Statements are deliberately NOT auto-linked — picking a Bank Account here
// never creates or changes anything on a Bank Statement; matching a
// Receipt/Expense to an imported statement row is always a manual, explicit
// step from the Bank Statements tab itself. ────────────────────────────────
function BankAccountsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type':'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving, setSaving] = useState(false);
  const EMPTY_FORM = { bank_name:'', nickname:'', account_name:'', account_number:'', account_type:'', ifsc_code:'', branch_area:'', upi_id:'', opening_balance:'' };
  const [form, setForm] = useState(EMPTY_FORM);
  const [paymentModes, setPaymentModes] = useState([]);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/bank/accounts`, { headers });
      const d = await r.json();
      setAccounts(Array.isArray(d) ? d : []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);
  useEffect(() => {
    fetch(`${BASE}/api/payment-modes`, { headers }).then(r => r.json())
      .then(d => setPaymentModes(Array.isArray(d) ? d : [])).catch(() => {});
  }, [token]);
  const openAdd  = () => { setEditItem(null); setForm(EMPTY_FORM); setShowForm(true); };
  const openEdit = (a) => { setEditItem(a); setForm({
    bank_name:a.bank_name, nickname:a.nickname||'', account_name:a.account_name||'', account_number:a.account_number||'',
    account_type:a.account_type||'', ifsc_code:a.ifsc_code||'', branch_area:a.branch_area||'', upi_id:a.upi_id||'',
    opening_balance:a.opening_balance != null ? String(a.opening_balance) : '', is_active:a.is_active,
  }); setShowForm(true); };

  const handleSave = async () => {
    if (!form.bank_name.trim()) return showToast('Bank name is required');
    setSaving(true);
    try {
      const url    = editItem ? `${BASE}/api/bank/accounts/${editItem.id}` : `${BASE}/api/bank/accounts`;
      const method = editItem ? 'PUT' : 'POST';
      const res    = await fetch(url, { method, headers:jh, body:JSON.stringify(form) });
      if (!res.ok) { const d=await res.json(); return showToast(d.message||'Error'); }
      setShowForm(false); fetchAll();
    } catch(e) { showToast('Error'); }
    finally { setSaving(false); }
  };

  const handleToggle = async (a) => {
    await fetch(`${BASE}/api/bank/accounts/${a.id}`, {
      method:'PUT', headers:jh,
      body: JSON.stringify({ ...a, is_active: !a.is_active })
    });
    fetchAll();
  };

  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this bank account? Its statement transactions and matching stay, but new Receipts/Expenses can no longer select it.')) return;
    await fetch(`${BASE}/api/bank/accounts/${id}`, { method:'DELETE', headers });
    fetchAll();
  };

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Bank Accounts</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Select which bank a Receipt or Expense actually moved through — separate from Payment Mode</p>
        </div>
        <button onClick={openAdd} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Bank Account
        </button>
      </div>

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>
      ) : (
        <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, overflow:'hidden', boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                {['Bank','Account','Status','Actions'].map(h => (
                  <th key={h} style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {accounts.length === 0 ? (
                <tr><td colSpan="4" style={{ padding:'48px 20px', textAlign:'center', color:T.text3, fontSize:13 }}>No bank accounts yet. Click Add Bank Account to create one.</td></tr>
              ) : accounts.map((a,i) => (
                <tr key={a.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), opacity:a.is_active?1:0.6, transition:'background 0.15s' }}
                  onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                  onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                  <td style={{ padding:'12px 20px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ width:36, height:36, borderRadius:10, background:['#0f1f45','#3b82f6','#10b981','#f59e0b','#8b5cf6','#ef4444','#ec4899','#06b6d4'][i%8], display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:14, fontWeight:700, flexShrink:0 }}>
                        {a.bank_name.charAt(0)}
                      </div>
                      <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{a.bank_name}</p>
                    </div>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <div>
                      <span style={{ fontSize:12.5, color:T.text2 }}>{a.nickname || '—'}</span>
                      {a.account_last4 && <code style={{ fontSize:12, color:T.text3, background:T.bg3, padding:'2px 8px', borderRadius:6, border:`1px solid ${T.border}`, marginLeft:8 }}>••{a.account_last4}</code>}
                      {a.account_type && <span style={{ fontSize:11, fontWeight:600, color:T.text3, marginLeft:8, textTransform:'capitalize' }}>{a.account_type}</span>}
                    </div>
                    {(a.ifsc_code || a.branch_area) && (
                      <p style={{ fontSize:11, color:T.text3, margin:'3px 0 0' }}>{[a.ifsc_code, a.branch_area].filter(Boolean).join(' · ')}</p>
                    )}
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <button onClick={() => handleToggle(a)} style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, cursor:'pointer', border:'1px solid',
                      color:a.is_active?'#16a34a':T.text3,
                      background:a.is_active?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc'),
                      borderColor:a.is_active?(darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'):(darkMode?T.border:T.border2) }}>
                      {a.is_active ? 'Active' : 'Inactive'}
                    </button>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                      <button onClick={() => openEdit(a)}
                        style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>{e.currentTarget.style.background=T.bg3;e.currentTarget.style.color=T.text2;}}
                        onMouseLeave={e=>{e.currentTarget.style.background='none';e.currentTarget.style.color=T.text3;}}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      </button>
                      <button onClick={() => handleDelete(a.id)}
                        style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:'#ef4444', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                        onMouseLeave={e=>e.currentTarget.style.background='none'}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:50, padding:16 }}>
          <div style={{ background:T.bg2, borderRadius:20, width:'100%', maxWidth:560, maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:darkMode?'0 24px 60px rgba(0,0,0,0.6)':'0 24px 60px rgba(15,31,69,0.2)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 28px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:'20px 20px 0 0', flexShrink:0 }}>
              <h3 style={{ fontSize:15, fontWeight:700, color:'#fff', margin:0 }}>{editItem?'Edit':'Add'} Bank Account</h3>
              <button onClick={()=>setShowForm(false)} style={{ width:30, height:30, borderRadius:8, border:'none', background:'rgba(255,255,255,0.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding:'20px 28px', background:T.bg3, display:'flex', flexDirection:'column', gap:16, overflowY:'auto' }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Bank Name *</label>
                  <input type="text" placeholder="e.g. ICICI Bank" value={form.bank_name}
                    onChange={e => setForm(f=>({...f,bank_name:e.target.value}))} style={is} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Nickname</label>
                  <input type="text" placeholder="e.g. Current Account" value={form.nickname}
                    onChange={e=>setForm(f=>({...f,nickname:e.target.value}))} style={is} />
                </div>
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Account Name</label>
                <input type="text" placeholder="Name on the account" value={form.account_name}
                  onChange={e=>setForm(f=>({...f,account_name:e.target.value}))} style={is} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Account No.</label>
                  <input type="text" placeholder="Full account number" value={form.account_number}
                    onChange={e=>setForm(f=>({...f,account_number:e.target.value.replace(/\s+/g,'')}))} style={is} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Type of Account</label>
                  <select value={form.account_type} onChange={e=>setForm(f=>({...f,account_type:e.target.value}))} style={is}>
                    <option value="">Select...</option>
                    <option value="savings">Savings</option>
                    <option value="current">Current</option>
                    <option value="cc">Cash Credit (CC)</option>
                    <option value="od">Overdraft (OD)</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>IFSC Code</label>
                  <input type="text" placeholder="e.g. ICIC0001234" value={form.ifsc_code}
                    onChange={e=>setForm(f=>({...f,ifsc_code:e.target.value.toUpperCase()}))} style={is} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Branch / Area</label>
                  <input type="text" placeholder="e.g. Connaught Place" value={form.branch_area}
                    onChange={e=>setForm(f=>({...f,branch_area:e.target.value}))} style={is} />
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>UPI ID</label>
                  <input type="text" placeholder="e.g. firm@icici" value={form.upi_id}
                    onChange={e=>setForm(f=>({...f,upi_id:e.target.value}))} style={is} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Opening Balance (₹)</label>
                  <input type="number" step="0.01" placeholder="0.00" value={form.opening_balance}
                    onChange={e=>setForm(f=>({...f,opening_balance:e.target.value}))} style={is} />
                </div>
              </div>
              <p style={{ fontSize:11, color:T.text3 }}>Once added, this bank appears as a "Bank Account" option on Receipts and Expenses. Opening Balance is what this account held before any transaction tracked here — used to compute the running Balance column on Bank Statements.</p>
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:12, padding:'14px 28px', borderTop:`1px solid ${T.border}`, background:T.bg2, borderRadius:'0 0 20px 20px', flexShrink:0 }}>
              <button onClick={()=>setShowForm(false)} style={{ padding:'9px 20px', borderRadius:10, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
              <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 22px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
                {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

function RenewalTypesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jsonHeaders = { 'Content-Type': 'application/json', ...headers };
  const { showConfirm } = useToast();

  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [newName, setNewName] = useState('');
  const [editItem, setEditItem] = useState(null);
  const [editName, setEditName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [openKebab, setOpenKebab] = useState(null);
  const [kebabPos, setKebabPos] = useState({ top:0, right:0 });

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE}/api/renewal-types/all`, { headers });
      const data = await res.json();
      setTypes(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setTypes([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const handleAdd = async () => {
    if (!newName.trim()) {
      setError('Please enter renewal type name');
      return;
    }

    setSaving(true);
    setError('');

    try {
      const res = await fetch(`${BASE}/api/renewal-types`, {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ name: newName.trim() })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Could not add renewal type');
        return;
      }

      setNewName('');
      setShowAdd(false);
      fetchAll();
    } catch (err) {
      console.error(err);
      setError('Network error. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = async (id) => {
    if (!editName.trim()) return;

    await fetch(`${BASE}/api/renewal-types/${id}`, {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify({ name: editName.trim(), is_active: true })
    });

    setEditItem(null);
    setEditName('');
    fetchAll();
  };

  const handleToggle = async (type) => {
    await fetch(`${BASE}/api/renewal-types/${type.id}`, {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify({
        name: type.name,
        is_active: !type.is_active
      })
    });

    fetchAll();
  };

  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this renewal type?')) return;

    await fetch(`${BASE}/api/renewal-types/${id}`, {
      method: 'DELETE',
      headers
    });

    fetchAll();
  };

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Renewal Types</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Create your own renewal types. These will appear inside Client Renewals.</p>
        </div>
        <button onClick={() => { setShowAdd(true); setError(''); }}
          style={{ padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
          + Add Renewal Type
        </button>
      </div>

      {showAdd && (
        <div style={{ background:T.bg3, border:`1px solid ${T.border}`, borderRadius:12, padding:16, marginBottom:20 }}>
          <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:8, textTransform:'uppercase', letterSpacing:'0.05em' }}>Renewal Type Name</label>
          <div style={{ display:'flex', gap:10 }}>
            <input type="text" placeholder="Example: DSC, Trade License, FSSAI, Pollution Certificate"
              value={newName} onChange={e => { setNewName(e.target.value); setError(''); }}
              onKeyDown={e => e.key==='Enter' && handleAdd()}
              style={{ ...is, flex:1 }} autoFocus />
            <button onClick={handleAdd} disabled={saving}
              style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, cursor:'pointer', opacity:saving?0.6:1 }}>
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button onClick={() => { setShowAdd(false); setNewName(''); setError(''); }}
              style={{ padding:'9px 16px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>
              Cancel
            </button>
          </div>
          {error && <p style={{ fontSize:12, color:'#ef4444', marginTop:6 }}>{error}</p>}
        </div>
      )}

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>
      ) : (
        <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, overflow:'hidden', boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                {['Renewal Type','Status','Actions'].map(h => (
                  <th key={h} style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {types.length === 0 ? (
                <tr><td colSpan="3" style={{ padding:'48px 20px', textAlign:'center', color:T.text3, fontSize:13 }}>No renewal types yet. Click Add Renewal Type to create your own.</td></tr>
              ) : types.map((type, i) => (
                <tr key={type.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), transition:'background 0.15s' }}
                  onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                  onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                  <td style={{ padding:'12px 20px' }}>
                    {editItem === type.id ? (
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <input type="text" value={editName} onChange={e=>setEditName(e.target.value)}
                          style={{ ...is, flex:1 }} autoFocus />
                        <button onClick={() => handleEdit(type.id)}
                          style={{ padding:'6px 12px', borderRadius:8, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:12, cursor:'pointer' }}>Save</button>
                        <button onClick={() => setEditItem(null)}
                          style={{ padding:'6px 12px', borderRadius:8, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:12, cursor:'pointer' }}>Cancel</button>
                      </div>
                    ) : (
                      <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{type.name}</p>
                    )}
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <button onClick={() => handleToggle(type)} style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, cursor:'pointer', border:'1px solid',
                      color:type.is_active?'#16a34a':T.text3,
                      background:type.is_active?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc'),
                      borderColor:type.is_active?(darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'):(darkMode?T.border:T.border2) }}>
                      {type.is_active ? 'Active' : 'Inactive'}
                    </button>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <div style={{ position:'relative', display:'inline-block' }}>
                      <button onClick={e=>{ e.stopPropagation(); setOpenKebab(openKebab===type.id?null:type.id); }}
                        style={{ width:28, height:28, borderRadius:8, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>e.currentTarget.style.background=T.bg3}
                        onMouseLeave={e=>e.currentTarget.style.background=T.bg2}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                      </button>
                      {openKebab === type.id && (
                        <div style={{ position:'absolute', right:0, top:32, background:T.bg2, border:`1px solid ${T.border2}`, borderRadius:10, boxShadow:darkMode?'0 8px 24px rgba(0,0,0,0.4)':'0 8px 24px rgba(15,31,69,0.12)', zIndex:999, minWidth:130, overflow:'hidden' }}
                          onMouseLeave={()=>setOpenKebab(null)}>
                          <button onClick={()=>{ setEditItem(type.id); setEditName(type.name); setOpenKebab(null); }}
                            style={{ width:'100%', padding:'9px 14px', textAlign:'left', fontSize:13, color:T.text2, background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', gap:8 }}
                            onMouseEnter={e=>e.currentTarget.style.background=T.bg3}
                            onMouseLeave={e=>e.currentTarget.style.background='none'}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                            Edit
                          </button>
                          <button onClick={()=>{ handleDelete(type.id); setOpenKebab(null); }}
                            style={{ width:'100%', padding:'9px 14px', textAlign:'left', fontSize:13, color:'#ef4444', background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', gap:8, borderTop:`1px solid ${T.border}` }}
                            onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.1)':'#fef2f2'}
                            onMouseLeave={e=>e.currentTarget.style.background='none'}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function HRSettingsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type':'application/json', ...headers };

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [showForm,   setShowForm]   = useState(false);
  const [editItem,   setEditItem]   = useState(null);
  const [saving,     setSaving]     = useState(false);
  const { showToast, showConfirm } = useToast();
  const [form, setForm] = useState({
    name:'', code:'', days_per_year:0, is_paid:true, carry_forward:false, is_active:true,
    allowed_from:'', allowed_to:'', min_notice_days:0, max_consecutive:0, pro_rate_on_join:true,
    pay_on_approval:false
  });

  // ── Firm leave policy (monthly free leaves, leave year) ──────────────────
  const MONTHS_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const [policy, setPolicy] = useState({ monthly_paid_leaves:2, leave_year_start_month:1 });
  const [policySaving, setPolicySaving] = useState(false);
  const [rebuilding, setRebuilding] = useState(false);

  const fetchTypes = useCallback(async () => {
    setLoading(true);
    try {
      const [r, pr] = await Promise.all([
        fetch(`${BASE}/api/employees/leave-types`, { headers }),
        fetch(`${BASE}/api/attendance-settings`, { headers }),
      ]);
      const d = await r.json();
      setLeaveTypes(Array.isArray(d) ? d : []);
      const p = await pr.json();
      setPolicy({
        monthly_paid_leaves:    p.monthly_paid_leaves    != null ? Number(p.monthly_paid_leaves)    : 2,
        leave_year_start_month: p.leave_year_start_month  != null ? Number(p.leave_year_start_month) : 1,
      });
    } catch(e) { console.error('Fetch error:', e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchTypes(); }, [fetchTypes]);

  const savePolicy = async () => {
    setPolicySaving(true);
    try {
      const res = await fetch(`${BASE}/api/attendance-settings`, {
        method:'PUT', headers:jh, body:JSON.stringify(policy)
      });
      if (!res.ok) return showToast('Error saving policy', 'error');
      showToast('Leave policy saved', 'success');
    } catch(e) { showToast('Error saving policy', 'error'); }
    finally { setPolicySaving(false); }
  };

  const rebuildBalances = async () => {
    if (!(await showConfirm('Rebuild leave balances for all active employees for the current leave year? Manually-adjusted balances are kept.', { title:'Rebuild Balances', confirmLabel:'Rebuild' }))) return;
    setRebuilding(true);
    try {
      const res = await fetch(`${BASE}/api/employees/leaves/balances/init`, { method:'POST', headers:jh, body:'{}' });
      const d = await res.json();
      showToast(res.ok ? `Balances rebuilt for ${d.year}` : (d.message||'Error'), res.ok ? 'success' : 'error');
    } catch(e) { showToast('Error', 'error'); }
    finally { setRebuilding(false); }
  };

  const openAdd = () => {
    setEditItem(null);
    setForm({ name:'', code:'', days_per_year:0, is_paid:true, carry_forward:false, is_active:true,
      allowed_from:'', allowed_to:'', min_notice_days:0, max_consecutive:0, pro_rate_on_join:true,
      pay_on_approval:false });
    setShowForm(true);
  };

  const openEdit = (lt) => {
    setEditItem(lt);
    setForm({
      name: lt.name, code: lt.code,
      days_per_year: lt.days_per_year,
      is_paid: lt.is_paid, carry_forward: lt.carry_forward,
      is_active: lt.is_active,
      allowed_from: lt.allowed_from || '', allowed_to: lt.allowed_to || '',
      min_notice_days: lt.min_notice_days || 0, max_consecutive: lt.max_consecutive || 0,
      pro_rate_on_join: lt.pro_rate_on_join !== false,
      pay_on_approval: lt.pay_mode === 'on_approval'
    });
    setShowForm(true);
  };

  const handleSave = async () => {
    if (!form.name || !form.code) return showToast('Name and Code are required', 'error');
    if (!/^[A-Z]{2,3}$/.test(form.code)) return showToast('Code must be exactly 2 or 3 letters', 'error');
    if ((form.allowed_from && !form.allowed_to) || (!form.allowed_from && form.allowed_to))
      return showToast('Set both start and end of the application window, or leave both blank', 'error');
    setSaving(true);
    try {
      const url    = editItem ? `${BASE}/api/employees/leave-types/${editItem.id}` : `${BASE}/api/employees/leave-types`;
      const method = editItem ? 'PUT' : 'POST';
      const payload = { ...form, pay_mode: form.pay_on_approval ? 'on_approval' : 'by_type' };
      const res    = await fetch(url, { method, headers:jh, body:JSON.stringify(payload) });
      const d = await res.json();
      if (!res.ok) return showToast(d.message||'Error saving', 'error');
      setShowForm(false);
      showToast(editItem ? 'Leave type updated' : 'Leave type added', 'success');
      fetchTypes();
    } catch(e) { showToast('Error saving', 'error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!(await showConfirm('Delete this leave type? This cannot be undone.', { title:'Delete Leave Type', confirmLabel:'Delete' }))) return;
    await fetch(`${BASE}/api/employees/leave-types/${id}`, { method:'DELETE', headers });
    showToast('Leave type deleted', 'success');
    fetchTypes();
  };

  const handleToggle = async (lt) => {
    await fetch(`${BASE}/api/employees/leave-types/${lt.id}`, {
      method:'PUT', headers:jh,
      body: JSON.stringify({ ...lt, is_active: !lt.is_active })
    });
    fetchTypes();
  };

  return (
    <div>
      {/* ── Firm Leave Policy ── */}
      <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, marginBottom:22, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 1px 4px rgba(15,31,69,0.05)' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
          <div>
            <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Leave Policy</h3>
            <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Firm-wide rules that drive payroll deductions</p>
          </div>
          <div style={{ display:'flex', gap:10 }}>
            <button onClick={rebuildBalances} disabled={rebuilding} style={{ padding:'8px 14px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:12.5, fontWeight:600, cursor:'pointer', opacity:rebuilding?0.6:1 }}>
              {rebuilding ? 'Rebuilding…' : 'Rebuild Balances'}
            </button>
            <button onClick={savePolicy} disabled={policySaving} style={{ padding:'8px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:12.5, fontWeight:600, cursor:'pointer', opacity:policySaving?0.6:1 }}>
              {policySaving ? 'Saving…' : 'Save Policy'}
            </button>
          </div>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2,minmax(0,320px))', gap:18 }}>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Free leaves per month</label>
            <input type="number" min={0} max={31} value={policy.monthly_paid_leaves}
              onChange={e=>setPolicy(p=>({...p, monthly_paid_leaves:Number(e.target.value)}))}
              style={{ width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' }} />
            <p style={{ fontSize:11, color:T.text3, margin:'6px 0 0' }}>Absences / unpaid leave up to this many days a month are not deducted. Weekly-offs &amp; public holidays never count. Resets each month.</p>
          </div>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Leave year starts in</label>
            <select value={policy.leave_year_start_month}
              onChange={e=>setPolicy(p=>({...p, leave_year_start_month:Number(e.target.value)}))}
              style={{ width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text }}>
              {MONTHS_FULL.map((m,i) => <option key={i} value={i+1}>{m}</option>)}
            </select>
            <p style={{ fontSize:11, color:T.text3, margin:'6px 0 0' }}>January = standard calendar-year leave cycle. Annual quotas reset on the 1st of this month.</p>
          </div>
        </div>
      </div>

      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Leave Types</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Annual quota per type · paid types don't deduct while balance lasts</p>
        </div>
        <button onClick={openAdd} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Leave Type
        </button>
      </div>

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>
      ) : (
        <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, overflow:'hidden', boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                {['Leave Type','Code','Days/Year','Window','Paid','Carry Forward','Status','Actions'].map(h => (
                  <th key={h} style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em', whiteSpace:'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {leaveTypes.length === 0 ? (
                <tr><td colSpan="8" style={{ padding:'48px 20px', textAlign:'center', color:T.text3, fontSize:13 }}>No leave types configured</td></tr>
              ) : leaveTypes.map((lt,i) => (
                <tr key={lt.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), transition:'background 0.15s' }}
                  onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                  onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                  <td style={{ padding:'12px 20px' }}>
                    <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{lt.name}</p>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <span style={{ fontSize:12, fontWeight:700, padding:'2px 8px', borderRadius:6, background:darkMode?'rgba(37,99,235,0.15)':'#eff6ff', color:'#2563eb', fontFamily:'monospace', border:`1px solid ${darkMode?'rgba(37,99,235,0.25)':'#bfdbfe'}` }}>{lt.code}</span>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <span style={{ fontSize:13, fontWeight:700, color:T.text }}>{lt.days_per_year}</span>
                    <span style={{ fontSize:11, color:T.text3, marginLeft:4 }}>days</span>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    {lt.allowed_from && lt.allowed_to
                      ? <span style={{ fontSize:11, fontWeight:600, color:T.text2, fontFamily:'monospace' }}>{lt.allowed_from} → {lt.allowed_to}</span>
                      : <span style={{ fontSize:11, color:T.text3 }}>Any time</span>}
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    {lt.pay_mode === 'on_approval' ? (
                      <span style={{ fontSize:11, fontWeight:600, padding:'2px 8px', borderRadius:20, color:'#7c3aed', background:darkMode?'rgba(124,58,237,0.12)':'#f5f3ff' }}>Per approval</span>
                    ) : (
                      <span style={{ fontSize:11, fontWeight:600, padding:'2px 8px', borderRadius:20,
                        color:lt.is_paid?'#16a34a':T.text3,
                        background:lt.is_paid?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc') }}>
                        {lt.is_paid ? 'Paid' : 'Unpaid'}
                      </span>
                    )}
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <span style={{ fontSize:11, fontWeight:600, padding:'2px 8px', borderRadius:20,
                      color:lt.carry_forward?'#7c3aed':T.text3,
                      background:lt.carry_forward?(darkMode?'rgba(124,58,237,0.12)':'#f5f3ff'):(darkMode?T.bg3:'#f8fafc') }}>
                      {lt.carry_forward ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <button onClick={() => handleToggle(lt)} style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, cursor:'pointer', border:'1px solid',
                      color:lt.is_active?'#16a34a':T.text3,
                      background:lt.is_active?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc'),
                      borderColor:lt.is_active?(darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'):(darkMode?T.border:T.border2) }}>
                      {lt.is_active ? 'Active' : 'Inactive'}
                    </button>
                  </td>
                  <td style={{ padding:'12px 20px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                      <button onClick={() => openEdit(lt)}
                        style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>{e.currentTarget.style.background=T.bg3;e.currentTarget.style.color=T.text2;}}
                        onMouseLeave={e=>{e.currentTarget.style.background='none';e.currentTarget.style.color=T.text3;}}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      </button>
                      <button onClick={() => handleDelete(lt.id)}
                        style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:'#ef4444', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                        onMouseLeave={e=>e.currentTarget.style.background='none'}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:50, padding:16 }}>
          <div style={{ background:T.bg2, borderRadius:20, width:'100%', maxWidth:480, boxShadow:darkMode?'0 24px 60px rgba(0,0,0,0.6)':'0 24px 60px rgba(15,31,69,0.2)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 28px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:'20px 20px 0 0' }}>
              <div>
                <h3 style={{ fontSize:15, fontWeight:700, color:'#fff', margin:0 }}>{editItem ? 'Edit Leave Type' : 'Add Leave Type'}</h3>
                <p style={{ fontSize:12, color:'rgba(255,255,255,0.6)', margin:'3px 0 0' }}>Configure leave policy details</p>
              </div>
              <button onClick={()=>setShowForm(false)} style={{ width:30, height:30, borderRadius:8, border:'none', background:'rgba(255,255,255,0.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding:'20px 28px', background:T.bg3, display:'flex', flexDirection:'column', gap:16 }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                <div style={{ gridColumn:'span 2' }}>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Leave Type Name *</label>
                  <input type="text" placeholder="e.g. Casual Leave, Maternity Leave" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} style={is} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Code * (2–3 letters)</label>
                  <input type="text" placeholder="e.g. CL, SL, PL" maxLength={3} value={form.code}
                    onChange={e=>setForm(f=>({...f,code:e.target.value.replace(/[^a-zA-Z]/g,'').toUpperCase().slice(0,3)}))}
                    style={{ ...is, border:`1px solid ${form.code && !/^[A-Z]{2,3}$/.test(form.code) ? '#f87171' : T.inputBorder}` }} />
                  <p style={{ fontSize:10.5, color: form.code && !/^[A-Z]{2,3}$/.test(form.code) ? '#dc2626' : T.text3, margin:'4px 0 0' }}>
                    {form.code && !/^[A-Z]{2,3}$/.test(form.code) ? 'Must be exactly 2 or 3 letters' : 'Shown on the attendance sheet (e.g. CL, PL). Must be unique.'}
                  </p>
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Days per Year</label>
                  <input type="number" min={0} max={365} placeholder="12" value={form.days_per_year} onChange={e=>setForm(f=>({...f,days_per_year:Number(e.target.value)}))} style={is} />
                </div>
              </div>
              <div style={{ borderTop:`1px solid ${T.border}`, paddingTop:16 }}>
                <p style={{ fontSize:11, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.05em', margin:'0 0 4px' }}>Application Rules</p>
                <p style={{ fontSize:11, color:T.text3, margin:'0 0 12px' }}>Leave both window dates blank to allow this leave any time of year.</p>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Window Opens</label>
                    <input type="date" value={form.allowed_from ? `2000-${form.allowed_from}` : ''}
                      onChange={e=>setForm(f=>({...f, allowed_from: e.target.value ? e.target.value.slice(5) : ''}))} style={is} />
                  </div>
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Window Closes</label>
                    <input type="date" value={form.allowed_to ? `2000-${form.allowed_to}` : ''}
                      onChange={e=>setForm(f=>({...f, allowed_to: e.target.value ? e.target.value.slice(5) : ''}))} style={is} />
                  </div>
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Min. Notice (days)</label>
                    <input type="number" min={0} value={form.min_notice_days} onChange={e=>setForm(f=>({...f, min_notice_days:Number(e.target.value)}))} style={is} />
                  </div>
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Max Consecutive (days)</label>
                    <input type="number" min={0} value={form.max_consecutive} onChange={e=>setForm(f=>({...f, max_consecutive:Number(e.target.value)}))} style={is} />
                  </div>
                </div>
                <p style={{ fontSize:11, color:T.text3, margin:'8px 0 0' }}>0 = no limit. A window that closes before it opens (e.g. Dec → Feb) is treated as spanning year-end.</p>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12 }}>
                {[
                  { key:'is_paid',          label: form.pay_on_approval ? 'Paid Leave (ignored — see below)' : 'Paid Leave (no deduction)' },
                  { key:'pay_on_approval',  label:'Decide pay at approval (Paid / Half / Unpaid)' },
                  { key:'pro_rate_on_join', label:'Pro-rate for mid-year joiners' },
                  { key:'carry_forward',    label:'Carry Forward' },
                  { key:'is_active',        label:'Active'        },
                ].map(f => (
                  <div key={f.key} style={{ display:'flex', alignItems:'center', gap:10, background:T.bg2, border:`1px solid ${T.border}`, borderRadius:10, padding:'10px 14px' }}>
                    <div style={{ position:'relative', display:'inline-flex', alignItems:'center', cursor:'pointer' }} onClick={()=>setForm(ff=>({...ff,[f.key]:!form[f.key]}))}>
                      <div style={{ width:36, height:20, borderRadius:10, background:form[f.key]?'#3b82f6':(darkMode?'#334155':'#d1d5db'), position:'relative', transition:'background 0.2s', cursor:'pointer' }}>
                        <div style={{ position:'absolute', top:2, left:form[f.key]?18:2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
                      </div>
                    </div>
                    <span style={{ fontSize:12, fontWeight:500, color:T.text2 }}>{f.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:12, padding:'14px 28px', borderTop:`1px solid ${T.border}`, background:T.bg2, borderRadius:'0 0 20px 20px' }}>
              <button onClick={()=>setShowForm(false)} style={{ padding:'9px 20px', borderRadius:10, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
              <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 24px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
                {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
                {saving ? 'Saving...' : editItem ? 'Save Changes' : 'Add Leave Type'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── DOCUMENT TYPES SECTION ────────────────────────────────────────────────────
const DOC_CATEGORIES = ['Identity','Business','Tax','Financial','Legal','Other'];

function DocumentTypesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [docs,     setDocs]     = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving,   setSaving]   = useState(false);
  const [filter,   setFilter]   = useState('all');
  const [form, setForm] = useState({ name: '', category: 'General' });

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/document-types`, { headers });
      const d = await r.json();
      setDocs(Array.isArray(d) ? d : []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const openAdd  = () => { setEditItem(null); setForm({ name: '', category: 'General' }); setShowForm(true); };
  const openEdit = (d) => { setEditItem(d); setForm({ name: d.name, category: d.category }); setShowForm(true); };

  const handleSave = async () => {
    if (!form.name.trim()) return showToast('Name is required');
    setSaving(true);
    try {
      const url    = editItem ? `${BASE}/api/document-types/${editItem.id}` : `${BASE}/api/document-types`;
      const method = editItem ? 'PUT' : 'POST';
      const res    = await fetch(url, { method, headers: jh, body: JSON.stringify(form) });
      const data   = await res.json();
      if (!res.ok) { showToast(data.message || 'Error'); return; }
      setShowForm(false); fetchAll();
    } catch(e) { showToast('Error saving'); }
    finally { setSaving(false); }
  };

  const handleToggle = async (d) => {
    await fetch(`${BASE}/api/document-types/${d.id}`, {
      method: 'PUT', headers: jh,
      body: JSON.stringify({ name: d.name, category: d.category, is_active: !d.is_active })
    });
    fetchAll();
  };

  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this document type?')) return;
    await fetch(`${BASE}/api/document-types/${id}`, { method: 'DELETE', headers });
    fetchAll();
  };

  const CAT_COLORS = {
    'Identity': { color:'#2563eb', bg: darkMode?'rgba(37,99,235,0.12)':'#eff6ff',   border: darkMode?'rgba(37,99,235,0.25)':'#bfdbfe'  },
    'Business': { color:'#7c3aed', bg: darkMode?'rgba(124,58,237,0.12)':'#f5f3ff', border: darkMode?'rgba(124,58,237,0.25)':'#ddd6fe' },
    'Tax':      { color:'#16a34a', bg: darkMode?'rgba(22,163,74,0.12)':'#f0fdf4',  border: darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'  },
    'Financial':{ color:'#d97706', bg: darkMode?'rgba(217,119,6,0.12)':'#fffbeb',  border: darkMode?'rgba(217,119,6,0.25)':'#fde68a'  },
    'Legal':    { color:'#dc2626', bg: darkMode?'rgba(220,38,38,0.12)':'#fef2f2',  border: darkMode?'rgba(220,38,38,0.25)':'#fecaca'  },
    'Other':    { color:'#64748b', bg: darkMode?'rgba(100,116,139,0.12)':'#f8fafc', border: darkMode?'rgba(100,116,139,0.25)':'#e2e8f0' },
    'General':  { color:'#64748b', bg: darkMode?'rgba(100,116,139,0.12)':'#f8fafc', border: darkMode?'rgba(100,116,139,0.25)':'#e2e8f0' },
  };

  const filtered = filter === 'all' ? docs : docs.filter(d => d.category === filter);
  const categories = ['all', ...DOC_CATEGORIES];

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Document Types</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>{docs.length} types · Used in Client → Documents tab</p>
        </div>
        <button onClick={openAdd} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Type
        </button>
      </div>

      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {categories.map(c => (
          <button key={c} onClick={() => setFilter(c)} style={{
            padding:'6px 14px', borderRadius:20, fontSize:12, fontWeight:600, cursor:'pointer', transition:'all 0.15s', textTransform:'capitalize',
            background: filter===c?(darkMode?'rgba(59,130,246,0.15)':'#eff6ff'):'transparent',
            color: filter===c?'#3b82f6':T.text3,
            border: filter===c?`1.5px solid ${darkMode?'rgba(59,130,246,0.3)':'#bfdbfe'}`:`1.5px solid ${T.border2}`,
          }}>
            {c==='all'?`All (${docs.length})`:`${c} (${docs.filter(d=>d.category===c).length})`}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>
      ) : (
        <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, overflow:'hidden', boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                {['Document Type','Category','Status','Actions'].map(h => (
                  <th key={h} style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan="4" style={{ padding:'48px 20px', textAlign:'center', color:T.text3, fontSize:13 }}>No document types found</td></tr>
              ) : filtered.map((d, i) => {
                const cc = CAT_COLORS[d.category] || CAT_COLORS['Other'];
                return (
                  <tr key={d.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), transition:'background 0.15s' }}
                    onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                    onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                    <td style={{ padding:'12px 20px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                        <div style={{ width:32, height:32, borderRadius:8, background:T.bg3, border:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                        </div>
                        <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{d.name}</p>
                      </div>
                    </td>
                    <td style={{ padding:'12px 20px' }}>
                      <span style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, color:cc.color, background:cc.bg, border:`1px solid ${cc.border}` }}>{d.category}</span>
                    </td>
                    <td style={{ padding:'12px 20px' }}>
                      <button onClick={() => handleToggle(d)} style={{
                        fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, cursor:'pointer', transition:'all 0.15s',
                        color: d.is_active?'#16a34a':T.text3,
                        background: d.is_active?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc'),
                        border:`1px solid ${d.is_active?(darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'):(darkMode?T.border:T.border2)}`,
                      }}>
                        {d.is_active ? 'Active' : 'Inactive'}
                      </button>
                    </td>
                    <td style={{ padding:'12px 20px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                        <button onClick={() => openEdit(d)}
                          style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                          onMouseEnter={e=>{e.currentTarget.style.background=T.bg3;e.currentTarget.style.color=T.text2;}}
                          onMouseLeave={e=>{e.currentTarget.style.background='none';e.currentTarget.style.color=T.text3;}}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                        </button>
                        <button onClick={() => handleDelete(d.id)}
                          style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:'#ef4444', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                          onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                          onMouseLeave={e=>e.currentTarget.style.background='none'}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:50, padding:16 }}>
          <div style={{ background:T.bg2, borderRadius:20, width:'100%', maxWidth:440, boxShadow:darkMode?'0 24px 60px rgba(0,0,0,0.6)':'0 24px 60px rgba(15,31,69,0.2)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 28px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:'20px 20px 0 0' }}>
              <div>
                <h3 style={{ fontSize:15, fontWeight:700, color:'#fff', margin:0 }}>{editItem?'Edit':'Add'} Document Type</h3>
                <p style={{ fontSize:12, color:'rgba(255,255,255,0.6)', margin:'3px 0 0' }}>Used in Client → Documents upload tab</p>
              </div>
              <button onClick={() => setShowForm(false)} style={{ width:30, height:30, borderRadius:8, border:'none', background:'rgba(255,255,255,0.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding:'20px 28px', background:T.bg3, display:'flex', flexDirection:'column', gap:16 }}>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Document Name *</label>
                <input type="text" placeholder="e.g. PAN Card, GST Certificate" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={is} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Category</label>
                <select value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} style={is}>
                  {DOC_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:12, padding:'14px 28px', borderTop:`1px solid ${T.border}`, background:T.bg2, borderRadius:'0 0 20px 20px' }}>
              <button onClick={() => setShowForm(false)} style={{ padding:'9px 20px', borderRadius:10, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
              <button onClick={handleSave} disabled={saving}
                className="px-6 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-50 flex items-center gap-2"
                style={{ background: '#0f1f45' }}>
                {saving && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"/>}
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── HOLIDAYS SECTION ──────────────────────────────────────────────────────────
function HolidaysSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const [holidays, setHolidays] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [year,     setYear]     = useState(new Date().getFullYear());
  const [form, setForm] = useState({ name: '', holiday_date: '', holiday_type: 'national' });
  const { showToast, showConfirm } = useToast();
  const YEARS = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - 2 + i);
  const TYPE_CFG = {
    national: { label:'National', color:'#dc2626', bg: darkMode?'rgba(220,38,38,0.12)':'#fef2f2', border: darkMode?'rgba(220,38,38,0.25)':'#fecaca' },
    regional: { label:'Regional', color:'#ea580c', bg: darkMode?'rgba(234,88,12,0.12)':'#fff7ed',  border: darkMode?'rgba(234,88,12,0.25)':'#fed7aa' },
    firm:     { label:'Firm',     color:'#2563eb', bg: darkMode?'rgba(37,99,235,0.12)':'#eff6ff',  border: darkMode?'rgba(37,99,235,0.25)':'#bfdbfe' },
  };
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/holidays?year=${year}`, { headers });
      const d = await r.json();
      setHolidays(Array.isArray(d) ? d : []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token, year]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleSave = async () => {
    if (!form.name.trim() || !form.holiday_date) return showToast('Name and date required', 'error');
    setSaving(true);
    try {
      const res  = await fetch(`${BASE}/api/holidays`, { method: 'POST', headers: jh, body: JSON.stringify(form) });
      const data = await res.json();
      if (!res.ok) { showToast(data.message || 'Error', 'error'); return; }
      setShowForm(false);
      setForm({ name: '', holiday_date: '', holiday_type: 'national' });
      showToast('Holiday added', 'success');
      fetchAll();
    } catch(e) { showToast('Error saving', 'error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!(await showConfirm('Remove this holiday?', { title:'Remove Holiday', confirmLabel:'Remove' }))) return;
    await fetch(`${BASE}/api/holidays/${id}`, { method: 'DELETE', headers });
    showToast('Holiday removed', 'success');
    fetchAll();
  };

  // Group by month
  const grouped = MONTHS.reduce((acc, m, i) => {
    const monthHols = holidays.filter(h => new Date(h.holiday_date).getMonth() === i);
    if (monthHols.length > 0) acc[m] = monthHols;
    return acc;
  }, {});

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Holidays List</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>{holidays.length} holidays for {year} · Used in HR Attendance</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <select value={year} onChange={e => setYear(Number(e.target.value))}
            style={{ border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'8px 12px', fontSize:13, background:T.inputBg, color:T.text, outline:'none' }}>
            {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button onClick={() => setShowForm(true)} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Holiday
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>
      ) : holidays.length === 0 ? (
        <div style={{ padding:'64px 0', textAlign:'center', border:`2px dashed ${T.border2}`, borderRadius:16 }}>
          <div style={{ width:56, height:56, background:T.bg3, borderRadius:16, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </div>
          <p style={{ fontSize:13, fontWeight:500, color:T.text2, margin:0 }}>No holidays for {year}</p>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Add national, regional or firm holidays</p>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          {Object.entries(grouped).map(([month, hols]) => (
            <div key={month} style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, overflow:'hidden' }}>
              <div style={{ padding:'10px 20px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderBottom:`1px solid ${T.border}` }}>
                <p style={{ fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.08em', margin:0 }}>{month} {year}</p>
              </div>
              {hols.map((h, i) => {
                const tc = TYPE_CFG[h.holiday_type] || TYPE_CFG.national;
                const d  = new Date(h.holiday_date);
                const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
                return (
                  <div key={h.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 20px', borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), transition:'background 0.15s' }}
                    onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                    onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                    <div style={{ display:'flex', alignItems:'center', gap:16 }}>
                      <div style={{ width:48, height:48, borderRadius:12, background:T.bg3, border:`1px solid ${T.border}`, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        <p style={{ fontSize:18, fontWeight:700, color:T.text, margin:0, lineHeight:1 }}>{d.getDate()}</p>
                        <p style={{ fontSize:11, color:T.text3, marginTop:2 }}>{days[d.getDay()]}</p>
                      </div>
                      <div>
                        <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{h.name}</p>
                        <span style={{ fontSize:11, fontWeight:600, padding:'2px 8px', borderRadius:20, marginTop:4, display:'inline-block', color:tc.color, background:tc.bg, border:`1px solid ${tc.border}` }}>{tc.label}</span>
                      </div>
                    </div>
                    <button onClick={() => handleDelete(h.id)}
                      style={{ width:32, height:32, borderRadius:9, border:'none', background:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:T.text3 }}
                      onMouseEnter={e=>{e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'; e.currentTarget.style.color='#ef4444';}}
                      onMouseLeave={e=>{e.currentTarget.style.background='none'; e.currentTarget.style.color=T.text3;}}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                    </button>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:50, padding:16 }}>
          <div style={{ background:T.bg2, borderRadius:20, width:'100%', maxWidth:440, boxShadow:darkMode?'0 24px 60px rgba(0,0,0,0.6)':'0 24px 60px rgba(15,31,69,0.2)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 28px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:'20px 20px 0 0' }}>
              <div>
                <h3 style={{ fontSize:15, fontWeight:700, color:'#fff', margin:0 }}>Add Holiday</h3>
                <p style={{ fontSize:12, color:'rgba(255,255,255,0.6)', margin:'3px 0 0' }}>Add to {year} holiday calendar</p>
              </div>
              <button onClick={() => setShowForm(false)} style={{ width:30, height:30, borderRadius:8, border:'none', background:'rgba(255,255,255,0.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding:'20px 28px', background:T.bg3, display:'flex', flexDirection:'column', gap:16 }}>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Holiday Name *</label>
                <input type="text" placeholder="e.g. Diwali, Republic Day, Holi" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={is} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Date *</label>
                <input type="date" value={form.holiday_date} onChange={e => setForm(f => ({ ...f, holiday_date: e.target.value }))} style={is} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Type</label>
                <select value={form.holiday_type} onChange={e => setForm(f => ({ ...f, holiday_type: e.target.value }))} style={is}>
                  <option value="national">National Holiday</option>
                  <option value="regional">Regional Holiday</option>
                  <option value="firm">Firm Holiday</option>
                </select>
              </div>
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:12, padding:'14px 28px', borderTop:`1px solid ${T.border}`, background:T.bg2, borderRadius:'0 0 20px 20px' }}>
              <button onClick={() => setShowForm(false)} style={{ padding:'9px 20px', borderRadius:10, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
              <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 24px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
                {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
                {saving ? 'Saving...' : 'Add Holiday'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── FIRM PROFILE SECTION ──────────────────────────────────────────────────────
const INDIAN_STATES = [
  'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
  'Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh',
  'Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab',
  'Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand',
  'West Bengal','Delhi','Jammu & Kashmir','Ladakh','Puducherry','Chandigarh',
];

function FirmProfileSection({ token }) {
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const { showToast } = useToast();
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [form, setForm] = useState({
    firm_name: '', firm_type: '', proprietor_name: '',
    gstin: '', pan: '', mobile: '', email: '', website: '',
    address_line1: '', address_line2: '', city: '', state: '', pincode: '',
    logo_url: '', signature_name: '', signature_designation: '',
    bank_name: '', bank_account: '', bank_ifsc: '', bank_branch: ''
  });
  const ic = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-blue-400 bg-white";

  const fetchProfile = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/firm-profile`, { headers });
      const d = await r.json();
      setProfile(d);
      setForm(f => ({ ...f, ...d }));
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchProfile(); }, [fetchProfile]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/firm-profile`, { method: 'PUT', headers: jh, body: JSON.stringify(form) });
      if (!res.ok) { showToast('Error saving'); return; }
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
      fetchProfile();
    } catch(e) { showToast('Error saving'); }
    finally { setSaving(false); }
  };

  const SH = ({ num, title }) => (
    <div className="flex items-center gap-3 mb-4 mt-7 first:mt-0">
      <div className="w-7 h-7 rounded-lg flex items-center justify-center text-white text-xs font-bold flex-shrink-0" style={{ background: '#0f1f45' }}>{num}</div>
      <h4 className="text-sm font-bold text-gray-700 uppercase tracking-wide">{title}</h4>
      <div className="flex-1 h-px bg-gray-100"/>
    </div>
  );

  if (loading) return <div className="py-10 text-center text-gray-400 text-sm">Loading...</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base font-bold" style={{ color: '#0f1f45' }}>Firm Profile</h3>
          <p className="text-xs text-gray-400 mt-0.5">Used in invoice headers, receipts and all PDF documents</p>
        </div>
        <div className="flex items-center gap-3">
          {saved && (
            <span className="flex items-center gap-1.5 text-sm text-green-600 font-medium">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              Saved successfully
            </span>
          )}
          <button onClick={handleSave} disabled={saving}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-50"
            style={{ background: '#0f1f45' }}>
            {saving && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"/>}
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-7">
        <SH num="1" title="Firm Identity" />
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-2">
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Company/ Firm Name*</label>
            <input type="text" placeholder="Legal Chanakya Corporate Advisors" value={form.firm_name}
              onChange={e => setForm(f => ({ ...f, firm_name: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Firm Type</label>
            <select value={form.firm_type} onChange={e => setForm(f => ({ ...f, firm_type: e.target.value }))} className={ic}>
              <option value="">Select...</option>
              <option>Proprietorship</option>
              <option>Partnership</option>
              <option>LLP</option>
              <option>Private Limited</option>
            </select>
          </div>
          <div className="col-span-2">
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Proprietor / Partner Name</label>
            <input type="text" placeholder="Legal Chanakya Corporate Advisors" value={form.proprietor_name}
              onChange={e => setForm(f => ({ ...f, proprietor_name: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">PAN</label>
            <input type="text" placeholder="ABCDE1234F" maxLength={10} value={form.pan}
              onChange={e => setForm(f => ({ ...f, pan: e.target.value.toUpperCase() }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">GSTIN</label>
            <input type="text" placeholder="09ABCDE1234F1Z5" maxLength={15} value={form.gstin}
              onChange={e => setForm(f => ({ ...f, gstin: e.target.value.toUpperCase() }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Mobile</label>
            <input type="text" placeholder="8400022008" value={form.mobile}
              onChange={e => setForm(f => ({ ...f, mobile: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Email</label>
            <input type="email" placeholder="info@legalchanakya.in" value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Website</label>
            <input type="text" placeholder="www.legalchanakya.in" value={form.website}
              onChange={e => setForm(f => ({ ...f, website: e.target.value }))} className={ic} />
          </div>
        </div>

        <SH num="2" title="Address" />
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-3">
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Address Line 1</label>
            <input type="text" placeholder="Office No, Building Name, Street" value={form.address_line1}
              onChange={e => setForm(f => ({ ...f, address_line1: e.target.value }))} className={ic} />
          </div>
          <div className="col-span-3">
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Address Line 2</label>
            <input type="text" placeholder="Area, Landmark" value={form.address_line2}
              onChange={e => setForm(f => ({ ...f, address_line2: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">City</label>
            <input type="text" placeholder="Lucknow" value={form.city}
              onChange={e => setForm(f => ({ ...f, city: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">State</label>
            <select value={form.state} onChange={e => setForm(f => ({ ...f, state: e.target.value }))} className={ic}>
              <option value="">Select state...</option>
              {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Pincode</label>
            <input type="text" placeholder="226001" maxLength={6} value={form.pincode}
              onChange={e => setForm(f => ({ ...f, pincode: e.target.value.replace(/\D/g, '') }))} className={ic} />
          </div>
        </div>

        <SH num="3" title="Authorised Signatory" />
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Signatory Name</label>
            <input type="text" placeholder="Ankit Singh" value={form.signature_name}
              onChange={e => setForm(f => ({ ...f, signature_name: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Designation</label>
            <input type="text" placeholder="Proprietor / Partner" value={form.signature_designation}
              onChange={e => setForm(f => ({ ...f, signature_designation: e.target.value }))} className={ic} />
          </div>
          <div className="col-span-2">
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Logo URL</label>
            <input type="text" placeholder="https://... or paste base64 image URL" value={form.logo_url}
              onChange={e => setForm(f => ({ ...f, logo_url: e.target.value }))} className={ic} />
            {form.logo_url && (
              <div className="mt-2 flex items-center gap-3">
                <img src={form.logo_url} alt="Logo preview" className="h-12 object-contain border border-gray-200 rounded-lg p-1" onError={e => e.target.style.display='none'} />
                <p className="text-xs text-green-600">Logo preview</p>
              </div>
            )}
          </div>
        </div>

        <SH num="4" title="Bank Details (for invoices)" />
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Bank Name</label>
            <input type="text" placeholder="HDFC Bank, Hazratganj" value={form.bank_name}
              onChange={e => setForm(f => ({ ...f, bank_name: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Account Number</label>
            <input type="text" placeholder="Account number" value={form.bank_account}
              onChange={e => setForm(f => ({ ...f, bank_account: e.target.value }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">IFSC Code</label>
            <input type="text" placeholder="HDFC0001234" maxLength={11} value={form.bank_ifsc}
              onChange={e => setForm(f => ({ ...f, bank_ifsc: e.target.value.toUpperCase() }))} className={ic} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">Branch</label>
            <input type="text" placeholder="Hazratganj Branch" value={form.bank_branch}
              onChange={e => setForm(f => ({ ...f, bank_branch: e.target.value }))} className={ic} />
          </div>
        </div>
      </div>
    </div>
  );
}

// ── CLIENT SETTINGS SECTION ───────────────────────────────────────────────────
function ClientSettingsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const { showToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [form, setForm] = useState({
    file_number_prefix: 'CLT',
    file_number_format: 'PREFIX/YEAR/NNN',
    file_number_start: 1,
    auto_file_number: true,
    default_state: '',
    default_city: ''
  });

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/client-settings`, { headers });
      const d = await r.json();
      if (d && d.file_number_prefix) setForm(f => ({ ...f, ...d }));
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/client-settings`, { method: 'PUT', headers: jh, body: JSON.stringify(form) });
      if (!res.ok) { showToast('Error saving client settings', 'error'); return; }
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch(e) { showToast('Error saving client settings', 'error'); }
    finally { setSaving(false); }
  };

  // Live preview of file number
  const preview = form.file_number_format
    .replace('PREFIX', form.file_number_prefix || 'CLT')
    .replace('YEAR', new Date().getFullYear())
    .replace('NNN', String(form.file_number_start || 1).padStart(3, '0'));

  if (loading) return <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>;

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Client Settings</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Configure defaults for client creation</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          {saved && (
            <span style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, color:'#16a34a', fontWeight:600 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              Saved
            </span>
          )}
          <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 22px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
            {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
        {/* File Number */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <h4 style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:16 }}>File Number Configuration</h4>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginBottom:16 }}>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Prefix</label>
              <input type="text" placeholder="CLT" value={form.file_number_prefix} onChange={e => setForm(f => ({ ...f, file_number_prefix: e.target.value.toUpperCase() }))} style={is} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Format</label>
              <select value={form.file_number_format} onChange={e => setForm(f => ({ ...f, file_number_format: e.target.value }))} style={is}>
                <option value="PREFIX/YEAR/NNN">PREFIX/YEAR/NNN</option>
                <option value="PREFIX/NNN">PREFIX/NNN</option>
                <option value="YEAR/NNN">YEAR/NNN</option>
                <option value="NNN">NNN only</option>
              </select>
            </div>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Start Number</label>
              <input type="number" min={1} value={form.file_number_start} onChange={e => setForm(f => ({ ...f, file_number_start: Number(e.target.value) }))} style={is} />
            </div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10, background:darkMode?'rgba(59,130,246,0.1)':'#eff6ff', border:`1px solid ${darkMode?'rgba(59,130,246,0.2)':'#bfdbfe'}`, borderRadius:10, padding:'10px 14px', marginBottom:16 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <p style={{ fontSize:12, color:darkMode?'#60a5fa':'#1d4ed8', margin:0 }}>
              Preview: <strong style={{ fontFamily:'monospace' }}>{preview}</strong>
            </p>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <label style={{ position:'relative', display:'inline-flex', alignItems:'center', cursor:'pointer' }}>
              <input type="checkbox" checked={form.auto_file_number} onChange={e => setForm(f => ({ ...f, auto_file_number: e.target.checked }))} style={{ position:'absolute', opacity:0, width:0, height:0 }} />
              <div style={{ width:36, height:20, borderRadius:10, background:form.auto_file_number?'#3b82f6':(darkMode?'#334155':'#d1d5db'), position:'relative', transition:'background 0.2s', cursor:'pointer' }}>
                <div style={{ position:'absolute', top:2, left:form.auto_file_number?18:2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
              </div>
            </label>
            <span style={{ fontSize:13, color:T.text2 }}>Auto-generate file number when creating new client</span>
          </div>
        </div>

        {/* Defaults */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <h4 style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:16 }}>Default Values</h4>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Default State</label>
              <select value={form.default_state} onChange={e => setForm(f => ({ ...f, default_state: e.target.value }))} style={is}>
                <option value="">None</option>
                {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Default City</label>
              <input type="text" placeholder="e.g. Lucknow" value={form.default_city} onChange={e => setForm(f => ({ ...f, default_city: e.target.value }))} style={is} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const MI = ({ d, d2 }) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={d}/>{d2 && <path d={d2}/>}</svg>;
const MODULES = [
  { id:'dashboard', label:'Dashboard', icon:<MI d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" d2="M9 21V12h6v9"/> },
  { id:'crm',       label:'CRM',       icon:<MI d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" d2="M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/> },
  { id:'clients',   label:'Clients',   icon:<MI d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" d2="M12 11a4 4 0 100-8 4 4 0 000 8z"/> },
  { id:'tasks',     label:'Tasks',     icon:<MI d="M9 11l3 3L22 4" d2="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/> },
  { id:'finance',   label:'Finance',   icon:<MI d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" /> },
  { id:'people',    label:'People',    icon:<MI d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 3a4 4 0 110 8 4 4 0 010-8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/> },
  { id:'services',  label:'Services',  icon:<MI d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/> },
  { id:'renewals',  label:'Renewals',  icon:<MI d="M23 4v6h-6" d2="M20.49 15a9 9 0 11-2.12-9.36L23 10"/> },
  { id:'reports',   label:'Reports',   icon:<MI d="M18 20V10M12 20V4M6 20v-6"/> },
  { id:'settings',  label:'Settings',  icon:<MI d="M12 15a3 3 0 100-6 3 3 0 000 6z" d2="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/> },
  // Workspace (paid) modules — real gate is Settings → Workspace Access
  // (user_module_access); the row here is a second view switch.
  { id:'hr',        label:'HR',        icon:<MI d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" d2="M9 11a4 4 0 100-8 4 4 0 000 8zM22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/> },
  { id:'referrals', label:'Referrals', icon:<MI d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" d2="M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/> },
];

const PERMISSIONS = ['view','create','edit','delete','export'];
const ROLES = ['manager','staff'];

const PERM_COLORS = {
  view:   { color:'#2563eb', label:'View',   darkBg:'rgba(37,99,235,0.15)',   darkBorder:'rgba(37,99,235,0.3)',   lightBg:'#eff6ff', lightBorder:'#bfdbfe' },
  create: { color:'#16a34a', label:'Create', darkBg:'rgba(22,163,74,0.15)',   darkBorder:'rgba(22,163,74,0.3)',   lightBg:'#f0fdf4', lightBorder:'#bbf7d0' },
  edit:   { color:'#d97706', label:'Edit',   darkBg:'rgba(217,119,6,0.15)',   darkBorder:'rgba(217,119,6,0.3)',   lightBg:'#fffbeb', lightBorder:'#fde68a' },
  delete: { color:'#dc2626', label:'Delete', darkBg:'rgba(220,38,38,0.15)',   darkBorder:'rgba(220,38,38,0.3)',   lightBg:'#fef2f2', lightBorder:'#fecaca' },
  export: { color:'#7c3aed', label:'Export', darkBg:'rgba(124,58,237,0.15)',  darkBorder:'rgba(124,58,237,0.3)', lightBg:'#f5f3ff', lightBorder:'#ddd6fe' },
};

function ClientPortalSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'10px 14px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh = { 'Content-Type': 'application/json', ...headers };
  const { showToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [copied,  setCopied]  = useState(false);
  const [domainType, setDomainType] = useState('slug'); // 'slug' | 'custom' — which section is shown
  const [form, setForm] = useState({
    show_tasks: true, show_documents: true, show_ledger: true, show_invoices: true, show_referral: true,
    portal_slug: '', custom_domain: '',
  });

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const r = await fetch(`${BASE}/api/client-portal-settings`, { headers });
        const d = await r.json();
        if (d && typeof d.show_tasks !== 'undefined') {
          setForm(f => ({ ...f, ...d, portal_slug: d.portal_slug || '', custom_domain: d.custom_domain || '' }));
          if (d.custom_domain) setDomainType('custom');
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // Once ChanakyaX's wildcard subdomain is live (CHANAKYAX_BASE_DOMAIN set —
  // see .env), the same slug gets a nicer <slug>.chanakyax.in address instead
  // of a path. Until then this env var is empty and we fall back to the path
  // link, which always works with zero extra setup.
  const wildcardBase = process.env.REACT_APP_CHANAKYAX_BASE_DOMAIN;
  const portalLink = !form.portal_slug ? '' : wildcardBase
    ? `https://${form.portal_slug}.${wildcardBase}/`
    : `${window.location.origin}/portal/${form.portal_slug}/login`;
  const customDomainLink = form.custom_domain ? `https://${form.custom_domain}/` : '';
  const activeLink = domainType === 'custom' ? customDomainLink : portalLink;

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/client-portal-settings`, { method: 'PUT', headers: jh, body: JSON.stringify(form) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { showToast(data.message || 'Error saving client portal settings', 'error'); return; }
      setForm(f => ({ ...f, ...data }));
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (e) { showToast('Error saving client portal settings', 'error'); }
    finally { setSaving(false); }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(activeLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const TOGGLES = [
    { key: 'show_tasks',     label: 'Task List',              desc: 'Clients see their task status and due dates' },
    { key: 'show_documents', label: 'Documents',               desc: 'Task documents marked "Visible to Client" are downloadable' },
    { key: 'show_ledger',    label: 'Ledger',                  desc: 'Running balance, including group-company view' },
    { key: 'show_invoices',  label: 'Invoices & Receipts',     desc: 'Clients can view and download PDFs' },
    { key: 'show_referral',  label: 'Referral Commissions',    desc: 'Only shown to clients flagged as a referral partner' },
  ];

  if (loading) return <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>;

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Client Portal</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Login link and section visibility for the client-facing portal</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          {saved && (
            <span style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, color:'#16a34a', fontWeight:600 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              Saved
            </span>
          )}
          <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 22px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
            {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
        {/* Domain Type + Portal link */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <h4 style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:14 }}>Domain Setting</h4>

          <div style={{ display:'flex', gap:12, marginBottom:20, flexWrap:'wrap' }}>
            <DomainTypeCard
              active={domainType === 'slug'} onClick={() => setDomainType('slug')}
              title="ChanakyaX Link" desc="Free, ready instantly" T={T} darkMode={darkMode}
            />
            <DomainTypeCard
              active={domainType === 'custom'} onClick={() => setDomainType('custom')}
              title="Your Own Domain" desc="Use your firm's website" T={T} darkMode={darkMode}
            />
          </div>

          {domainType === 'slug' ? (
            <>
              <p style={{ fontSize:12, color:T.text3, marginBottom:14 }}>
                Choose a short name for your firm (only small letters and hyphens, e.g. "legalchanakya"). Save it, then share the link below with your clients. They just sign in with their Gmail — no password needed.
              </p>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Portal Slug</label>
              <input
                type="text" placeholder="legalchanakya"
                value={form.portal_slug}
                onChange={e => setForm(f => ({ ...f, portal_slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') }))}
                style={{ ...is, marginBottom:14, maxWidth:280, fontFamily:'monospace' }}
              />
            </>
          ) : (
            <>
              <p style={{ fontSize:12, color:T.text3, marginBottom:14 }}>
                Already have your own website or subdomain? Type it below. Already hosted with us? It works right away after you save. Hosted somewhere else? Save it and message us once — we'll turn it on for you, no technical work needed on your end.
              </p>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Domain</label>
              <input
                type="text" placeholder="chanakyax.yourfirm.com"
                value={form.custom_domain}
                onChange={e => setForm(f => ({ ...f, custom_domain: e.target.value.toLowerCase().trim() }))}
                style={{ ...is, marginBottom:14, maxWidth:320, fontFamily:'monospace' }}
              />
              <div style={{ background:darkMode?'rgba(59,130,246,0.08)':'#eff6ff', border:`1px solid ${darkMode?'rgba(59,130,246,0.2)':'#bfdbfe'}`, borderRadius:10, padding:'12px 14px', fontSize:12, color:darkMode?'#93c5fd':'#1e40af', marginBottom:14 }}>
                <strong>Domain hosted elsewhere?</strong> Just save it and let us know — we'll set everything up for you.
              </div>
            </>
          )}

          <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Shareable Link</label>
          <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
            <div style={{ flex:1, minWidth:220, background:T.bg3, border:`1px solid ${T.border}`, borderRadius:10, padding:'10px 14px', fontSize:13, color: activeLink ? T.text2 : T.text3, fontFamily:'monospace', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {activeLink || (domainType === 'slug' ? 'Set a slug and save to get your link' : 'Set a domain and save to get your link')}
            </div>
            <button onClick={handleCopyLink} disabled={!activeLink} style={{ padding:'10px 18px', borderRadius:10, border:`1px solid ${T.border}`, background:T.bg2, color:T.text, fontSize:13, fontWeight:600, cursor: activeLink ? 'pointer' : 'not-allowed', opacity: activeLink ? 1 : 0.5 }}>
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
            {activeLink ? (
              <a href={activeLink} target="_blank" rel="noreferrer" style={{ padding:'10px 18px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, textDecoration:'none', display:'inline-flex', alignItems:'center' }}>
                Open Portal ↗
              </a>
            ) : (
              <span style={{ padding:'10px 18px', borderRadius:10, background:T.bg3, color:T.text3, fontSize:13, fontWeight:600, display:'inline-flex', alignItems:'center' }}>
                Open Portal ↗
              </span>
            )}
          </div>
        </div>

        {/* Section toggles */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <h4 style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:16 }}>Visible Sections</h4>
          <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
            {TOGGLES.map((t) => (
              <div key={t.key} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 0', borderBottom:`1px solid ${T.cardBorder}` }}>
                <div>
                  <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{t.label}</p>
                  <p style={{ fontSize:11, color:T.text3, margin:'2px 0 0' }}>{t.desc}</p>
                </div>
                <button type="button" onClick={() => setForm(f => ({ ...f, [t.key]: !f[t.key] }))}
                  style={{ position:'relative', width:38, height:20, borderRadius:10, border:'none', cursor:'pointer', flexShrink:0, background: form[t.key] ? '#3b82f6' : (darkMode ? '#334155' : '#d1d5db'), transition:'background 0.2s' }}>
                  <span style={{ position:'absolute', top:2, left: form[t.key] ? 20 : 2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
                </button>
              </div>
            ))}
          </div>
        </div>

        <div style={{ background: darkMode ? 'rgba(59,130,246,0.08)' : '#eff6ff', border:`1px solid ${darkMode?'rgba(59,130,246,0.2)':'#bfdbfe'}`, borderRadius:12, padding:'14px 18px', fontSize:12, color: darkMode?'#93c5fd':'#1e40af' }}>
          These toggles only hide the section from the client's navigation. Individually enabling a client for portal access (and setting their Gmail) is done per-client on the Clients page.
        </div>
      </div>
    </div>
  );
}

// Custom-drawn selectable card standing in for a plain radio button — used
// for the Domain Setting choice above. Two of these side by side read as a
// clean segmented choice rather than a bare browser radio + label.
const DomainTypeCard = ({ active, onClick, title, desc, T, darkMode }) => (
  <button
    type="button" onClick={onClick}
    style={{
      flex: 1, minWidth: 180, display: 'flex', alignItems: 'center', gap: 12,
      padding: '14px 16px', borderRadius: 12, cursor: 'pointer', textAlign: 'left',
      border: `1.5px solid ${active ? '#f97316' : T.border}`,
      background: active ? (darkMode ? 'rgba(249,115,22,0.08)' : '#fff7ed') : T.bg2,
      transition: 'border-color 0.15s, background 0.15s',
    }}
  >
    <span style={{
      width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
      border: `2px solid ${active ? '#f97316' : T.border2}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'border-color 0.15s',
    }}>
      {active && <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#f97316' }} />}
    </span>
    <span>
      <span style={{ display: 'block', fontSize: 13, fontWeight: 700, color: active ? '#c2410c' : T.text }}>{title}</span>
      <span style={{ display: 'block', fontSize: 11, color: T.text3, marginTop: 1 }}>{desc}</span>
    </span>
  </button>
);

function UserRolesSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh      = { 'Content-Type': 'application/json', ...headers };
  const [allPerms, setAllPerms]   = useState({});
  const [loading,  setLoading]    = useState(true);
  const [saving,   setSaving]     = useState({});
  const [activeRole, setActiveRole] = useState('manager');
  const [resetting,  setResetting]  = useState(false);
  const { showToast, showConfirm } = useToast();

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/role-permissions`, { headers });
      const d = await r.json();
      setAllPerms(d);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleToggle = async (role, module, permission, currentVal) => {
    const key = `${role}-${module}-${permission}`;
    setSaving(s => ({ ...s, [key]: true }));
    try {
      const current = allPerms[role]?.[module] || {};
      const updated = { ...current, [`can_${permission}`]: !currentVal };
      const res = await fetch(`${BASE}/api/role-permissions/${role}/${module}`, {
        method: 'PUT', headers: jh, body: JSON.stringify(updated)
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.message || `Save failed (HTTP ${res.status})`);
      }
      setAllPerms(prev => ({
        ...prev,
        [role]: {
          ...prev[role],
          [module]: { ...prev[role]?.[module], [`can_${permission}`]: !currentVal }
        }
      }));
      invalidatePermissionCache();
    } catch(e) { showToast(e.message || 'Error saving permission', 'error'); }
    finally { setSaving(s => ({ ...s, [key]: false })); }
  };

  const handleReset = async (role) => {
    const confirmed = await showConfirm(`Reset ${role} permissions to defaults?`);
    if (!confirmed) return;
    setResetting(true);
    try {
      const res = await fetch(`${BASE}/api/role-permissions/${role}/reset`, {
        method: 'POST', headers: jh
      });
      if (!res.ok) throw new Error('Reset failed');
      showToast(`${role.charAt(0).toUpperCase()+role.slice(1)} permissions reset to defaults`, 'success');
      invalidatePermissionCache();
      fetchAll();
    } catch(e) { showToast('Error resetting permissions', 'error'); }
    finally { setResetting(false); }
  };

  const getRoleStats = (role) => {
    const mods = allPerms[role] || {};
    let total = 0, enabled = 0;
    Object.values(mods).forEach(m => {
      PERMISSIONS.forEach(p => {
        total++;
        if (m[`can_${p}`]) enabled++;
      });
    });
    return { total, enabled };
  };

  const ROLE_CARD = {
    manager: { grad:'linear-gradient(135deg,#1e40af,#3b82f6)', light:'#eff6ff', accent:'#3b82f6', border:'#bfdbfe' },
    staff:   { grad:'linear-gradient(135deg,#166534,#22c55e)', light:'#f0fdf4', accent:'#16a34a', border:'#bbf7d0' },
  };

  return (
    <div>
      {/* ── Header ── */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:16, fontWeight:700, color:T.text, margin:0 }}>User Roles & Permissions</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:3 }}>Control what each role can view, create, edit, delete and export</p>
        </div>
      </div>

      {/* ── Admin notice ── */}
      <div style={{ background:darkMode?'rgba(37,99,235,0.1)':'#eff6ff', border:`1px solid ${darkMode?'rgba(37,99,235,0.25)':'#bfdbfe'}`, borderRadius:12, padding:'14px 18px', marginBottom:20, display:'flex', alignItems:'flex-start', gap:12 }}>
        <div style={{ width:32, height:32, borderRadius:8, background:darkMode?'rgba(37,99,235,0.2)':'#dbeafe', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        </div>
        <div>
          <p style={{ fontSize:13, fontWeight:700, color:'#2563eb', margin:0 }}>Admin always has full access</p>
          <p style={{ fontSize:12, color:darkMode?'#60a5fa':'#3b82f6', marginTop:3 }}>Admin permissions cannot be modified. Configure Manager and Staff roles below.</p>
        </div>
      </div>

      {/* ── Role Cards ── */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:14, marginBottom:22 }}>
        {/* Admin card — always full */}
        <div style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:16, padding:22, color:'#fff', position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', top:-20, right:-20, width:80, height:80, borderRadius:'50%', background:'rgba(255,255,255,0.05)' }}/>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
            <span style={{ fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.1em', opacity:0.6 }}>Admin</span>
            <span style={{ fontSize:11, padding:'3px 10px', background:'rgba(249,115,22,0.25)', color:'#fdba74', borderRadius:20, fontWeight:600 }}>Full Access</span>
          </div>
          <p style={{ fontSize:28, fontWeight:800, margin:0, lineHeight:1 }}>{MODULES.length * PERMISSIONS.length} <span style={{ fontSize:14, fontWeight:400, opacity:0.5 }}>/ {MODULES.length * PERMISSIONS.length}</span></p>
          <p style={{ fontSize:11, opacity:0.5, marginTop:6 }}>All permissions enabled</p>
          <div style={{ marginTop:14, height:4, borderRadius:4, background:'rgba(255,255,255,0.15)' }}>
            <div style={{ height:4, borderRadius:4, background:'#f97316', width:'100%' }}/>
          </div>
        </div>

        {ROLES.map(role => {
          const stats = getRoleStats(role);
          const pct   = stats.total > 0 ? Math.round((stats.enabled / stats.total) * 100) : 0;
          const isActive = activeRole === role;
          const meta = ROLE_CARD[role] || ROLE_CARD.staff;
          return (
            <button key={role} onClick={() => setActiveRole(role)} style={{
              textAlign:'left', borderRadius:16, padding:22,
              border: isActive ? `2px solid ${meta.accent}` : `2px solid ${T.border}`,
              background: isActive ? (darkMode?`rgba(${meta.accent === '#3b82f6'?'59,130,246':'22,163,74'},0.12)`:meta.light) : T.bg2,
              cursor:'pointer', transition:'all 0.2s',
              boxShadow: isActive ? `0 4px 16px ${meta.accent}22` : 'none',
            }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
                <span style={{ fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.1em', color:T.text3 }}>{role}</span>
                <span style={{ fontSize:11, padding:'3px 10px', borderRadius:20, fontWeight:600, background: isActive ? (darkMode?`rgba(${meta.accent === '#3b82f6'?'59,130,246':'22,163,74'},0.2)`:meta.border) : T.bg3, color: isActive ? meta.accent : T.text3 }}>
                  {pct}%
                </span>
              </div>
              <p style={{ fontSize:28, fontWeight:800, color:T.text, margin:0, lineHeight:1 }}>{stats.enabled} <span style={{ fontSize:14, fontWeight:400, color:T.text3 }}>/ {stats.total}</span></p>
              <p style={{ fontSize:11, color:T.text3, marginTop:6 }}>permissions enabled</p>
              <div style={{ marginTop:14, height:4, borderRadius:4, background:T.bg3 }}>
                <div style={{ height:4, borderRadius:4, background: meta.accent, width:`${pct}%`, transition:'width 0.4s ease' }}/>
              </div>
            </button>
          );
        })}
      </div>

      {/* ── Permission Matrix ── */}
      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:'#94a3b8', fontSize:13 }}>Loading permissions...</div>
      ) : (
        <div style={{ background:T.bg2, borderRadius:16, border:`1px solid ${T.cardBorder}`, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 1px 6px rgba(15,31,69,0.05)', overflow:'hidden' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 20px', borderBottom:`1px solid ${T.border}`, background:T.bg3 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:8, height:8, borderRadius:'50%', background:'#f97316' }}/>
              <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0, textTransform:'capitalize' }}>{activeRole} Permissions</p>
            </div>
            <button onClick={() => handleReset(activeRole)} disabled={resetting} style={{
              display:'flex', alignItems:'center', gap:6, fontSize:12, color:T.text3,
              padding:'6px 12px', borderRadius:8, border:`1px solid ${T.border2}`, background:T.bg2, cursor:'pointer',
            }}
            onMouseEnter={e => { e.currentTarget.style.color='#ef4444'; e.currentTarget.style.borderColor='#fecaca'; e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.1)':'#fef2f2'; }}
            onMouseLeave={e => { e.currentTarget.style.color=T.text3; e.currentTarget.style.borderColor=T.border2; e.currentTarget.style.background=T.bg2; }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 4v6h-6M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
              Reset to Default
            </button>
          </div>

          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                <th style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em', width:160 }}>Module</th>
                {PERMISSIONS.map(p => {
                  const meta = PERM_COLORS[p];
                  return (
                    <th key={p} style={{ padding:'10px 8px', textAlign:'center' }}>
                      <span style={{
                        display:'inline-block', padding:'3px 10px', borderRadius:6,
                        fontSize:11, fontWeight:700, letterSpacing:'0.04em', color:'#fff', opacity:0.9,
                      }}>
                        {meta.label}
                      </span>
                    </th>
                  );
                })}
                <th style={{ padding:'10px 8px', textAlign:'center', fontSize:11, fontWeight:700, color:'#fff', opacity:0.9 }}>All</th>
              </tr>
            </thead>
            <tbody>
              {MODULES.map((mod, i) => {
                const modPerms = allPerms[activeRole]?.[mod.id] || {};
                const allEnabled = PERMISSIONS.every(p => modPerms[`can_${p}`]);
                return (
                  <tr key={mod.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), transition:'background 0.15s' }}
                      onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                      onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                    <td style={{ padding:'12px 20px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <span style={{ fontSize:16 }}>{mod.icon}</span>
                        <span style={{ fontSize:13, fontWeight:600, color:T.text }}>{mod.label}</span>
                      </div>
                    </td>
                    {PERMISSIONS.map(p => {
                      const key      = `${activeRole}-${mod.id}-${p}`;
                      const enabled  = modPerms[`can_${p}`] === true;
                      const isSaving = saving[key];
                      const meta     = PERM_COLORS[p];
                      return (
                        <td key={p} style={{ padding:'8px 4px', textAlign:'center' }}>
                          <button
                            onClick={() => handleToggle(activeRole, mod.id, p, enabled)}
                            disabled={isSaving}
                            title={`${enabled?'Disable':'Enable'} ${meta.label}`}
                            style={{
                              width:36, height:28, borderRadius:6,
                              border: `1px solid ${enabled?(darkMode?meta.darkBorder:meta.lightBorder):T.border}`,
                              background: enabled?(darkMode?meta.darkBg:meta.lightBg):'transparent',
                              color: enabled?meta.color:T.text3,
                              display:'flex', alignItems:'center', justifyContent:'center',
                              margin:'0 auto', cursor:isSaving?'wait':'pointer',
                              opacity:isSaving?0.6:1, transition:'all 0.15s',
                              fontSize:11, fontWeight:700,
                            }}
                            onMouseEnter={e=>{ if(!isSaving){ e.currentTarget.style.borderColor=meta.color; e.currentTarget.style.color=meta.color; }}}
                            onMouseLeave={e=>{ if(!enabled){ e.currentTarget.style.borderColor=T.border; e.currentTarget.style.color=T.text3; }}}
                          >
                            {isSaving ? (
                              <span style={{ width:10, height:10, border:`2px solid ${meta.color}`, borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>
                            ) : enabled ? (
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={meta.color} strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                            ) : (
                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                            )}
                          </button>
                        </td>
                      );
                    })}
                    {/* Toggle All */}
                    <td style={{ padding:'8px 16px', textAlign:'center' }}>
                      <button
                        onClick={async () => {
                          const newVal = !allEnabled;
                          const current = allPerms[activeRole]?.[mod.id] || {};
                          const updated = PERMISSIONS.reduce((acc, p) => ({ ...acc, [`can_${p}`]: newVal }), current);
                          await fetch(`${BASE}/api/role-permissions/${activeRole}/${mod.id}`, {
                            method: 'PUT', headers: jh, body: JSON.stringify(updated)
                          });
                          setAllPerms(prev => ({ ...prev, [activeRole]: { ...prev[activeRole], [mod.id]: updated } }));
                          invalidatePermissionCache();
                        }}
                        title={allEnabled ? 'Disable All' : 'Enable All'}
                        style={{
                          width:36, height:28, borderRadius:6,
                          border:`1px solid ${allEnabled?(darkMode?'rgba(79,70,229,0.4)':'#c7d2fe'):T.border}`,
                          background:allEnabled?(darkMode?'rgba(79,70,229,0.15)':'#eef2ff'):'transparent',
                          color:allEnabled?'#4f46e5':T.text3,
                          display:'flex', alignItems:'center', justifyContent:'center',
                          margin:'0 auto', cursor:'pointer', transition:'all 0.15s',
                        }}
                        onMouseEnter={e=>{ e.currentTarget.style.borderColor='#6366f1'; e.currentTarget.style.color='#6366f1'; }}
                        onMouseLeave={e=>{ if(!allEnabled){ e.currentTarget.style.borderColor=T.border; e.currentTarget.style.color=T.text3; }}}
                      >
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                          {allEnabled ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></> : <polyline points="20 6 9 17 4 12"/>}
                        </svg>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── ATTENDANCE SETTINGS ───────────────────────────────────────────────────────
const ALL_DAYS = [
  { id:'monday',    label:'Mon' },
  { id:'tuesday',   label:'Tue' },
  { id:'wednesday', label:'Wed' },
  { id:'thursday',  label:'Thu' },
  { id:'friday',    label:'Fri' },
  { id:'saturday',  label:'Sat' },
  { id:'sunday',    label:'Sun' },
];

function AttendanceSettingsSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh      = { 'Content-Type': 'application/json', ...headers };
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [form, setForm] = useState({
    working_days:               ['monday','tuesday','wednesday','thursday','friday','saturday'],
    office_in_time:             '09:30',
    office_out_time:            '18:30',
    late_threshold_minutes:     30,
    half_day_threshold_hours:   4.0,
    overtime_threshold_hours:   9.0,
    grace_period_minutes:       10,
    auto_mark_absent:           true,
    auto_mark_absent_after_hours: 4,
    weekly_hours_target:        48.0,
    count_offday_work_as:       'overtime',
    late_arrival_enabled:       true,
    half_day_enabled:           true,
    overtime_enabled:           true,
  });
  const { showToast } = useToast();
  const ic = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-blue-400 bg-white";

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/attendance-settings`, { headers });
      const d = await r.json();
      if (d && d.office_in_time) {
        setForm({
          working_days:               Array.isArray(d.working_days) ? d.working_days : JSON.parse(d.working_days || '[]'),
          office_in_time:             d.office_in_time?.slice(0,5) || '09:30',
          office_out_time:            d.office_out_time?.slice(0,5) || '18:30',
          late_threshold_minutes:     d.late_threshold_minutes || 30,
          half_day_threshold_hours:   parseFloat(d.half_day_threshold_hours) || 4.0,
          overtime_threshold_hours:   parseFloat(d.overtime_threshold_hours) || 9.0,
          grace_period_minutes:       d.grace_period_minutes || 10,
          auto_mark_absent:           d.auto_mark_absent !== false,
          auto_mark_absent_after_hours: d.auto_mark_absent_after_hours || 4,
          weekly_hours_target:        parseFloat(d.weekly_hours_target) || 48.0,
          count_offday_work_as:       d.count_offday_work_as || 'overtime',
          late_arrival_enabled:       d.late_arrival_enabled !== false,
          half_day_enabled:           d.half_day_enabled !== false,
          overtime_enabled:           d.overtime_enabled !== false,
        });
      }
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  const toggleDay = (day) => {
    setForm(f => ({
      ...f,
      working_days: f.working_days.includes(day)
        ? f.working_days.filter(d => d !== day)
        : [...f.working_days, day]
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/attendance-settings`, {
        method: 'PUT', headers: jh, body: JSON.stringify(form)
      });
      if (!res.ok) { showToast('Error saving', 'error'); return; }
      setSaved(true);
      showToast('Attendance settings saved', 'success');
      setTimeout(() => setSaved(false), 3000);
    } catch(e) { showToast('Error saving', 'error'); }
    finally { setSaving(false); }
  };

  const workingHours = () => {
    const [ih, im] = form.office_in_time.split(':').map(Number);
    const [oh, om] = form.office_out_time.split(':').map(Number);
    const total = (oh * 60 + om) - (ih * 60 + im);
    return `${Math.floor(total/60)}h ${total%60}m`;
  };

  const SH = ({ num, title }) => (
    <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16, marginTop:24 }}>
      <div style={{ width:28, height:28, borderRadius:8, background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:11, fontWeight:700 }}>{num}</div>
      <h4 style={{ fontSize:12, fontWeight:700, color:T.text3, textTransform:'uppercase', letterSpacing:'0.08em', margin:0 }}>{title}</h4>
      <div style={{ flex:1, height:1, background:T.border }}/>
    </div>
  );

  if (loading) return <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>;

  const SLabel = ({ children }) => (
    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>{children}</label>
  );
  const SInput = ({ style: s, ...props }) => (
    <input {...props} style={{ width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box', ...s }} />
  );
  const RuleCard = ({ color, borderColor, bgColor, iconStroke, iconPath, title, children, enabled, onToggle }) => {
    const hasToggle = typeof enabled === 'boolean';
    const off = hasToggle && !enabled;
    return (
      <div style={{ background:darkMode?T.bg3:bgColor, border:`1px solid ${darkMode?T.border:borderColor}`, borderRadius:14, padding:20, position:'relative' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16 }}>
          <div style={{ width:34, height:34, borderRadius:9, background:darkMode?`rgba(${iconStroke==='#d97706'?'217,119,6':iconStroke==='#ea580c'?'234,88,12':iconStroke==='#7c3aed'?'124,58,237':'220,38,38'},0.2)`:borderColor, display:'flex', alignItems:'center', justifyContent:'center', opacity:off?0.5:1 }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={iconStroke} strokeWidth="2">{iconPath}</svg>
          </div>
          <p style={{ fontSize:13, fontWeight:700, color:darkMode?'#fff':color, margin:0, opacity:off?0.6:1, flex:1 }}>{title}</p>
          {hasToggle && (
            <span onClick={onToggle} title={enabled?'Rule is ON — click to turn off':'Rule is OFF — click to turn on'}
              style={{ display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer', userSelect:'none' }}>
              <span style={{ fontSize:10, fontWeight:700, color: enabled ? iconStroke : T.text3 }}>{enabled ? 'ON' : 'OFF'}</span>
              <span style={{ width:34, height:19, borderRadius:10, background: enabled ? iconStroke : (darkMode?'#334155':'#cbd5e1'), position:'relative', transition:'background 0.2s' }}>
                <span style={{ position:'absolute', top:2, left: enabled ? 17 : 2, width:15, height:15, borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.25)' }}/>
              </span>
            </span>
          )}
        </div>
        <div style={{ opacity:off?0.4:1, pointerEvents:off?'none':'auto', filter:off?'grayscale(0.6)':'none', transition:'opacity 0.15s' }}>
          {children}
        </div>
        {off && <p style={{ fontSize:10.5, color:T.text3, margin:'8px 0 0', fontStyle:'italic' }}>This rule is off — the values above are ignored.</p>}
      </div>
    );
  };

  return (
    <div>
      {/* ── Header ── */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div>
          <h3 style={{ fontSize:16, fontWeight:700, color:T.text, margin:0 }}>Work Schedule</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:3 }}>Your firm's office hours & working days — the whole HR module follows this</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          {saved && (
            <span style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, color:'#16a34a', fontWeight:600 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>Saved
            </span>
          )}
          <button onClick={handleSave} disabled={saving} style={{
            display:'flex', alignItems:'center', gap:8, padding:'10px 22px',
            background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff',
            border:'none', borderRadius:10, fontSize:13, fontWeight:600,
            cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1,
            boxShadow:'0 4px 12px rgba(15,31,69,0.25)',
          }}>
            {saving && <span style={{ width:13, height:13, border:'2px solid rgba(255,255,255,0.4)', borderTopColor:'#fff', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }}/>}
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

        {/* ── Card 1: Working Days ── */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 1px 4px rgba(15,31,69,0.05)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:18 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </div>
            <div>
              <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>Working Days</p>
            <p style={{ fontSize:11, color:T.text3, margin:'2px 0 0' }}>{form.working_days.length} days selected · {form.weekly_hours_target}h weekly target</p>
            </div>
          </div>
          <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
            {ALL_DAYS.map(d => {
              const active = form.working_days.includes(d.id);
              return (
                <button key={d.id} onClick={() => toggleDay(d.id)} style={{
                  width:52, height:52, borderRadius:12, fontSize:12, fontWeight:700,
                  border: active ? '2px solid #0f1f45' : `2px solid ${T.border2}`,
                  background: active ? 'linear-gradient(135deg,#0f1f45,#1a3a6b)' : T.bg2,
                  color: active ? '#fff' : T.text3,
                  cursor:'pointer', transition:'all 0.15s',
                  boxShadow: active ? '0 3px 10px rgba(15,31,69,0.25)' : 'none',
                }}>
                  {d.label}
                </button>
              );
            })}
          </div>
          <div style={{ marginTop:18, paddingTop:18, borderTop:`1px solid ${T.border}`, maxWidth:360 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>When an employee works on a weekly-off / holiday</label>
            <select value={form.count_offday_work_as}
              onChange={e => setForm(f => ({ ...f, count_offday_work_as: e.target.value }))}
              style={{ width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text }}>
              <option value="overtime">Count as Overtime</option>
              <option value="comp_off">Grant Compensatory Off</option>
              <option value="present">Count as a normal Present day</option>
              <option value="none">Record only — no extra credit</option>
            </select>
            <p style={{ fontSize:11, color:T.text3, margin:'6px 0 0' }}>Applies when attendance is marked Present / Half Day / WFH on a non-working day.</p>
          </div>
        </div>

        {/* ── Card 2: Office Timings ── */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 1px 4px rgba(15,31,69,0.05)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:18 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:darkMode?'rgba(14,165,233,0.15)':'linear-gradient(135deg,#0ea5e9,#0284c7)', border:darkMode?'1px solid rgba(14,165,233,0.3)':'none', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={darkMode?'#38bdf8':'#fff'} strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            </div>
            <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>Office Timings</p>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:14 }}>
            <div><SLabel>In Time</SLabel><SInput type="time" value={form.office_in_time} onChange={e => setForm(f => ({ ...f, office_in_time: e.target.value }))} /></div>
            <div><SLabel>Out Time</SLabel><SInput type="time" value={form.office_out_time} onChange={e => setForm(f => ({ ...f, office_out_time: e.target.value }))} /></div>
            <div><SLabel>Weekly Hours Target</SLabel><SInput type="number" step="0.5" min="1" value={form.weekly_hours_target} onChange={e => setForm(f => ({ ...f, weekly_hours_target: e.target.value }))} /></div>
            <div style={{ display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
              <div style={{ background:darkMode?'rgba(37,99,235,0.12)':'linear-gradient(135deg,#eff6ff,#dbeafe)', border:`1px solid ${darkMode?'rgba(37,99,235,0.25)':'#bfdbfe'}`, borderRadius:12, padding:'10px 14px', textAlign:'center' }}>
                <p style={{ fontSize:11, color:'#3b82f6', fontWeight:600, margin:0 }}>Daily Hours</p>
                <p style={{ fontSize:20, fontWeight:800, color:darkMode?'#60a5fa':'#1e40af', margin:'2px 0 0' }}>{workingHours()}</p>
              </div>
            </div>
          </div>
        </div>

        {/* ── Card 3: Attendance Rules ── */}
        <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16, padding:24, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 1px 4px rgba(15,31,69,0.05)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:18 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:'linear-gradient(135deg,#f59e0b,#d97706)', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            </div>
            <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>Attendance Rules</p>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>

            <RuleCard color="#92400e" borderColor="#fde68a" bgColor="#fffbeb" iconStroke="#d97706" title="Late Arrival"
              enabled={form.late_arrival_enabled} onToggle={() => setForm(f => ({ ...f, late_arrival_enabled: !f.late_arrival_enabled }))}
              iconPath={<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>}>
              <div style={{ marginBottom:10 }}>
                <SLabel>Grace Period (minutes)</SLabel>
                <SInput type="number" min="0" max="60" value={form.grace_period_minutes} onChange={e => setForm(f => ({ ...f, grace_period_minutes: Number(e.target.value) }))} style={{ borderColor:'#fde68a' }} />
                <p style={{ fontSize:11, color:darkMode?'#fbbf24':'#b45309', marginTop:4 }}>No penalty within grace period</p>
              </div>
              <div>
                <SLabel>Late Threshold (min after grace)</SLabel>
                <SInput type="number" min="1" value={form.late_threshold_minutes} onChange={e => setForm(f => ({ ...f, late_threshold_minutes: Number(e.target.value) }))} style={{ borderColor:'#fde68a' }} />
                <p style={{ fontSize:11, color:darkMode?'#fbbf24':'#b45309', marginTop:4 }}>Marked late after {form.grace_period_minutes + form.late_threshold_minutes}m from in-time</p>
              </div>
            </RuleCard>

            <RuleCard color="#7c2d12" borderColor="#fed7aa" bgColor="#fff7ed" iconStroke="#ea580c" title="Half Day"
              enabled={form.half_day_enabled} onToggle={() => setForm(f => ({ ...f, half_day_enabled: !f.half_day_enabled }))}
              iconPath={<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>}>
              <SLabel>Threshold (hours)</SLabel>
              <SInput type="number" step="0.5" min="1" max="8" value={form.half_day_threshold_hours} onChange={e => setForm(f => ({ ...f, half_day_threshold_hours: e.target.value }))} style={{ borderColor:'#fed7aa' }} />
              <p style={{ fontSize:11, color:darkMode?'#fb923c':'#c2410c', marginTop:4 }}>Less than {form.half_day_threshold_hours}h = Half Day</p>
            </RuleCard>

            <RuleCard color="#4c1d95" borderColor="#ddd6fe" bgColor="#f5f3ff" iconStroke="#7c3aed" title="Overtime"
              enabled={form.overtime_enabled} onToggle={() => setForm(f => ({ ...f, overtime_enabled: !f.overtime_enabled }))}
              iconPath={<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>}>
              <SLabel>Threshold (hours)</SLabel>
              <SInput type="number" step="0.5" min="6" max="16" value={form.overtime_threshold_hours} onChange={e => setForm(f => ({ ...f, overtime_threshold_hours: e.target.value }))} style={{ borderColor:'#ddd6fe' }} />
              <p style={{ fontSize:11, color:darkMode?'#a78bfa':'#6d28d9', marginTop:4 }}>More than {form.overtime_threshold_hours}h = Overtime</p>
            </RuleCard>

            <RuleCard color="#991b1b" borderColor="#fecaca" bgColor="#fef2f2" iconStroke="#dc2626" title="Auto Absent"
              enabled={form.auto_mark_absent} onToggle={() => setForm(f => ({ ...f, auto_mark_absent: !f.auto_mark_absent }))}
              iconPath={<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>}>
              <SLabel>Mark absent if no punch after (hours from in-time)</SLabel>
              <SInput type="number" min="1" max="12" value={form.auto_mark_absent_after_hours} onChange={e => setForm(f => ({ ...f, auto_mark_absent_after_hours: Number(e.target.value) }))} style={{ borderColor:'#fecaca' }} />
              <p style={{ fontSize:11, color:darkMode?'#fca5a5':'#b91c1c', marginTop:4 }}>A day with no punch-in is auto-marked Absent after this many hours.</p>
            </RuleCard>
          </div>
        </div>

        {/* ── Summary strip ── */}
        <div style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:16, padding:'18px 24px', display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:0 }}>
          {[
            { label:'Working Days', value: form.working_days.length, unit:'days' },
            { label:'Daily Hours',  value: workingHours(), unit:'' },
            { label:'Grace Period', value: `${form.grace_period_minutes}m`, unit:'' },
            { label:'Half Day',     value: `< ${form.half_day_threshold_hours}h`, unit:'' },
          ].map((s, i) => (
            <div key={s.label} style={{ textAlign:'center', borderRight: i < 3 ? '1px solid rgba(255,255,255,0.1)' : 'none', padding:'0 16px' }}>
              <p style={{ fontSize:22, fontWeight:800, color:'#fff', margin:0, lineHeight:1 }}>{s.value}</p>
              <p style={{ fontSize:11, color:'rgba(255,255,255,0.5)', marginTop:5, fontWeight:500 }}>{s.label}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

// ── USER REPLACEMENT SECTION ──────────────────────────────────────────────────
function UserReplacementSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh      = { 'Content-Type': 'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [users,     setUsers]     = useState([]);
  const [fromUser,  setFromUser]  = useState('');
  const [toUser,    setToUser]    = useState('');
  const [preview,   setPreview]   = useState(null);
  const [previewing,setPreviewing]= useState(false);
  const [executing, setExecuting] = useState(false);
  const [result,    setResult]    = useState(null);

  useEffect(() => {
    fetch(`${BASE}/api/users`, { headers })
      .then(r => r.json())
      .then(d => setUsers(Array.isArray(d) ? d : []));
  }, [token]);

  const handlePreview = async () => {
    if (!fromUser) return showToast('Select a user to replace');
    setPreviewing(true); setPreview(null); setResult(null);
    try {
      const r = await fetch(`${BASE}/api/user-replacement/preview/${fromUser}`, { headers });
      const d = await r.json();
      setPreview(d);
    } catch(e) { showToast('Error fetching preview'); }
    finally { setPreviewing(false); }
  };

  const handleExecute = async () => {
    if (!fromUser || !toUser) return showToast('Select both users');
    if (fromUser === toUser) return showToast('Cannot replace with the same user');
    const fromName = users.find(u => String(u.id) === fromUser)?.full_name;
    const toName   = users.find(u => String(u.id) === toUser)?.full_name;
    if (!await showConfirm(`Transfer ALL assignments from ${fromName} to ${toName}?\n\nThis action cannot be undone.`)) return;

    setExecuting(true);
    try {
      const res  = await fetch(`${BASE}/api/user-replacement/execute`, {
        method: 'POST', headers: jh,
        body: JSON.stringify({ from_user_id: fromUser, to_user_id: toUser })
      });
      const data = await res.json();
      if (!res.ok) { showToast(data.message || 'Error'); return; }
      setResult(data);
      setPreview(null);
      setFromUser(''); setToUser('');
    } catch(e) { showToast('Error executing replacement'); }
    finally { setExecuting(false); }
  };

  const PREVIEW_ITEMS = [
    { key:'tasks',     label:'Tasks',      icon:'◻', color:'bg-blue-50 text-blue-700 border-blue-200'   },
    { key:'leads',     label:'Leads',      icon:'◈', color:'bg-purple-50 text-purple-700 border-purple-200' },
    { key:'clients',   label:'Clients',    icon:'◉', color:'bg-green-50 text-green-700 border-green-200'  },
    { key:'followups', label:'Follow-ups', icon:'📞', color:'bg-amber-50 text-amber-700 border-amber-200'  },
    { key:'proposals', label:'Proposals',  icon:'📄', color:'bg-indigo-50 text-indigo-700 border-indigo-200'},
    { key:'invoices',  label:'Invoices',   icon:'❏', color:'bg-rose-50 text-rose-700 border-rose-200'   },
  ];

  const totalItems = preview ? Object.values(preview).reduce((s, v) => s + v, 0) : 0;

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>User Replacement</h3>
        <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Transfer all assignments from one user to another across all modules</p>
      </div>

      <div style={{ background:darkMode?'rgba(245,158,11,0.1)':'#fffbeb', border:`1px solid ${darkMode?'rgba(245,158,11,0.25)':'#fde68a'}`, borderRadius:16, padding:'16px 20px', marginBottom:24, display:'flex', alignItems:'flex-start', gap:12 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" style={{ flexShrink:0, marginTop:1 }}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        <div>
          <p style={{ fontSize:13, fontWeight:700, color:darkMode?'#fbbf24':'#92400e', margin:0 }}>Irreversible Action</p>
          <p style={{ fontSize:12, color:darkMode?'#fcd34d':'#b45309', marginTop:3 }}>This will permanently transfer all tasks, leads, clients and assignments from one user to another.</p>
        </div>
      </div>

      <div style={{ background:T.bg2, borderRadius:16, border:`1px solid ${T.cardBorder}`, padding:28, boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr auto 1fr', gap:16, alignItems:'flex-end', marginBottom:24 }}>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Replace From (leaving user) *</label>
            <select value={fromUser} onChange={e => { setFromUser(e.target.value); setPreview(null); setResult(null); }} style={is}>
              <option value="">Select user...</option>
              {users.map(u => <option key={u.id} value={u.id}>{u.full_name} ({u.role})</option>)}
            </select>
          </div>
          <div style={{ display:'flex', alignItems:'flex-end', paddingBottom:4 }}>
            <div style={{ width:40, height:40, borderRadius:'50%', background:T.bg3, border:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </div>
          </div>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>Replace To (receiving user) *</label>
            <select value={toUser} onChange={e => setToUser(e.target.value)} style={is}>
              <option value="">Select user...</option>
              {users.filter(u => String(u.id) !== fromUser).map(u => <option key={u.id} value={u.id}>{u.full_name} ({u.role})</option>)}
            </select>
          </div>
        </div>

        {fromUser && !preview && !result && (
          <button onClick={handlePreview} disabled={previewing} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 18px', borderRadius:10, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer', marginBottom:24 }}
            onMouseEnter={e=>e.currentTarget.style.background=T.bg3}
            onMouseLeave={e=>e.currentTarget.style.background=T.bg2}>
            {previewing ? <span style={{ width:14, height:14, border:`2px solid ${T.text3}`, borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/> : (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            )}
            {previewing ? 'Loading preview...' : 'Preview What Will Be Transferred'}
          </button>
        )}

        {preview && (
          <div style={{ marginBottom:24 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
              <p style={{ fontSize:13, fontWeight:700, color:T.text, margin:0 }}>Transfer Preview — <span style={{ color:'#3b82f6' }}>{totalItems} total assignments</span></p>
              <button onClick={() => setPreview(null)} style={{ fontSize:12, color:T.text3, background:'none', border:'none', cursor:'pointer' }}>✕ Clear</button>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
              {PREVIEW_ITEMS.map(item => (
                <div key={item.key} style={{ border:`1px solid ${T.border}`, borderRadius:14, padding:16, background: preview[item.key]>0?T.bg2:T.bg3, opacity: preview[item.key]>0?1:0.5 }}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <span style={{ fontSize:16 }}>{item.icon}</span>
                      <span style={{ fontSize:13, fontWeight:600, color:T.text }}>{item.label}</span>
                    </div>
                    <span style={{ fontSize:22, fontWeight:800, color:T.text }}>{preview[item.key]||0}</span>
                  </div>
                </div>
              ))}
            </div>
            {totalItems === 0 ? (
              <div style={{ background:T.bg3, border:`1px solid ${T.border2}`, borderRadius:12, padding:16, textAlign:'center' }}>
                <p style={{ fontSize:13, fontWeight:500, color:T.text2, margin:0 }}>No assignments found for this user</p>
                <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>Nothing to transfer</p>
              </div>
            ) : (
              <button onClick={handleExecute} disabled={!toUser||executing} style={{ width:'100%', padding:'12px 0', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:(!toUser||executing)?0.6:1 }}>
                {executing && <span style={{ width:14, height:14, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
                {executing ? 'Transferring...' : `Transfer ${totalItems} Assignments to ${users.find(u=>String(u.id)===toUser)?.full_name||'selected user'}`}
              </button>
            )}
          </div>
        )}

        {result && (
          <div style={{ background:darkMode?'rgba(22,163,74,0.1)':'#f0fdf4', border:`1px solid ${darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'}`, borderRadius:16, padding:20 }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
              <div style={{ width:40, height:40, background:darkMode?'rgba(22,163,74,0.2)':'#dcfce7', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <div>
                <p style={{ fontSize:13, fontWeight:700, color:'#16a34a', margin:0 }}>Replacement Complete!</p>
                <p style={{ fontSize:12, color:darkMode?'#4ade80':'#15803d', marginTop:3 }}>All assignments transferred successfully</p>
              </div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10 }}>
              {PREVIEW_ITEMS.map(item => result.results[item.key] > 0 && (
                <div key={item.key} style={{ background:T.bg2, border:`1px solid ${darkMode?'rgba(22,163,74,0.2)':'#bbf7d0'}`, borderRadius:10, padding:'8px 12px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                  <span style={{ fontSize:12, color:T.text2 }}>{item.label}</span>
                  <span style={{ fontSize:13, fontWeight:700, color:'#16a34a' }}>{result.results[item.key]}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Settings;

// ── NOTIFICATION COMING SOON ──────────────────────────────────────────────────
function NotificationComingSoon({ title, desc, icon }) {
  return (
    <div>
      <div className="mb-5">
        <h3 className="text-base font-bold" style={{ color:'#0f1f45' }}>{title}</h3>
      </div>
      <div className="py-20 text-center bg-white rounded-2xl border border-gray-100 shadow-sm">
        <div className="text-5xl mb-4">{icon}</div>
        <h3 className="text-gray-700 font-semibold text-base">{title}</h3>
        <p className="text-gray-400 text-sm mt-2 max-w-sm mx-auto">{desc}</p>
        <span className="mt-4 inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs rounded-full font-medium border border-blue-100">Coming Soon</span>
      </div>
    </div>
  );
}

// ── COMPLIANCE CALENDAR SECTION ───────────────────────────────────────────────
const COMPLIANCE_CATEGORIES = ['GST','Income Tax','TDS','ROC/MCA','PF/ESI','Other'];

const DEFAULT_COMPLIANCES = [
  { name:'GSTR-1 Filing',          category:'GST',         frequency:'monthly',  due_day:11, description:'Monthly return for outward supplies' },
  { name:'GSTR-3B Filing',         category:'GST',         frequency:'monthly',  due_day:20, description:'Monthly summary return' },
  { name:'GSTR-9 Annual Return',   category:'GST',         frequency:'yearly',   due_month:12, due_day:31, description:'Annual GST return' },
  { name:'TDS Return Q1',          category:'TDS',         frequency:'quarterly',due_day:31, due_month:7,  description:'TDS return for Apr-Jun' },
  { name:'TDS Return Q2',          category:'TDS',         frequency:'quarterly',due_day:31, due_month:10, description:'TDS return for Jul-Sep' },
  { name:'TDS Return Q3',          category:'TDS',         frequency:'quarterly',due_day:31, due_month:1,  description:'TDS return for Oct-Dec' },
  { name:'TDS Return Q4',          category:'TDS',         frequency:'quarterly',due_day:31, due_month:5,  description:'TDS return for Jan-Mar' },
  { name:'Advance Tax Q1',         category:'Income Tax',  frequency:'quarterly',due_day:15, due_month:6,  description:'15% of annual tax liability' },
  { name:'Advance Tax Q2',         category:'Income Tax',  frequency:'quarterly',due_day:15, due_month:9,  description:'45% of annual tax liability' },
  { name:'Advance Tax Q3',         category:'Income Tax',  frequency:'quarterly',due_day:15, due_month:12, description:'75% of annual tax liability' },
  { name:'Advance Tax Q4',         category:'Income Tax',  frequency:'quarterly',due_day:15, due_month:3,  description:'100% of annual tax liability' },
  { name:'ITR Filing (Individual)',category:'Income Tax',  frequency:'yearly',   due_day:31, due_month:7,  description:'Income Tax Return for individuals' },
  { name:'ITR Filing (Audit)',     category:'Income Tax',  frequency:'yearly',   due_day:31, due_month:10, description:'ITR for audit cases' },
  { name:'PF Monthly Payment',     category:'PF/ESI',      frequency:'monthly',  due_day:15, description:'Monthly PF contribution' },
  { name:'ESI Monthly Payment',    category:'PF/ESI',      frequency:'monthly',  due_day:15, description:'Monthly ESI contribution' },
  { name:'ROC Annual Return',      category:'ROC/MCA',     frequency:'yearly',   due_day:29, due_month:11, description:'Annual filing for companies' },
];

function ComplianceCalendarSection({ token, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:10, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh      = { 'Content-Type': 'application/json', ...headers };
  const { showToast, showConfirm } = useToast();
  const [items,    setItems]    = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving,   setSaving]   = useState(false);
  const [filterCat,setFilterCat]= useState('all');
  const [form, setForm] = useState({
    name:'', category:'GST', frequency:'monthly', due_day:1,
    due_month:'', description:'', is_active:true
  });
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/compliance-calendar`, { headers });
      const d = await r.json();
      setItems(Array.isArray(d) ? d : []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleSeed = async () => {
    if (!await showConfirm('Load default compliance items? This will add standard GST, TDS, ITR and other due dates.')) return;
    setSaving(true);
    try {
      for (const item of DEFAULT_COMPLIANCES) {
        await fetch(`${BASE}/api/compliance-calendar`, {
          method:'POST', headers:jh, body:JSON.stringify(item)
        });
      }
      fetchAll();
    } catch(e) { showToast('Error loading defaults'); }
    finally { setSaving(false); }
  };

  const openAdd  = () => { setEditItem(null); setForm({ name:'', category:'GST', frequency:'monthly', due_day:1, due_month:'', description:'', is_active:true }); setShowForm(true); };
  const openEdit = (i) => { setEditItem(i); setForm({ name:i.name, category:i.category, frequency:i.frequency, due_day:i.due_day, due_month:i.due_month||'', description:i.description||'', is_active:i.is_active }); setShowForm(true); };

  const handleSave = async () => {
    if (!form.name.trim()) return showToast('Name required');
    setSaving(true);
    try {
      const url    = editItem ? `${BASE}/api/compliance-calendar/${editItem.id}` : `${BASE}/api/compliance-calendar`;
      const method = editItem ? 'PUT' : 'POST';
      const res    = await fetch(url, { method, headers:jh, body:JSON.stringify(form) });
      if (!res.ok) { const d=await res.json(); showToast(d.message||'Error'); return; }
      setShowForm(false); fetchAll();
    } catch(e) { showToast('Error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!await showConfirm('Delete this compliance item?')) return;
    await fetch(`${BASE}/api/compliance-calendar/${id}`, { method:'DELETE', headers });
    fetchAll();
  };

  const handleToggle = async (item) => {
    await fetch(`${BASE}/api/compliance-calendar/${item.id}`, {
      method:'PUT', headers:jh,
      body:JSON.stringify({ ...item, is_active:!item.is_active })
    });
    fetchAll();
  };

  const CAT_COLORS = {
    'GST':        { color:'#2563eb', bg:darkMode?'rgba(37,99,235,0.12)':'#eff6ff',   border:darkMode?'rgba(37,99,235,0.25)':'#bfdbfe'  },
    'Income Tax': { color:'#16a34a', bg:darkMode?'rgba(22,163,74,0.12)':'#f0fdf4',   border:darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'  },
    'TDS':        { color:'#d97706', bg:darkMode?'rgba(217,119,6,0.12)':'#fffbeb',   border:darkMode?'rgba(217,119,6,0.25)':'#fde68a'  },
    'ROC/MCA':    { color:'#7c3aed', bg:darkMode?'rgba(124,58,237,0.12)':'#f5f3ff',  border:darkMode?'rgba(124,58,237,0.25)':'#ddd6fe' },
    'PF/ESI':     { color:'#0d9488', bg:darkMode?'rgba(13,148,136,0.12)':'#f0fdfa',  border:darkMode?'rgba(13,148,136,0.25)':'#99f6e4' },
    'Other':      { color:'#64748b', bg:darkMode?'rgba(100,116,139,0.12)':'#f8fafc', border:darkMode?'rgba(100,116,139,0.25)':'#e2e8f0' },
  };

  const FREQ_COLORS = {
    'monthly':   { color:'#2563eb', bg:darkMode?'rgba(37,99,235,0.12)':'#dbeafe'   },
    'quarterly': { color:'#ea580c', bg:darkMode?'rgba(234,88,12,0.12)':'#fed7aa'   },
    'yearly':    { color:'#16a34a', bg:darkMode?'rgba(22,163,74,0.12)':'#bbf7d0'   },
  };

  const filtered = filterCat === 'all' ? items : items.filter(i => i.category === filterCat);

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <h3 style={{ fontSize:15, fontWeight:700, color:T.text, margin:0 }}>Compliance Calendar</h3>
          <p style={{ fontSize:12, color:T.text3, marginTop:4 }}>{items.length} compliance due dates configured</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {items.length === 0 && (
            <button onClick={handleSeed} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 14px', borderRadius:9, fontSize:13, fontWeight:500, cursor:'pointer', border:`1px solid ${darkMode?'rgba(37,99,235,0.3)':'#bfdbfe'}`, background:darkMode?'rgba(37,99,235,0.1)':'#eff6ff', color:'#2563eb' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
              Load Defaults
            </button>
          )}
          <button onClick={openAdd} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Compliance
          </button>
        </div>
      </div>

      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {['all', ...COMPLIANCE_CATEGORIES].map(c => (
          <button key={c} onClick={() => setFilterCat(c)} style={{
            padding:'6px 14px', borderRadius:20, fontSize:12, fontWeight:600, cursor:'pointer', transition:'all 0.15s',
            background: filterCat===c?(darkMode?'rgba(59,130,246,0.15)':'#eff6ff'):'transparent',
            color: filterCat===c?'#3b82f6':T.text3,
            border: filterCat===c?`1.5px solid ${darkMode?'rgba(59,130,246,0.3)':'#bfdbfe'}`:`1.5px solid ${T.border2}`,
          }}>
            {c==='all'?`All (${items.length})`:`${c} (${items.filter(i=>i.category===c).length})`}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ padding:'40px 0', textAlign:'center', color:T.text3, fontSize:13 }}>Loading...</div>
      ) : items.length === 0 ? (
        <div style={{ padding:'64px 0', textAlign:'center', background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:16 }}>
          <div style={{ fontSize:48, marginBottom:16 }}>📅</div>
          <p style={{ fontSize:14, fontWeight:600, color:T.text, margin:0 }}>No compliance items yet</p>
          <p style={{ fontSize:12, color:T.text3, marginTop:6, marginBottom:20 }}>Add GST, TDS, ITR and other statutory due dates</p>
          <button onClick={handleSeed} disabled={saving} style={{ padding:'9px 22px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', opacity:saving?0.6:1 }}>
            Load Default Compliance Calendar
          </button>
        </div>
      ) : (
        <div style={{ background:T.bg2, borderRadius:14, border:`1px solid ${T.cardBorder}`, overflow:'hidden', boxShadow:darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
              <tr>
                {['Compliance','Category','Frequency','Due Date','Status','Actions'].map(h => (
                  <th key={h} style={{ padding:'10px 20px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em', whiteSpace:'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((item, i) => {
                const cc = CAT_COLORS[item.category] || CAT_COLORS['Other'];
                const fc = FREQ_COLORS[item.frequency] || { color:T.text3, bg:T.bg3 };
                return (
                  <tr key={item.id} style={{ borderBottom:`1px solid ${T.border}`, background:darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff'), opacity:item.is_active?1:0.5, transition:'background 0.15s' }}
                    onMouseEnter={e=>e.currentTarget.style.background=darkMode?'#1e3a5f':'#f0f4ff'}
                    onMouseLeave={e=>e.currentTarget.style.background=darkMode?(i%2===0?T.bg2:T.bg3):(i%2===0?'#fff':'#fafbff')}>
                    <td style={{ padding:'12px 20px' }}>
                      <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{item.name}</p>
                      {item.description && <p style={{ fontSize:11, color:T.text3, marginTop:3 }}>{item.description}</p>}
                    </td>
                    <td style={{ padding:'12px 20px' }}>
                      <span style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, color:cc.color, background:cc.bg, border:`1px solid ${cc.border}` }}>{item.category}</span>
                    </td>
                    <td style={{ padding:'12px 20px' }}>
                      <span style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, color:fc.color, background:fc.bg, textTransform:'capitalize' }}>{item.frequency}</span>
                    </td>
                    <td style={{ padding:'12px 20px', fontSize:13, color:T.text2, whiteSpace:'nowrap' }}>
                      {item.frequency==='monthly' && `${item.due_day}th of every month`}
                      {item.frequency==='quarterly' && `${item.due_day} ${MONTHS[(item.due_month-1)%12]||''}`}
                      {item.frequency==='yearly' && `${item.due_day} ${MONTHS[(item.due_month-1)%12]||''}`}
                    </td>
                    <td style={{ padding:'12px 20px' }}>
                      <button onClick={()=>handleToggle(item)} style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20, cursor:'pointer', border:'1px solid',
                        color:item.is_active?'#16a34a':T.text3,
                        background:item.is_active?(darkMode?'rgba(22,163,74,0.12)':'#f0fdf4'):(darkMode?T.bg3:'#f8fafc'),
                        borderColor:item.is_active?(darkMode?'rgba(22,163,74,0.25)':'#bbf7d0'):(darkMode?T.border:T.border2) }}>
                        {item.is_active ? 'Active' : 'Inactive'}
                      </button>
                    </td>
                    <td style={{ padding:'12px 20px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                        <button onClick={()=>openEdit(item)}
                          style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                          onMouseEnter={e=>{e.currentTarget.style.background=T.bg3;e.currentTarget.style.color=T.text2;}}
                          onMouseLeave={e=>{e.currentTarget.style.background='none';e.currentTarget.style.color=T.text3;}}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                        </button>
                        <button onClick={()=>handleDelete(item.id)}
                          style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', color:'#ef4444', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                          onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                          onMouseLeave={e=>e.currentTarget.style.background='none'}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:50, padding:16 }}>
          <div style={{ background:T.bg2, borderRadius:20, width:'100%', maxWidth:500, boxShadow:darkMode?'0 24px 60px rgba(0,0,0,0.6)':'0 24px 60px rgba(15,31,69,0.2)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 28px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', borderRadius:'20px 20px 0 0' }}>
              <div>
                <h3 style={{ fontSize:15, fontWeight:700, color:'#fff', margin:0 }}>{editItem?'Edit':'Add'} Compliance</h3>
                <p style={{ fontSize:12, color:'rgba(255,255,255,0.6)', margin:'3px 0 0' }}>Set statutory due date reminder</p>
              </div>
              <button onClick={()=>setShowForm(false)} style={{ width:30, height:30, borderRadius:8, border:'none', background:'rgba(255,255,255,0.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding:'20px 28px', background:T.bg3, display:'flex', flexDirection:'column', gap:16 }}>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Name *</label>
                <input type="text" placeholder="e.g. GSTR-3B Filing" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} style={is} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Category</label>
                  <select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={is}>
                    {COMPLIANCE_CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Frequency</label>
                  <select value={form.frequency} onChange={e=>setForm(f=>({...f,frequency:e.target.value}))} style={is}>
                    <option value="monthly">Monthly</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Due Day (of month)</label>
                  <input type="number" min={1} max={31} value={form.due_day} onChange={e=>setForm(f=>({...f,due_day:Number(e.target.value)}))} style={is} />
                </div>
                {(form.frequency==='quarterly'||form.frequency==='yearly') && (
                  <div>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Due Month</label>
                    <select value={form.due_month} onChange={e=>setForm(f=>({...f,due_month:Number(e.target.value)}))} style={is}>
                      <option value="">Select...</option>
                      {MONTHS.map((m,idx)=><option key={idx+1} value={idx+1}>{m}</option>)}
                    </select>
                  </div>
                )}
              </div>
              <div>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>Description</label>
                <input type="text" placeholder="Brief description..." value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} style={is} />
              </div>
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:12, padding:'14px 28px', borderTop:`1px solid ${T.border}`, background:T.bg2, borderRadius:'0 0 20px 20px' }}>
              <button onClick={()=>setShowForm(false)} style={{ padding:'9px 20px', borderRadius:10, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, cursor:'pointer' }}>Cancel</button>
              <button onClick={handleSave} disabled={saving} style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 24px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', opacity:saving?0.6:1 }}>
                {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── DIGITAL SIGNATURE SECTION ─────────────────────────────────────────────────
function DigitalSignatureSection({ token }) {
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh      = { 'Content-Type': 'application/json', ...headers };
  const { showToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [form, setForm] = useState({
    signature_name: '',
    signature_designation: '',
    signature_image_url: '',
    stamp_image_url: '',
    show_signature_on_invoice: true,
    show_signature_on_receipt: true,
    show_signature_on_quotation: true,
    show_stamp: false,
  });
  const ic = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-blue-400 bg-white";

  const fetchProfile = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/api/firm-profile`, { headers });
      const d = await r.json();
      setForm(f => ({
        ...f,
        signature_name:        d.signature_name || '',
        signature_designation: d.signature_designation || '',
        signature_image_url:   d.logo_url || '',
      }));
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchProfile(); }, [fetchProfile]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${BASE}/api/firm-profile`, {
        method:'PUT', headers:jh,
        body:JSON.stringify({
          signature_name:        form.signature_name,
          signature_designation: form.signature_designation,
        })
      });
      if (!res.ok) { showToast('Error saving'); return; }
      setSaved(true); setTimeout(() => setSaved(false), 3000);
    } catch(e) { showToast('Error'); }
    finally { setSaving(false); }
  };

  const handleImageUpload = (field, e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2*1024*1024) return showToast('Image must be under 2MB');
    const reader = new FileReader();
    reader.onload = ev => setForm(f => ({ ...f, [field]: ev.target.result }));
    reader.readAsDataURL(file);
  };

  if (loading) return <div className="py-10 text-center text-gray-400 text-sm">Loading...</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base font-bold" style={{ color:'#0f1f45' }}>Digital Signature</h3>
          <p className="text-xs text-gray-400 mt-0.5">Signatory details shown on invoices, receipts and quotations</p>
        </div>
        <div className="flex items-center gap-3">
          {saved && (
            <span className="flex items-center gap-1.5 text-sm text-green-600 font-medium">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              Saved
            </span>
          )}
          <button onClick={handleSave} disabled={saving}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-50"
            style={{ background:'#0f1f45' }}>
            {saving && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"/>}
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div className="space-y-5">
        {/* Signatory details */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
          <h4 className="text-sm font-bold text-gray-700 mb-4">Authorised Signatory Details</h4>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1.5">Full Name</label>
              <input type="text" placeholder="CA Shivam Singh" value={form.signature_name}
                onChange={e=>setForm(f=>({...f,signature_name:e.target.value}))} className={ic} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1.5">Designation</label>
              <input type="text" placeholder="Proprietor / Partner" value={form.signature_designation}
                onChange={e=>setForm(f=>({...f,signature_designation:e.target.value}))} className={ic} />
            </div>
          </div>
        </div>

        {/* Signature image */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
          <h4 className="text-sm font-bold text-gray-700 mb-1">Signature Image</h4>
          <p className="text-xs text-gray-400 mb-4">Upload a PNG/JPG of your signature (transparent background recommended)</p>
          <div className="flex items-start gap-6">
            <div className="flex-1">
              <label className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl cursor-pointer transition ${form.signature_image_url?'border-blue-300 bg-blue-50':'border-gray-200 hover:border-blue-300 hover:bg-blue-50'}`}>
                <input type="file" accept="image/*" className="hidden" onChange={e=>handleImageUpload('signature_image_url',e)} />
                {form.signature_image_url ? (
                  <img src={form.signature_image_url} alt="Signature" className="max-h-24 object-contain" />
                ) : (
                  <div className="text-center">
                    <svg className="w-8 h-8 text-gray-300 mx-auto mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                    <p className="text-sm text-gray-400">Click to upload signature</p>
                    <p className="text-xs text-gray-300 mt-1">PNG or JPG · Max 2MB</p>
                  </div>
                )}
              </label>
              {form.signature_image_url && (
                <button onClick={()=>setForm(f=>({...f,signature_image_url:''}))}
                  className="mt-2 text-xs text-red-400 hover:text-red-600">Remove</button>
              )}
            </div>

            <div className="flex-1">
              <label className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl cursor-pointer transition ${form.stamp_image_url?'border-blue-300 bg-blue-50':'border-gray-200 hover:border-blue-300 hover:bg-blue-50'}`}>
                <input type="file" accept="image/*" className="hidden" onChange={e=>handleImageUpload('stamp_image_url',e)} />
                {form.stamp_image_url ? (
                  <img src={form.stamp_image_url} alt="Stamp" className="max-h-24 object-contain" />
                ) : (
                  <div className="text-center">
                    <svg className="w-8 h-8 text-gray-300 mx-auto mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
                    <p className="text-sm text-gray-400">Click to upload stamp</p>
                    <p className="text-xs text-gray-300 mt-1">Optional · PNG recommended</p>
                  </div>
                )}
              </label>
              {form.stamp_image_url && (
                <button onClick={()=>setForm(f=>({...f,stamp_image_url:''}))}
                  className="mt-2 text-xs text-red-400 hover:text-red-600">Remove</button>
              )}
            </div>
          </div>
        </div>

        {/* Show on documents */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
          <h4 className="text-sm font-bold text-gray-700 mb-4">Show Signature On</h4>
          <div className="grid grid-cols-2 gap-3">
            {[
              { key:'show_signature_on_invoice',   label:'Invoices',    icon:'📄' },
              { key:'show_signature_on_receipt',   label:'Receipts',    icon:'🧾' },
              { key:'show_signature_on_quotation', label:'Quotations',  icon:'📋' },
              { key:'show_stamp',                  label:'Show Stamp',  icon:'🔵' },
            ].map(item => (
              <div key={item.key} className={`flex items-center gap-3 p-4 rounded-xl border-2 transition cursor-pointer ${form[item.key]?'border-blue-400 bg-blue-50':'border-gray-100 bg-gray-50'}`}
                onClick={()=>setForm(f=>({...f,[item.key]:!f[item.key]}))}>
                <span className="text-xl">{item.icon}</span>
                <span className="text-sm font-medium text-gray-700">{item.label}</span>
                <div className={`ml-auto w-5 h-5 rounded-full border-2 flex items-center justify-center ${form[item.key]?'bg-blue-500 border-blue-500':'border-gray-300'}`}>
                  {form[item.key] && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Preview */}
        {(form.signature_name || form.signature_image_url) && (
          <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
            <h4 className="text-sm font-bold text-gray-700 mb-4">Preview</h4>
            <div className="border border-gray-200 rounded-xl p-6 bg-gray-50 inline-block min-w-48 text-center">
              {form.signature_image_url && (
                <img src={form.signature_image_url} alt="Signature" className="h-12 object-contain mx-auto mb-2" />
              )}
              {!form.signature_image_url && (
                <div className="h-8 border-b border-gray-400 mb-2 mx-8"/>
              )}
              <p className="text-sm font-bold text-gray-800">{form.signature_name || 'Signatory Name'}</p>
              <p className="text-xs text-gray-500">{form.signature_designation || 'Designation'}</p>
              {form.stamp_image_url && form.show_stamp && (
                <img src={form.stamp_image_url} alt="Stamp" className="h-10 object-contain mx-auto mt-2" />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── BRANDING SECTION ──────────────────────────────────────────────────────────
function BrandingSection({ token }) {
  const headers = { 'Authorization': `Bearer ${token}` };
  const jh      = { 'Content-Type': 'application/json', ...headers };
  const { showToast } = useToast();
  const [saving, setSaving] = useState(false);
  const [saved,  setSaved]  = useState(false);
  const [form, setForm] = useState({
    primary_color:    '#0f1f45',
    secondary_color:  '#c8a951',
    accent_color:     '#3b82f6',
    invoice_font:     'Plus Jakarta Sans',
    template_style:   'classic',
    show_logo:        true,
    show_watermark:   false,
    watermark_text:   'ORIGINAL',
  });
  const ic = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-blue-400 bg-white";

  const PRESET_COLORS = [
    { name:'Navy Blue',  color:'#0f1f45' },
    { name:'Royal Blue', color:'#1e40af' },
    { name:'Forest',     color:'#166534' },
    { name:'Maroon',     color:'#7f1d1d' },
    { name:'Purple',     color:'#4c1d95' },
    { name:'Teal',       color:'#134e4a' },
    { name:'Dark Gray',  color:'#1f2937' },
    { name:'Charcoal',   color:'#374151' },
  ];

  const FONTS = ['Plus Jakarta Sans','Arial','Helvetica','Times New Roman','Georgia','Verdana','Calibri','Roboto'];

  const TEMPLATES = [
    { id:'classic', label:'Classic',  desc:'Traditional professional layout' },
    { id:'modern',  label:'Modern',   desc:'Clean minimal design' },
    { id:'minimal', label:'Minimal',  desc:'Simple and elegant' },
  ];

  const handleSave = async () => {
    setSaving(true);
    try {
      // Save to invoice settings
      await fetch(`${BASE}/api/invoices/settings/config`, {
        method:'PUT', headers:jh,
        body:JSON.stringify({
          primary_color:  form.primary_color,
          invoice_font:   form.invoice_font,
          template_style: form.template_style,
          show_watermark: form.show_watermark,
          watermark_text: form.watermark_text,
        })
      });
      setSaved(true); setTimeout(() => setSaved(false), 3000);
    } catch(e) { showToast('Error saving'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base font-bold" style={{ color:'#0f1f45' }}>Branding</h3>
          <p className="text-xs text-gray-400 mt-0.5">Customise colours and document appearance</p>
        </div>
        <div className="flex items-center gap-3">
          {saved && (
            <span className="flex items-center gap-1.5 text-sm text-green-600 font-medium">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              Saved
            </span>
          )}
          <button onClick={handleSave} disabled={saving}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-50"
            style={{ background:'#0f1f45' }}>
            {saving && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"/>}
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div className="space-y-5">
        {/* Primary color */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
          <h4 className="text-sm font-bold text-gray-700 mb-4">Brand Colours</h4>
          <div className="mb-4">
            <label className="block text-xs font-medium text-gray-500 mb-3">Primary Colour (used in invoice headers)</label>
            <div className="flex items-center gap-3 flex-wrap mb-3">
              {PRESET_COLORS.map(c => (
                <button key={c.color} onClick={()=>setForm(f=>({...f,primary_color:c.color}))}
                  title={c.name}
                  className={`w-10 h-10 rounded-xl transition-all ${form.primary_color===c.color?'ring-2 ring-offset-2 ring-blue-500 scale-110':''}`}
                  style={{ background:c.color }}/>
              ))}
              <div className="flex items-center gap-2 ml-2">
                <input type="color" value={form.primary_color}
                  onChange={e=>setForm(f=>({...f,primary_color:e.target.value}))}
                  className="w-10 h-10 rounded-lg cursor-pointer border border-gray-200 p-0.5" />
                <span className="text-xs text-gray-400">Custom</span>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-3">
              <div className="w-10 h-10 rounded-xl flex-shrink-0" style={{ background:form.primary_color }}/>
              <div>
                <p className="text-sm font-semibold text-gray-800">Selected: <span className="font-mono">{form.primary_color}</span></p>
                <p className="text-xs text-gray-400">Used in invoice/receipt headers and accents</p>
              </div>
            </div>
          </div>
        </div>

        {/* Document template */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
          <h4 className="text-sm font-bold text-gray-700 mb-4">Document Template Style</h4>
          <div className="grid grid-cols-3 gap-3 mb-4">
            {TEMPLATES.map(t => (
              <button key={t.id} onClick={()=>setForm(f=>({...f,template_style:t.id}))}
                className={`p-4 rounded-xl border-2 text-left transition ${form.template_style===t.id?'border-blue-500 bg-blue-50':'border-gray-200 hover:border-gray-300'}`}>
                <div className="w-full h-16 rounded-lg mb-3 overflow-hidden border border-gray-200">
                  <div className="h-4 w-full" style={{ background:form.primary_color }}/>
                  <div className="p-1.5 space-y-1">
                    <div className="h-1.5 bg-gray-200 rounded w-3/4"/>
                    <div className="h-1.5 bg-gray-100 rounded w-1/2"/>
                  </div>
                </div>
                <p className="text-sm font-semibold text-gray-700">{t.label}</p>
                <p className="text-xs text-gray-400 mt-0.5">{t.desc}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Font */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
          <h4 className="text-sm font-bold text-gray-700 mb-4">Document Font</h4>
          <div className="grid grid-cols-4 gap-3">
            {FONTS.map(f => (
              <button key={f} onClick={()=>setForm(ff=>({...ff,invoice_font:f}))}
                className={`py-3 px-4 rounded-xl border-2 text-sm transition ${form.invoice_font===f?'border-blue-500 bg-blue-50 text-blue-700 font-semibold':'border-gray-200 text-gray-600 hover:border-gray-300'}`}
                style={{ fontFamily:f }}>
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* Watermark */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6">
          <h4 className="text-sm font-bold text-gray-700 mb-4">Document Watermark</h4>
          <div className="flex items-center gap-4 mb-4">
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" checked={form.show_watermark}
                onChange={e=>setForm(f=>({...f,show_watermark:e.target.checked}))} className="sr-only peer" />
              <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <span className="text-sm text-gray-600">Show watermark on documents</span>
          </div>
          {form.show_watermark && (
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1.5">Watermark Text</label>
              <div className="flex gap-3">
                {['ORIGINAL','DUPLICATE','COPY'].map(w=>(
                  <button key={w} onClick={()=>setForm(f=>({...f,watermark_text:w}))}
                    className={`px-4 py-2 rounded-xl border text-sm font-medium transition ${form.watermark_text===w?'border-blue-400 bg-blue-50 text-blue-700':'border-gray-200 text-gray-500 hover:border-gray-300'}`}>
                    {w}
                  </button>
                ))}
                <input type="text" placeholder="Custom..." value={form.watermark_text}
                  onChange={e=>setForm(f=>({...f,watermark_text:e.target.value}))}
                  className="flex-1 border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-blue-400" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}